export const LESS_THAN_60_MONTHS = {
    "male": {
        "height": [
            {
                "name": 0,
                "month": 0,
                "m": 49.9,
                "2sd": 53.7,
                "-2sd": 46.1
            },
            {
                "name": 1,
                "month": 1,
                "m": 54.7,
                "2sd": 58.6,
                "-2sd": 50.8
            },
            {
                "name": 2,
                "month": 2,
                "m": 58.4,
                "2sd": 62.4,
                "-2sd": 54.4
            },
            {
                "name": 3,
                "month": 3,
                "m": 61.4,
                "2sd": 65.5,
                "-2sd": 57.3
            },
            {
                "name": 4,
                "month": 4,
                "m": 63.9,
                "2sd": 68,
                "-2sd": 59.7
            },
            {
                "name": 5,
                "month": 5,
                "m": 65.9,
                "2sd": 70.1,
                "-2sd": 61.7
            },
            {
                "name": 6,
                "month": 6,
                "m": 67.6,
                "2sd": 71.9,
                "-2sd": 63.3
            },
            {
                "name": 7,
                "month": 7,
                "m": 69.2,
                "2sd": 73.5,
                "-2sd": 64.8
            },
            {
                "name": 8,
                "month": 8,
                "m": 70.6,
                "2sd": 75,
                "-2sd": 66.2
            },
            {
                "name": 9,
                "month": 9,
                "m": 72,
                "2sd": 76.5,
                "-2sd": 67.5
            },
            {
                "name": 10,
                "month": 10,
                "m": 73.3,
                "2sd": 77.9,
                "-2sd": 68.7
            },
            {
                "name": 11,
                "month": 11,
                "m": 74.5,
                "2sd": 79.2,
                "-2sd": 69.9
            },
            {
                "name": 12,
                "month": 12,
                "m": 75.7,
                "2sd": 80.5,
                "-2sd": 71
            },
            {
                "name": 13,
                "month": 13,
                "m": 76.9,
                "2sd": 81.8,
                "-2sd": 72.1
            },
            {
                "name": 14,
                "month": 14,
                "m": 78,
                "2sd": 83,
                "-2sd": 73.1
            },
            {
                "name": 15,
                "month": 15,
                "m": 79.1,
                "2sd": 84.2,
                "-2sd": 74.1
            },
            {
                "name": 16,
                "month": 16,
                "m": 80.2,
                "2sd": 85.4,
                "-2sd": 75
            },
            {
                "name": 17,
                "month": 17,
                "m": 81.2,
                "2sd": 86.5,
                "-2sd": 76
            },
            {
                "name": 18,
                "month": 18,
                "m": 82.3,
                "2sd": 87.7,
                "-2sd": 76.9
            },
            {
                "name": 19,
                "month": 19,
                "m": 83.2,
                "2sd": 88.8,
                "-2sd": 77.7
            },
            {
                "name": 20,
                "month": 20,
                "m": 84.2,
                "2sd": 89.8,
                "-2sd": 78.6
            },
            {
                "name": 21,
                "month": 21,
                "m": 85.1,
                "2sd": 90.9,
                "-2sd": 79.4
            },
            {
                "name": 22,
                "month": 22,
                "m": 86,
                "2sd": 91.9,
                "-2sd": 80.2
            },
            {
                "name": 23,
                "month": 23,
                "m": 86.9,
                "2sd": 92.9,
                "-2sd": 81
            },
            {
                "name": 24,
                "month": 24,
                "m": 87.8,
                "2sd": 93.9,
                "-2sd": 81.7
            },
            {
                "name": 25,
                "month": 25,
                "m": 88,
                "2sd": 94.2,
                "-2sd": 81.7
            },
            {
                "name": 26,
                "month": 26,
                "m": 88.8,
                "2sd": 95.2,
                "-2sd": 82.5
            },
            {
                "name": 27,
                "month": 27,
                "m": 89.6,
                "2sd": 96.1,
                "-2sd": 83.1
            },
            {
                "name": 28,
                "month": 28,
                "m": 90.4,
                "2sd": 97,
                "-2sd": 83.8
            },
            {
                "name": 29,
                "month": 29,
                "m": 91.2,
                "2sd": 97.9,
                "-2sd": 84.5
            },
            {
                "name": 30,
                "month": 30,
                "m": 91.9,
                "2sd": 98.7,
                "-2sd": 85.1
            },
            {
                "name": 31,
                "month": 31,
                "m": 92.7,
                "2sd": 99.6,
                "-2sd": 85.7
            },
            {
                "name": 32,
                "month": 32,
                "m": 93.4,
                "2sd": 100.4,
                "-2sd": 86.4
            },
            {
                "name": 33,
                "month": 33,
                "m": 94.1,
                "2sd": 101.2,
                "-2sd": 86.9
            },
            {
                "name": 34,
                "month": 34,
                "m": 94.8,
                "2sd": 102,
                "-2sd": 87.5
            },
            {
                "name": 35,
                "month": 35,
                "m": 95.4,
                "2sd": 102.7,
                "-2sd": 88.1
            },
            {
                "name": 36,
                "month": 36,
                "m": 96.1,
                "2sd": 103.5,
                "-2sd": 88.7
            },
            {
                "name": 37,
                "month": 37,
                "m": 96.7,
                "2sd": 104.2,
                "-2sd": 89.2
            },
            {
                "name": 38,
                "month": 38,
                "m": 97.4,
                "2sd": 105,
                "-2sd": 89.8
            },
            {
                "name": 39,
                "month": 39,
                "m": 98,
                "2sd": 105.7,
                "-2sd": 90.3
            },
            {
                "name": 40,
                "month": 40,
                "m": 98.6,
                "2sd": 106.4,
                "-2sd": 90.9
            },
            {
                "name": 41,
                "month": 41,
                "m": 99.2,
                "2sd": 107.1,
                "-2sd": 91.4
            },
            {
                "name": 42,
                "month": 42,
                "m": 99.9,
                "2sd": 107.8,
                "-2sd": 91.9
            },
            {
                "name": 43,
                "month": 43,
                "m": 100.4,
                "2sd": 108.5,
                "-2sd": 92.4
            },
            {
                "name": 44,
                "month": 44,
                "m": 101,
                "2sd": 109.1,
                "-2sd": 93
            },
            {
                "name": 45,
                "month": 45,
                "m": 101.6,
                "2sd": 109.8,
                "-2sd": 93.5
            },
            {
                "name": 46,
                "month": 46,
                "m": 102.2,
                "2sd": 110.4,
                "-2sd": 94
            },
            {
                "name": 47,
                "month": 47,
                "m": 102.8,
                "2sd": 111.1,
                "-2sd": 94.4
            },
            {
                "name": 48,
                "month": 48,
                "m": 103.3,
                "2sd": 111.7,
                "-2sd": 94.9
            },
            {
                "name": 49,
                "month": 49,
                "m": 103.9,
                "2sd": 112.4,
                "-2sd": 95.4
            },
            {
                "name": 50,
                "month": 50,
                "m": 104.4,
                "2sd": 113,
                "-2sd": 95.9
            },
            {
                "name": 51,
                "month": 51,
                "m": 105,
                "2sd": 113.6,
                "-2sd": 96.4
            },
            {
                "name": 52,
                "month": 52,
                "m": 105.6,
                "2sd": 114.2,
                "-2sd": 96.9
            },
            {
                "name": 53,
                "month": 53,
                "m": 106.1,
                "2sd": 114.9,
                "-2sd": 97.4
            },
            {
                "name": 54,
                "month": 54,
                "m": 106.7,
                "2sd": 115.5,
                "-2sd": 97.8
            },
            {
                "name": 55,
                "month": 55,
                "m": 107.2,
                "2sd": 116.1,
                "-2sd": 98.3
            },
            {
                "name": 56,
                "month": 56,
                "m": 107.8,
                "2sd": 116.7,
                "-2sd": 98.8
            },
            {
                "name": 57,
                "month": 57,
                "m": 108.3,
                "2sd": 117.4,
                "-2sd": 99.3
            },
            {
                "name": 58,
                "month": 58,
                "m": 108.9,
                "2sd": 118,
                "-2sd": 99.7
            },
            {
                "name": 59,
                "month": 59,
                "m": 109.4,
                "2sd": 118.6,
                "-2sd": 100.2
            },
            {
                "name": 60,
                "month": 60,
                "m": 110,
                "2sd": 119.2,
                "-2sd": 100.7
            }
        ],
        "weight": [
            {
                "name": 0,
                "month": 0,
                "m": 3.3,
                "2sd": 4.4,
                "-2sd": 2.5
            },
            {
                "name": 1,
                "month": 1,
                "m": 4.5,
                "2sd": 5.8,
                "-2sd": 3.4
            },
            {
                "name": 2,
                "month": 2,
                "m": 5.6,
                "2sd": 7.1,
                "-2sd": 4.3
            },
            {
                "name": 3,
                "month": 3,
                "m": 6.4,
                "2sd": 8,
                "-2sd": 5
            },
            {
                "name": 4,
                "month": 4,
                "m": 7,
                "2sd": 8.7,
                "-2sd": 5.6
            },
            {
                "name": 5,
                "month": 5,
                "m": 7.5,
                "2sd": 9.3,
                "-2sd": 6
            },
            {
                "name": 6,
                "month": 6,
                "m": 7.9,
                "2sd": 9.8,
                "-2sd": 6.4
            },
            {
                "name": 7,
                "month": 7,
                "m": 8.3,
                "2sd": 10.3,
                "-2sd": 6.7
            },
            {
                "name": 8,
                "month": 8,
                "m": 8.6,
                "2sd": 10.7,
                "-2sd": 6.9
            },
            {
                "name": 9,
                "month": 9,
                "m": 8.9,
                "2sd": 11,
                "-2sd": 7.1
            },
            {
                "name": 10,
                "month": 10,
                "m": 9.2,
                "2sd": 11.4,
                "-2sd": 7.4
            },
            {
                "name": 11,
                "month": 11,
                "m": 9.4,
                "2sd": 11.7,
                "-2sd": 7.6
            },
            {
                "name": 12,
                "month": 12,
                "m": 9.6,
                "2sd": 12,
                "-2sd": 7.7
            },
            {
                "name": 13,
                "month": 13,
                "m": 9.9,
                "2sd": 12.3,
                "-2sd": 7.9
            },
            {
                "name": 14,
                "month": 14,
                "m": 10.1,
                "2sd": 12.6,
                "-2sd": 8.1
            },
            {
                "name": 15,
                "month": 15,
                "m": 10.3,
                "2sd": 12.8,
                "-2sd": 8.3
            },
            {
                "name": 16,
                "month": 16,
                "m": 10.5,
                "2sd": 13.1,
                "-2sd": 8.4
            },
            {
                "name": 17,
                "month": 17,
                "m": 10.7,
                "2sd": 13.4,
                "-2sd": 8.6
            },
            {
                "name": 18,
                "month": 18,
                "m": 10.9,
                "2sd": 13.7,
                "-2sd": 8.8
            },
            {
                "name": 19,
                "month": 19,
                "m": 11.1,
                "2sd": 13.9,
                "-2sd": 8.9
            },
            {
                "name": 20,
                "month": 20,
                "m": 11.3,
                "2sd": 14.2,
                "-2sd": 9.1
            },
            {
                "name": 21,
                "month": 21,
                "m": 11.5,
                "2sd": 14.5,
                "-2sd": 9.2
            },
            {
                "name": 22,
                "month": 22,
                "m": 11.8,
                "2sd": 14.7,
                "-2sd": 9.4
            },
            {
                "name": 23,
                "month": 23,
                "m": 12,
                "2sd": 15,
                "-2sd": 9.5
            },
            {
                "name": 24,
                "month": 24,
                "m": 12.2,
                "2sd": 15.3,
                "-2sd": 9.7
            },
            {
                "name": 25,
                "month": 25,
                "m": 12.4,
                "2sd": 15.5,
                "-2sd": 9.8
            },
            {
                "name": 26,
                "month": 26,
                "m": 12.5,
                "2sd": 15.8,
                "-2sd": 10
            },
            {
                "name": 27,
                "month": 27,
                "m": 12.7,
                "2sd": 16.1,
                "-2sd": 10.1
            },
            {
                "name": 28,
                "month": 28,
                "m": 12.9,
                "2sd": 16.3,
                "-2sd": 10.2
            },
            {
                "name": 29,
                "month": 29,
                "m": 13.1,
                "2sd": 16.6,
                "-2sd": 10.4
            },
            {
                "name": 30,
                "month": 30,
                "m": 13.3,
                "2sd": 16.9,
                "-2sd": 10.5
            },
            {
                "name": 31,
                "month": 31,
                "m": 13.5,
                "2sd": 17.1,
                "-2sd": 10.7
            },
            {
                "name": 32,
                "month": 32,
                "m": 13.7,
                "2sd": 17.4,
                "-2sd": 10.8
            },
            {
                "name": 33,
                "month": 33,
                "m": 13.8,
                "2sd": 17.6,
                "-2sd": 10.9
            },
            {
                "name": 34,
                "month": 34,
                "m": 14,
                "2sd": 17.8,
                "-2sd": 11
            },
            {
                "name": 35,
                "month": 35,
                "m": 14.2,
                "2sd": 18.1,
                "-2sd": 11.2
            },
            {
                "name": 36,
                "month": 36,
                "m": 14.3,
                "2sd": 18.3,
                "-2sd": 11.3
            },
            {
                "name": 37,
                "month": 37,
                "m": 14.5,
                "2sd": 18.6,
                "-2sd": 11.4
            },
            {
                "name": 38,
                "month": 38,
                "m": 14.7,
                "2sd": 18.8,
                "-2sd": 11.5
            },
            {
                "name": 39,
                "month": 39,
                "m": 14.8,
                "2sd": 19,
                "-2sd": 11.6
            },
            {
                "name": 40,
                "month": 40,
                "m": 15,
                "2sd": 19.3,
                "-2sd": 11.8
            },
            {
                "name": 41,
                "month": 41,
                "m": 15.2,
                "2sd": 19.5,
                "-2sd": 11.9
            },
            {
                "name": 42,
                "month": 42,
                "m": 15.3,
                "2sd": 19.7,
                "-2sd": 12
            },
            {
                "name": 43,
                "month": 43,
                "m": 15.5,
                "2sd": 20,
                "-2sd": 12.1
            },
            {
                "name": 44,
                "month": 44,
                "m": 15.7,
                "2sd": 20.2,
                "-2sd": 12.2
            },
            {
                "name": 45,
                "month": 45,
                "m": 15.8,
                "2sd": 20.5,
                "-2sd": 12.4
            },
            {
                "name": 46,
                "month": 46,
                "m": 16,
                "2sd": 20.7,
                "-2sd": 12.5
            },
            {
                "name": 47,
                "month": 47,
                "m": 16.2,
                "2sd": 20.9,
                "-2sd": 12.6
            },
            {
                "name": 48,
                "month": 48,
                "m": 16.3,
                "2sd": 21.2,
                "-2sd": 12.7
            },
            {
                "name": 49,
                "month": 49,
                "m": 16.5,
                "2sd": 21.4,
                "-2sd": 12.8
            },
            {
                "name": 50,
                "month": 50,
                "m": 16.7,
                "2sd": 21.7,
                "-2sd": 12.9
            },
            {
                "name": 51,
                "month": 51,
                "m": 16.8,
                "2sd": 21.9,
                "-2sd": 13.1
            },
            {
                "name": 52,
                "month": 52,
                "m": 17,
                "2sd": 22.2,
                "-2sd": 13.2
            },
            {
                "name": 53,
                "month": 53,
                "m": 17.2,
                "2sd": 22.4,
                "-2sd": 13.3
            },
            {
                "name": 54,
                "month": 54,
                "m": 17.3,
                "2sd": 22.7,
                "-2sd": 13.4
            },
            {
                "name": 55,
                "month": 55,
                "m": 17.5,
                "2sd": 22.9,
                "-2sd": 13.5
            },
            {
                "name": 56,
                "month": 56,
                "m": 17.7,
                "2sd": 23.2,
                "-2sd": 13.6
            },
            {
                "name": 57,
                "month": 57,
                "m": 17.8,
                "2sd": 23.4,
                "-2sd": 13.7
            },
            {
                "name": 58,
                "month": 58,
                "m": 18,
                "2sd": 23.7,
                "-2sd": 13.8
            },
            {
                "name": 59,
                "month": 59,
                "m": 18.2,
                "2sd": 23.9,
                "-2sd": 14
            },
            {
                "name": 60,
                "month": 60,
                "m": 18.3,
                "2sd": 24.2,
                "-2sd": 14.1
            }
        ]
    },
    "female": {
        "height": [
            {
                "name": 0,
                "month": 0,
                "m": 49.1,
                "2sd": 52.9,
                "-2sd": 45.4
            },
            {
                "name": 1,
                "month": 1,
                "m": 53.7,
                "2sd": 57.6,
                "-2sd": 49.8
            },
            {
                "name": 2,
                "month": 2,
                "m": 57.1,
                "2sd": 61.1,
                "-2sd": 53
            },
            {
                "name": 3,
                "month": 3,
                "m": 59.8,
                "2sd": 64,
                "-2sd": 55.6
            },
            {
                "name": 4,
                "month": 4,
                "m": 62.1,
                "2sd": 66.4,
                "-2sd": 57.8
            },
            {
                "name": 5,
                "month": 5,
                "m": 64,
                "2sd": 68.5,
                "-2sd": 59.6
            },
            {
                "name": 6,
                "month": 6,
                "m": 65.7,
                "2sd": 70.3,
                "-2sd": 61.2
            },
            {
                "name": 7,
                "month": 7,
                "m": 67.3,
                "2sd": 71.9,
                "-2sd": 62.7
            },
            {
                "name": 8,
                "month": 8,
                "m": 68.7,
                "2sd": 73.5,
                "-2sd": 64
            },
            {
                "name": 9,
                "month": 9,
                "m": 70.1,
                "2sd": 75,
                "-2sd": 65.3
            },
            {
                "name": 10,
                "month": 10,
                "m": 71.5,
                "2sd": 76.4,
                "-2sd": 66.5
            },
            {
                "name": 11,
                "month": 11,
                "m": 72.8,
                "2sd": 77.8,
                "-2sd": 67.7
            },
            {
                "name": 12,
                "month": 12,
                "m": 74,
                "2sd": 79.2,
                "-2sd": 68.9
            },
            {
                "name": 13,
                "month": 13,
                "m": 75.2,
                "2sd": 80.5,
                "-2sd": 70
            },
            {
                "name": 14,
                "month": 14,
                "m": 76.4,
                "2sd": 81.7,
                "-2sd": 71
            },
            {
                "name": 15,
                "month": 15,
                "m": 77.5,
                "2sd": 83,
                "-2sd": 72
            },
            {
                "name": 16,
                "month": 16,
                "m": 78.6,
                "2sd": 84.2,
                "-2sd": 73
            },
            {
                "name": 17,
                "month": 17,
                "m": 79.7,
                "2sd": 85.4,
                "-2sd": 74
            },
            {
                "name": 18,
                "month": 18,
                "m": 80.7,
                "2sd": 86.5,
                "-2sd": 74.9
            },
            {
                "name": 19,
                "month": 19,
                "m": 81.7,
                "2sd": 87.6,
                "-2sd": 75.8
            },
            {
                "name": 20,
                "month": 20,
                "m": 82.7,
                "2sd": 88.7,
                "-2sd": 76.7
            },
            {
                "name": 21,
                "month": 21,
                "m": 83.7,
                "2sd": 89.8,
                "-2sd": 77.5
            },
            {
                "name": 22,
                "month": 22,
                "m": 84.6,
                "2sd": 90.8,
                "-2sd": 78.4
            },
            {
                "name": 23,
                "month": 23,
                "m": 85.5,
                "2sd": 91.9,
                "-2sd": 79.2
            },
            {
                "name": 24,
                "month": 24,
                "m": 86.4,
                "2sd": 92.9,
                "-2sd": 80
            },
            {
                "name": 25,
                "month": 25,
                "m": 86.6,
                "2sd": 93.1,
                "-2sd": 80
            },
            {
                "name": 26,
                "month": 26,
                "m": 87.4,
                "2sd": 94.1,
                "-2sd": 80.8
            },
            {
                "name": 27,
                "month": 27,
                "m": 88.3,
                "2sd": 95,
                "-2sd": 81.5
            },
            {
                "name": 28,
                "month": 28,
                "m": 89.1,
                "2sd": 96,
                "-2sd": 82.2
            },
            {
                "name": 29,
                "month": 29,
                "m": 89.9,
                "2sd": 96.9,
                "-2sd": 82.9
            },
            {
                "name": 30,
                "month": 30,
                "m": 90.7,
                "2sd": 97.7,
                "-2sd": 83.6
            },
            {
                "name": 31,
                "month": 31,
                "m": 91.4,
                "2sd": 98.6,
                "-2sd": 84.3
            },
            {
                "name": 32,
                "month": 32,
                "m": 92.2,
                "2sd": 99.4,
                "-2sd": 84.9
            },
            {
                "name": 33,
                "month": 33,
                "m": 92.9,
                "2sd": 100.3,
                "-2sd": 85.6
            },
            {
                "name": 34,
                "month": 34,
                "m": 93.6,
                "2sd": 101.1,
                "-2sd": 86.2
            },
            {
                "name": 35,
                "month": 35,
                "m": 94.4,
                "2sd": 101.9,
                "-2sd": 86.8
            },
            {
                "name": 36,
                "month": 36,
                "m": 95.1,
                "2sd": 102.7,
                "-2sd": 87.4
            },
            {
                "name": 37,
                "month": 37,
                "m": 95.7,
                "2sd": 103.4,
                "-2sd": 88
            },
            {
                "name": 38,
                "month": 38,
                "m": 96.4,
                "2sd": 104.2,
                "-2sd": 88.6
            },
            {
                "name": 39,
                "month": 39,
                "m": 97.1,
                "2sd": 105,
                "-2sd": 89.2
            },
            {
                "name": 40,
                "month": 40,
                "m": 97.7,
                "2sd": 105.7,
                "-2sd": 89.8
            },
            {
                "name": 41,
                "month": 41,
                "m": 98.4,
                "2sd": 106.4,
                "-2sd": 90.4
            },
            {
                "name": 42,
                "month": 42,
                "m": 99,
                "2sd": 107.2,
                "-2sd": 90.9
            },
            {
                "name": 43,
                "month": 43,
                "m": 99.7,
                "2sd": 107.9,
                "-2sd": 91.5
            },
            {
                "name": 44,
                "month": 44,
                "m": 100.3,
                "2sd": 108.6,
                "-2sd": 92
            },
            {
                "name": 45,
                "month": 45,
                "m": 100.9,
                "2sd": 109.3,
                "-2sd": 92.5
            },
            {
                "name": 46,
                "month": 46,
                "m": 101.5,
                "2sd": 110,
                "-2sd": 93.1
            },
            {
                "name": 47,
                "month": 47,
                "m": 102.1,
                "2sd": 110.7,
                "-2sd": 93.6
            },
            {
                "name": 48,
                "month": 48,
                "m": 102.7,
                "2sd": 111.3,
                "-2sd": 94.1
            },
            {
                "name": 49,
                "month": 49,
                "m": 103.3,
                "2sd": 112,
                "-2sd": 94.6
            },
            {
                "name": 50,
                "month": 50,
                "m": 103.9,
                "2sd": 112.7,
                "-2sd": 95.1
            },
            {
                "name": 51,
                "month": 51,
                "m": 104.5,
                "2sd": 113.3,
                "-2sd": 95.6
            },
            {
                "name": 52,
                "month": 52,
                "m": 105,
                "2sd": 114,
                "-2sd": 96.1
            },
            {
                "name": 53,
                "month": 53,
                "m": 105.6,
                "2sd": 114.6,
                "-2sd": 96.6
            },
            {
                "name": 54,
                "month": 54,
                "m": 106.2,
                "2sd": 115.2,
                "-2sd": 97.1
            },
            {
                "name": 55,
                "month": 55,
                "m": 106.7,
                "2sd": 115.9,
                "-2sd": 97.6
            },
            {
                "name": 56,
                "month": 56,
                "m": 107.3,
                "2sd": 116.5,
                "-2sd": 98.1
            },
            {
                "name": 57,
                "month": 57,
                "m": 107.8,
                "2sd": 117.1,
                "-2sd": 98.5
            },
            {
                "name": 58,
                "month": 58,
                "m": 108.4,
                "2sd": 117.7,
                "-2sd": 99
            },
            {
                "name": 59,
                "month": 59,
                "m": 108.9,
                "2sd": 118.3,
                "-2sd": 99.5
            },
            {
                "name": 60,
                "month": 60,
                "m": 109.4,
                "2sd": 118.9,
                "-2sd": 99.9
            }
        ],
        "weight": [
            {
                "name": 0,
                "month": 0,
                "m": 3.2,
                "2sd": 4.2,
                "-2sd": 2.4
            },
            {
                "name": 1,
                "month": 1,
                "m": 4.2,
                "2sd": 5.5,
                "-2sd": 3.2
            },
            {
                "name": 2,
                "month": 2,
                "m": 5.1,
                "2sd": 6.6,
                "-2sd": 3.9
            },
            {
                "name": 3,
                "month": 3,
                "m": 5.8,
                "2sd": 7.5,
                "-2sd": 4.5
            },
            {
                "name": 4,
                "month": 4,
                "m": 6.4,
                "2sd": 8.2,
                "-2sd": 5
            },
            {
                "name": 5,
                "month": 5,
                "m": 6.9,
                "2sd": 8.8,
                "-2sd": 5.4
            },
            {
                "name": 6,
                "month": 6,
                "m": 7.3,
                "2sd": 9.3,
                "-2sd": 5.7
            },
            {
                "name": 7,
                "month": 7,
                "m": 7.6,
                "2sd": 9.8,
                "-2sd": 6
            },
            {
                "name": 8,
                "month": 8,
                "m": 7.9,
                "2sd": 10.2,
                "-2sd": 6.3
            },
            {
                "name": 9,
                "month": 9,
                "m": 8.2,
                "2sd": 10.5,
                "-2sd": 6.5
            },
            {
                "name": 10,
                "month": 10,
                "m": 8.5,
                "2sd": 10.9,
                "-2sd": 6.7
            },
            {
                "name": 11,
                "month": 11,
                "m": 8.7,
                "2sd": 11.2,
                "-2sd": 6.9
            },
            {
                "name": 12,
                "month": 12,
                "m": 8.9,
                "2sd": 11.5,
                "-2sd": 7
            },
            {
                "name": 13,
                "month": 13,
                "m": 9.2,
                "2sd": 11.8,
                "-2sd": 7.2
            },
            {
                "name": 14,
                "month": 14,
                "m": 9.4,
                "2sd": 12.1,
                "-2sd": 7.4
            },
            {
                "name": 15,
                "month": 15,
                "m": 9.6,
                "2sd": 12.4,
                "-2sd": 7.6
            },
            {
                "name": 16,
                "month": 16,
                "m": 9.8,
                "2sd": 12.6,
                "-2sd": 7.7
            },
            {
                "name": 17,
                "month": 17,
                "m": 10,
                "2sd": 12.9,
                "-2sd": 7.9
            },
            {
                "name": 18,
                "month": 18,
                "m": 10.2,
                "2sd": 13.2,
                "-2sd": 8.1
            },
            {
                "name": 19,
                "month": 19,
                "m": 10.4,
                "2sd": 13.5,
                "-2sd": 8.2
            },
            {
                "name": 20,
                "month": 20,
                "m": 10.6,
                "2sd": 13.7,
                "-2sd": 8.4
            },
            {
                "name": 21,
                "month": 21,
                "m": 10.9,
                "2sd": 14,
                "-2sd": 8.6
            },
            {
                "name": 22,
                "month": 22,
                "m": 11.1,
                "2sd": 14.3,
                "-2sd": 8.7
            },
            {
                "name": 23,
                "month": 23,
                "m": 11.3,
                "2sd": 14.6,
                "-2sd": 8.9
            },
            {
                "name": 24,
                "month": 24,
                "m": 11.5,
                "2sd": 14.8,
                "-2sd": 9
            },
            {
                "name": 25,
                "month": 25,
                "m": 11.7,
                "2sd": 15.1,
                "-2sd": 9.2
            },
            {
                "name": 26,
                "month": 26,
                "m": 11.9,
                "2sd": 15.4,
                "-2sd": 9.4
            },
            {
                "name": 27,
                "month": 27,
                "m": 12.1,
                "2sd": 15.7,
                "-2sd": 9.5
            },
            {
                "name": 28,
                "month": 28,
                "m": 12.3,
                "2sd": 16,
                "-2sd": 9.7
            },
            {
                "name": 29,
                "month": 29,
                "m": 12.5,
                "2sd": 16.2,
                "-2sd": 9.8
            },
            {
                "name": 30,
                "month": 30,
                "m": 12.7,
                "2sd": 16.5,
                "-2sd": 10
            },
            {
                "name": 31,
                "month": 31,
                "m": 12.9,
                "2sd": 16.8,
                "-2sd": 10.1
            },
            {
                "name": 32,
                "month": 32,
                "m": 13.1,
                "2sd": 17.1,
                "-2sd": 10.3
            },
            {
                "name": 33,
                "month": 33,
                "m": 13.3,
                "2sd": 17.3,
                "-2sd": 10.4
            },
            {
                "name": 34,
                "month": 34,
                "m": 13.5,
                "2sd": 17.6,
                "-2sd": 10.5
            },
            {
                "name": 35,
                "month": 35,
                "m": 13.7,
                "2sd": 17.9,
                "-2sd": 10.7
            },
            {
                "name": 36,
                "month": 36,
                "m": 13.9,
                "2sd": 18.1,
                "-2sd": 10.8
            },
            {
                "name": 37,
                "month": 37,
                "m": 14,
                "2sd": 18.4,
                "-2sd": 10.9
            },
            {
                "name": 38,
                "month": 38,
                "m": 14.2,
                "2sd": 18.7,
                "-2sd": 11.1
            },
            {
                "name": 39,
                "month": 39,
                "m": 14.4,
                "2sd": 19,
                "-2sd": 11.2
            },
            {
                "name": 40,
                "month": 40,
                "m": 14.6,
                "2sd": 19.2,
                "-2sd": 11.3
            },
            {
                "name": 41,
                "month": 41,
                "m": 14.8,
                "2sd": 19.5,
                "-2sd": 11.5
            },
            {
                "name": 42,
                "month": 42,
                "m": 15,
                "2sd": 19.8,
                "-2sd": 11.6
            },
            {
                "name": 43,
                "month": 43,
                "m": 15.2,
                "2sd": 20.1,
                "-2sd": 11.7
            },
            {
                "name": 44,
                "month": 44,
                "m": 15.3,
                "2sd": 20.4,
                "-2sd": 11.8
            },
            {
                "name": 45,
                "month": 45,
                "m": 15.5,
                "2sd": 20.7,
                "-2sd": 12
            },
            {
                "name": 46,
                "month": 46,
                "m": 15.7,
                "2sd": 20.9,
                "-2sd": 12.1
            },
            {
                "name": 47,
                "month": 47,
                "m": 15.9,
                "2sd": 21.2,
                "-2sd": 12.2
            },
            {
                "name": 48,
                "month": 48,
                "m": 16.1,
                "2sd": 21.5,
                "-2sd": 12.3
            },
            {
                "name": 49,
                "month": 49,
                "m": 16.3,
                "2sd": 21.8,
                "-2sd": 12.4
            },
            {
                "name": 50,
                "month": 50,
                "m": 16.4,
                "2sd": 22.1,
                "-2sd": 12.6
            },
            {
                "name": 51,
                "month": 51,
                "m": 16.6,
                "2sd": 22.4,
                "-2sd": 12.7
            },
            {
                "name": 52,
                "month": 52,
                "m": 16.8,
                "2sd": 22.6,
                "-2sd": 12.8
            },
            {
                "name": 53,
                "month": 53,
                "m": 17,
                "2sd": 22.9,
                "-2sd": 12.9
            },
            {
                "name": 54,
                "month": 54,
                "m": 17.2,
                "2sd": 23.2,
                "-2sd": 13
            },
            {
                "name": 55,
                "month": 55,
                "m": 17.3,
                "2sd": 23.5,
                "-2sd": 13.2
            },
            {
                "name": 56,
                "month": 56,
                "m": 17.5,
                "2sd": 23.8,
                "-2sd": 13.3
            },
            {
                "name": 57,
                "month": 57,
                "m": 17.7,
                "2sd": 24.1,
                "-2sd": 13.4
            },
            {
                "name": 58,
                "month": 58,
                "m": 17.9,
                "2sd": 24.4,
                "-2sd": 13.5
            },
            {
                "name": 59,
                "month": 59,
                "m": 18,
                "2sd": 24.6,
                "-2sd": 13.6
            },
            {
                "name": 60,
                "month": 60,
                "m": 18.2,
                "2sd": 24.9,
                "-2sd": 13.7
            }
        ]
    }
}
//MORE_THAN_60_MONTHS
export const BMI_MALE_5_19 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.6,
        "2sd": 18.3,
        "3sd": 20.2
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.6,
        "2sd": 18.3,
        "3sd": 20.2
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.3,
        "3sd": 20.2
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.3,
        "3sd": 20.3
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.3,
        "3sd": 20.3
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.4,
        "3sd": 20.4
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.4,
        "3sd": 20.4
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.4,
        "3sd": 20.5
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.4,
        "3sd": 20.5
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.5,
        "3sd": 20.6
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.7,
        "2sd": 18.5,
        "3sd": 20.6
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.8,
        "2sd": 18.5,
        "3sd": 20.7
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "-3sd": 12.1,
        "-2sd": 13,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.8,
        "2sd": 18.6,
        "3sd": 20.8
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.8,
        "2sd": 18.6,
        "3sd": 20.8
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.3,
        "1sd": 16.8,
        "2sd": 18.6,
        "3sd": 20.9
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.4,
        "1sd": 16.8,
        "2sd": 18.7,
        "3sd": 21
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.4,
        "1sd": 16.9,
        "2sd": 18.7,
        "3sd": 21
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.4,
        "1sd": 16.9,
        "2sd": 18.7,
        "3sd": 21.1
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.1,
        "Median": 15.4,
        "1sd": 16.9,
        "2sd": 18.8,
        "3sd": 21.2
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.2,
        "Median": 15.4,
        "1sd": 16.9,
        "2sd": 18.8,
        "3sd": 21.3
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.2,
        "Median": 15.4,
        "1sd": 17,
        "2sd": 18.9,
        "3sd": 21.3
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.2,
        "Median": 15.4,
        "1sd": 17,
        "2sd": 18.9,
        "3sd": 21.4
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "-3sd": 12.2,
        "-2sd": 13.1,
        "-1sd": 14.2,
        "Median": 15.5,
        "1sd": 17,
        "2sd": 19,
        "3sd": 21.5
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "-3sd": 12.3,
        "-2sd": 13.1,
        "-1sd": 14.2,
        "Median": 15.5,
        "1sd": 17,
        "2sd": 19,
        "3sd": 21.6
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.2,
        "Median": 15.5,
        "1sd": 17.1,
        "2sd": 19.1,
        "3sd": 21.7
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.2,
        "Median": 15.5,
        "1sd": 17.1,
        "2sd": 19.1,
        "3sd": 21.8
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.5,
        "1sd": 17.1,
        "2sd": 19.2,
        "3sd": 21.9
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.6,
        "1sd": 17.2,
        "2sd": 19.2,
        "3sd": 22
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.6,
        "1sd": 17.2,
        "2sd": 19.3,
        "3sd": 22
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.6,
        "1sd": 17.2,
        "2sd": 19.3,
        "3sd": 22.1
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.6,
        "1sd": 17.3,
        "2sd": 19.4,
        "3sd": 22.2
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "-3sd": 12.3,
        "-2sd": 13.2,
        "-1sd": 14.3,
        "Median": 15.6,
        "1sd": 17.3,
        "2sd": 19.4,
        "3sd": 22.4
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.3,
        "Median": 15.7,
        "1sd": 17.3,
        "2sd": 19.5,
        "3sd": 22.5
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.7,
        "1sd": 17.4,
        "2sd": 19.6,
        "3sd": 22.6
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.7,
        "1sd": 17.4,
        "2sd": 19.6,
        "3sd": 22.7
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.7,
        "1sd": 17.4,
        "2sd": 19.7,
        "3sd": 22.8
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.8,
        "1sd": 17.5,
        "2sd": 19.7,
        "3sd": 22.9
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.8,
        "1sd": 17.5,
        "2sd": 19.8,
        "3sd": 23
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "-3sd": 12.4,
        "-2sd": 13.3,
        "-1sd": 14.4,
        "Median": 15.8,
        "1sd": 17.5,
        "2sd": 19.9,
        "3sd": 23.1
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "-3sd": 12.4,
        "-2sd": 13.4,
        "-1sd": 14.5,
        "Median": 15.8,
        "1sd": 17.6,
        "2sd": 19.9,
        "3sd": 23.3
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "-3sd": 12.5,
        "-2sd": 13.4,
        "-1sd": 14.5,
        "Median": 15.9,
        "1sd": 17.6,
        "2sd": 20,
        "3sd": 23.4
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "-3sd": 12.5,
        "-2sd": 13.4,
        "-1sd": 14.5,
        "Median": 15.9,
        "1sd": 17.7,
        "2sd": 20.1,
        "3sd": 23.5
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "-3sd": 12.5,
        "-2sd": 13.4,
        "-1sd": 14.5,
        "Median": 15.9,
        "1sd": 17.7,
        "2sd": 20.1,
        "3sd": 23.6
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "-3sd": 12.5,
        "-2sd": 13.4,
        "-1sd": 14.5,
        "Median": 15.9,
        "1sd": 17.7,
        "2sd": 20.2,
        "3sd": 23.8
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "-3sd": 12.5,
        "-2sd": 13.4,
        "-1sd": 14.6,
        "Median": 16,
        "1sd": 17.8,
        "2sd": 20.3,
        "3sd": 23.9
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "-3sd": 12.5,
        "-2sd": 13.5,
        "-1sd": 14.6,
        "Median": 16,
        "1sd": 17.8,
        "2sd": 20.3,
        "3sd": 24
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "-3sd": 12.5,
        "-2sd": 13.5,
        "-1sd": 14.6,
        "Median": 16,
        "1sd": 17.9,
        "2sd": 20.4,
        "3sd": 24.2
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "-3sd": 12.6,
        "-2sd": 13.5,
        "-1sd": 14.6,
        "Median": 16,
        "1sd": 17.9,
        "2sd": 20.5,
        "3sd": 24.3
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "-3sd": 12.6,
        "-2sd": 13.5,
        "-1sd": 14.6,
        "Median": 16.1,
        "1sd": 18,
        "2sd": 20.5,
        "3sd": 24.4
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "-3sd": 12.6,
        "-2sd": 13.5,
        "-1sd": 14.7,
        "Median": 16.1,
        "1sd": 18,
        "2sd": 20.6,
        "3sd": 24.6
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "-3sd": 12.6,
        "-2sd": 13.5,
        "-1sd": 14.7,
        "Median": 16.1,
        "1sd": 18,
        "2sd": 20.7,
        "3sd": 24.7
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "-3sd": 12.6,
        "-2sd": 13.6,
        "-1sd": 14.7,
        "Median": 16.2,
        "1sd": 18.1,
        "2sd": 20.8,
        "3sd": 24.9
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "-3sd": 12.6,
        "-2sd": 13.6,
        "-1sd": 14.7,
        "Median": 16.2,
        "1sd": 18.1,
        "2sd": 20.8,
        "3sd": 25
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "-3sd": 12.7,
        "-2sd": 13.6,
        "-1sd": 14.8,
        "Median": 16.2,
        "1sd": 18.2,
        "2sd": 20.9,
        "3sd": 25.1
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "-3sd": 12.7,
        "-2sd": 13.6,
        "-1sd": 14.8,
        "Median": 16.3,
        "1sd": 18.2,
        "2sd": 21,
        "3sd": 25.3
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "-3sd": 12.7,
        "-2sd": 13.6,
        "-1sd": 14.8,
        "Median": 16.3,
        "1sd": 18.3,
        "2sd": 21.1,
        "3sd": 25.5
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "-3sd": 12.7,
        "-2sd": 13.7,
        "-1sd": 14.8,
        "Median": 16.3,
        "1sd": 18.3,
        "2sd": 21.2,
        "3sd": 25.6
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "-3sd": 12.7,
        "-2sd": 13.7,
        "-1sd": 14.9,
        "Median": 16.4,
        "1sd": 18.4,
        "2sd": 21.2,
        "3sd": 25.8
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "-3sd": 12.8,
        "-2sd": 13.7,
        "-1sd": 14.9,
        "Median": 16.4,
        "1sd": 18.4,
        "2sd": 21.3,
        "3sd": 25.9
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "-3sd": 12.8,
        "-2sd": 13.7,
        "-1sd": 14.9,
        "Median": 16.4,
        "1sd": 18.5,
        "2sd": 21.4,
        "3sd": 26.1
    },
    {
        "year": 10,
        "monthByYear": 1,
        "month": 121,
        "name": "10: 1",
        "-3sd": 12.8,
        "-2sd": 13.8,
        "-1sd": 15,
        "Median": 16.5,
        "1sd": 18.5,
        "2sd": 21.5,
        "3sd": 26.2
    },
    {
        "year": 10,
        "monthByYear": 2,
        "month": 122,
        "name": "10: 2",
        "-3sd": 12.8,
        "-2sd": 13.8,
        "-1sd": 15,
        "Median": 16.5,
        "1sd": 18.6,
        "2sd": 21.6,
        "3sd": 26.4
    },
    {
        "year": 10,
        "monthByYear": 3,
        "month": 123,
        "name": "10: 3",
        "-3sd": 12.8,
        "-2sd": 13.8,
        "-1sd": 15,
        "Median": 16.6,
        "1sd": 18.6,
        "2sd": 21.7,
        "3sd": 26.6
    },
    {
        "year": 10,
        "monthByYear": 4,
        "month": 124,
        "name": "10: 4",
        "-3sd": 12.9,
        "-2sd": 13.8,
        "-1sd": 15,
        "Median": 16.6,
        "1sd": 18.7,
        "2sd": 21.7,
        "3sd": 26.7
    },
    {
        "year": 10,
        "monthByYear": 5,
        "month": 125,
        "name": "10: 5",
        "-3sd": 12.9,
        "-2sd": 13.9,
        "-1sd": 15.1,
        "Median": 16.6,
        "1sd": 18.8,
        "2sd": 21.8,
        "3sd": 26.9
    },
    {
        "year": 10,
        "monthByYear": 6,
        "month": 126,
        "name": "10: 6",
        "-3sd": 12.9,
        "-2sd": 13.9,
        "-1sd": 15.1,
        "Median": 16.7,
        "1sd": 18.8,
        "2sd": 21.9,
        "3sd": 27
    },
    {
        "year": 10,
        "monthByYear": 7,
        "month": 127,
        "name": "10: 7",
        "-3sd": 12.9,
        "-2sd": 13.9,
        "-1sd": 15.1,
        "Median": 16.7,
        "1sd": 18.9,
        "2sd": 22,
        "3sd": 27.2
    },
    {
        "year": 10,
        "monthByYear": 8,
        "month": 128,
        "name": "10: 8",
        "-3sd": 13,
        "-2sd": 13.9,
        "-1sd": 15.2,
        "Median": 16.8,
        "1sd": 18.9,
        "2sd": 22.1,
        "3sd": 27.4
    },
    {
        "year": 10,
        "monthByYear": 9,
        "month": 129,
        "name": "10: 9",
        "-3sd": 13,
        "-2sd": 14,
        "-1sd": 15.2,
        "Median": 16.8,
        "1sd": 19,
        "2sd": 22.2,
        "3sd": 27.5
    },
    {
        "year": 10,
        "monthByYear": 10,
        "month": 130,
        "name": "10:10",
        "-3sd": 13,
        "-2sd": 14,
        "-1sd": 15.2,
        "Median": 16.9,
        "1sd": 19,
        "2sd": 22.3,
        "3sd": 27.7
    },
    {
        "year": 10,
        "monthByYear": 11,
        "month": 131,
        "name": "10:11",
        "-3sd": 13,
        "-2sd": 14,
        "-1sd": 15.3,
        "Median": 16.9,
        "1sd": 19.1,
        "2sd": 22.4,
        "3sd": 27.9
    },
    {
        "year": 11,
        "monthByYear": 0,
        "month": 132,
        "name": "11: 0",
        "-3sd": 13.1,
        "-2sd": 14.1,
        "-1sd": 15.3,
        "Median": 16.9,
        "1sd": 19.2,
        "2sd": 22.5,
        "3sd": 28
    },
    {
        "year": 11,
        "monthByYear": 1,
        "month": 133,
        "name": "11: 1",
        "-3sd": 13.1,
        "-2sd": 14.1,
        "-1sd": 15.3,
        "Median": 17,
        "1sd": 19.2,
        "2sd": 22.5,
        "3sd": 28.2
    },
    {
        "year": 11,
        "monthByYear": 2,
        "month": 134,
        "name": "11: 2",
        "-3sd": 13.1,
        "-2sd": 14.1,
        "-1sd": 15.4,
        "Median": 17,
        "1sd": 19.3,
        "2sd": 22.6,
        "3sd": 28.4
    },
    {
        "year": 11,
        "monthByYear": 3,
        "month": 135,
        "name": "11: 3",
        "-3sd": 13.1,
        "-2sd": 14.1,
        "-1sd": 15.4,
        "Median": 17.1,
        "1sd": 19.3,
        "2sd": 22.7,
        "3sd": 28.5
    },
    {
        "year": 11,
        "monthByYear": 4,
        "month": 136,
        "name": "11: 4",
        "-3sd": 13.2,
        "-2sd": 14.2,
        "-1sd": 15.5,
        "Median": 17.1,
        "1sd": 19.4,
        "2sd": 22.8,
        "3sd": 28.7
    },
    {
        "year": 11,
        "monthByYear": 5,
        "month": 137,
        "name": "11: 5",
        "-3sd": 13.2,
        "-2sd": 14.2,
        "-1sd": 15.5,
        "Median": 17.2,
        "1sd": 19.5,
        "2sd": 22.9,
        "3sd": 28.8
    },
    {
        "year": 11,
        "monthByYear": 6,
        "month": 138,
        "name": "11: 6",
        "-3sd": 13.2,
        "-2sd": 14.2,
        "-1sd": 15.5,
        "Median": 17.2,
        "1sd": 19.5,
        "2sd": 23,
        "3sd": 29
    },
    {
        "year": 11,
        "monthByYear": 7,
        "month": 139,
        "name": "11: 7",
        "-3sd": 13.2,
        "-2sd": 14.3,
        "-1sd": 15.6,
        "Median": 17.3,
        "1sd": 19.6,
        "2sd": 23.1,
        "3sd": 29.2
    },
    {
        "year": 11,
        "monthByYear": 8,
        "month": 140,
        "name": "11: 8",
        "-3sd": 13.3,
        "-2sd": 14.3,
        "-1sd": 15.6,
        "Median": 17.3,
        "1sd": 19.7,
        "2sd": 23.2,
        "3sd": 29.3
    },
    {
        "year": 11,
        "monthByYear": 9,
        "month": 141,
        "name": "11: 9",
        "-3sd": 13.3,
        "-2sd": 14.3,
        "-1sd": 15.7,
        "Median": 17.4,
        "1sd": 19.7,
        "2sd": 23.3,
        "3sd": 29.5
    },
    {
        "year": 11,
        "monthByYear": 10,
        "month": 142,
        "name": "11:10",
        "-3sd": 13.3,
        "-2sd": 14.4,
        "-1sd": 15.7,
        "Median": 17.4,
        "1sd": 19.8,
        "2sd": 23.4,
        "3sd": 29.6
    },
    {
        "year": 11,
        "monthByYear": 11,
        "month": 143,
        "name": "11:11",
        "-3sd": 13.4,
        "-2sd": 14.4,
        "-1sd": 15.7,
        "Median": 17.5,
        "1sd": 19.9,
        "2sd": 23.5,
        "3sd": 29.8
    },
    {
        "year": 12,
        "monthByYear": 0,
        "month": 144,
        "name": "12: 0",
        "-3sd": 13.4,
        "-2sd": 14.5,
        "-1sd": 15.8,
        "Median": 17.5,
        "1sd": 19.9,
        "2sd": 23.6,
        "3sd": 30
    },
    {
        "year": 12,
        "monthByYear": 1,
        "month": 145,
        "name": "12: 1",
        "-3sd": 13.4,
        "-2sd": 14.5,
        "-1sd": 15.8,
        "Median": 17.6,
        "1sd": 20,
        "2sd": 23.7,
        "3sd": 30.1
    },
    {
        "year": 12,
        "monthByYear": 2,
        "month": 146,
        "name": "12: 2",
        "-3sd": 13.5,
        "-2sd": 14.5,
        "-1sd": 15.9,
        "Median": 17.6,
        "1sd": 20.1,
        "2sd": 23.8,
        "3sd": 30.3
    },
    {
        "year": 12,
        "monthByYear": 3,
        "month": 147,
        "name": "12: 3",
        "-3sd": 13.5,
        "-2sd": 14.6,
        "-1sd": 15.9,
        "Median": 17.7,
        "1sd": 20.2,
        "2sd": 23.9,
        "3sd": 30.4
    },
    {
        "year": 12,
        "monthByYear": 4,
        "month": 148,
        "name": "12: 4",
        "-3sd": 13.5,
        "-2sd": 14.6,
        "-1sd": 16,
        "Median": 17.8,
        "1sd": 20.2,
        "2sd": 24,
        "3sd": 30.6
    },
    {
        "year": 12,
        "monthByYear": 5,
        "month": 149,
        "name": "12: 5",
        "-3sd": 13.6,
        "-2sd": 14.6,
        "-1sd": 16,
        "Median": 17.8,
        "1sd": 20.3,
        "2sd": 24.1,
        "3sd": 30.7
    },
    {
        "year": 12,
        "monthByYear": 6,
        "month": 150,
        "name": "12: 6",
        "-3sd": 13.6,
        "-2sd": 14.7,
        "-1sd": 16.1,
        "Median": 17.9,
        "1sd": 20.4,
        "2sd": 24.2,
        "3sd": 30.9
    },
    {
        "year": 12,
        "monthByYear": 7,
        "month": 151,
        "name": "12: 7",
        "-3sd": 13.6,
        "-2sd": 14.7,
        "-1sd": 16.1,
        "Median": 17.9,
        "1sd": 20.4,
        "2sd": 24.3,
        "3sd": 31
    },
    {
        "year": 12,
        "monthByYear": 8,
        "month": 152,
        "name": "12: 8",
        "-3sd": 13.7,
        "-2sd": 14.8,
        "-1sd": 16.2,
        "Median": 18,
        "1sd": 20.5,
        "2sd": 24.4,
        "3sd": 31.1
    },
    {
        "year": 12,
        "monthByYear": 9,
        "month": 153,
        "name": "12: 9",
        "-3sd": 13.7,
        "-2sd": 14.8,
        "-1sd": 16.2,
        "Median": 18,
        "1sd": 20.6,
        "2sd": 24.5,
        "3sd": 31.3
    },
    {
        "year": 12,
        "monthByYear": 10,
        "month": 154,
        "name": "12:10",
        "-3sd": 13.7,
        "-2sd": 14.8,
        "-1sd": 16.3,
        "Median": 18.1,
        "1sd": 20.7,
        "2sd": 24.6,
        "3sd": 31.4
    },
    {
        "year": 12,
        "monthByYear": 11,
        "month": 155,
        "name": "12:11",
        "-3sd": 13.8,
        "-2sd": 14.9,
        "-1sd": 16.3,
        "Median": 18.2,
        "1sd": 20.8,
        "2sd": 24.7,
        "3sd": 31.6
    },
    {
        "year": 13,
        "monthByYear": 0,
        "month": 156,
        "name": "13: 0",
        "-3sd": 13.8,
        "-2sd": 14.9,
        "-1sd": 16.4,
        "Median": 18.2,
        "1sd": 20.8,
        "2sd": 24.8,
        "3sd": 31.7
    },
    {
        "year": 13,
        "monthByYear": 1,
        "month": 157,
        "name": "13: 1",
        "-3sd": 13.8,
        "-2sd": 15,
        "-1sd": 16.4,
        "Median": 18.3,
        "1sd": 20.9,
        "2sd": 24.9,
        "3sd": 31.8
    },
    {
        "year": 13,
        "monthByYear": 2,
        "month": 158,
        "name": "13: 2",
        "-3sd": 13.9,
        "-2sd": 15,
        "-1sd": 16.5,
        "Median": 18.4,
        "1sd": 21,
        "2sd": 25,
        "3sd": 31.9
    },
    {
        "year": 13,
        "monthByYear": 3,
        "month": 159,
        "name": "13: 3",
        "-3sd": 13.9,
        "-2sd": 15.1,
        "-1sd": 16.5,
        "Median": 18.4,
        "1sd": 21.1,
        "2sd": 25.1,
        "3sd": 32.1
    },
    {
        "year": 13,
        "monthByYear": 4,
        "month": 160,
        "name": "13: 4",
        "-3sd": 14,
        "-2sd": 15.1,
        "-1sd": 16.6,
        "Median": 18.5,
        "1sd": 21.1,
        "2sd": 25.2,
        "3sd": 32.2
    },
    {
        "year": 13,
        "monthByYear": 5,
        "month": 161,
        "name": "13: 5",
        "-3sd": 14,
        "-2sd": 15.2,
        "-1sd": 16.6,
        "Median": 18.6,
        "1sd": 21.2,
        "2sd": 25.2,
        "3sd": 32.3
    },
    {
        "year": 13,
        "monthByYear": 6,
        "month": 162,
        "name": "13: 6",
        "-3sd": 14,
        "-2sd": 15.2,
        "-1sd": 16.7,
        "Median": 18.6,
        "1sd": 21.3,
        "2sd": 25.3,
        "3sd": 32.4
    },
    {
        "year": 13,
        "monthByYear": 7,
        "month": 163,
        "name": "13: 7",
        "-3sd": 14.1,
        "-2sd": 15.2,
        "-1sd": 16.7,
        "Median": 18.7,
        "1sd": 21.4,
        "2sd": 25.4,
        "3sd": 32.6
    },
    {
        "year": 13,
        "monthByYear": 8,
        "month": 164,
        "name": "13: 8",
        "-3sd": 14.1,
        "-2sd": 15.3,
        "-1sd": 16.8,
        "Median": 18.7,
        "1sd": 21.5,
        "2sd": 25.5,
        "3sd": 32.7
    },
    {
        "year": 13,
        "monthByYear": 9,
        "month": 165,
        "name": "13: 9",
        "-3sd": 14.1,
        "-2sd": 15.3,
        "-1sd": 16.8,
        "Median": 18.8,
        "1sd": 21.5,
        "2sd": 25.6,
        "3sd": 32.8
    },
    {
        "year": 13,
        "monthByYear": 10,
        "month": 166,
        "name": "13:10",
        "-3sd": 14.2,
        "-2sd": 15.4,
        "-1sd": 16.9,
        "Median": 18.9,
        "1sd": 21.6,
        "2sd": 25.7,
        "3sd": 32.9
    },
    {
        "year": 13,
        "monthByYear": 11,
        "month": 167,
        "name": "13:11",
        "-3sd": 14.2,
        "-2sd": 15.4,
        "-1sd": 17,
        "Median": 18.9,
        "1sd": 21.7,
        "2sd": 25.8,
        "3sd": 33
    },
    {
        "year": 14,
        "monthByYear": 0,
        "month": 168,
        "name": "14: 0",
        "-3sd": 14.3,
        "-2sd": 15.5,
        "-1sd": 17,
        "Median": 19,
        "1sd": 21.8,
        "2sd": 25.9,
        "3sd": 33.1
    },
    {
        "year": 14,
        "monthByYear": 1,
        "month": 169,
        "name": "14: 1",
        "-3sd": 14.3,
        "-2sd": 15.5,
        "-1sd": 17.1,
        "Median": 19.1,
        "1sd": 21.8,
        "2sd": 26,
        "3sd": 33.2
    },
    {
        "year": 14,
        "monthByYear": 2,
        "month": 170,
        "name": "14: 2",
        "-3sd": 14.3,
        "-2sd": 15.6,
        "-1sd": 17.1,
        "Median": 19.1,
        "1sd": 21.9,
        "2sd": 26.1,
        "3sd": 33.3
    },
    {
        "year": 14,
        "monthByYear": 3,
        "month": 171,
        "name": "14: 3",
        "-3sd": 14.4,
        "-2sd": 15.6,
        "-1sd": 17.2,
        "Median": 19.2,
        "1sd": 22,
        "2sd": 26.2,
        "3sd": 33.4
    },
    {
        "year": 14,
        "monthByYear": 4,
        "month": 172,
        "name": "14: 4",
        "-3sd": 14.4,
        "-2sd": 15.7,
        "-1sd": 17.2,
        "Median": 19.3,
        "1sd": 22.1,
        "2sd": 26.3,
        "3sd": 33.5
    },
    {
        "year": 14,
        "monthByYear": 5,
        "month": 173,
        "name": "14: 5",
        "-3sd": 14.5,
        "-2sd": 15.7,
        "-1sd": 17.3,
        "Median": 19.3,
        "1sd": 22.2,
        "2sd": 26.4,
        "3sd": 33.5
    },
    {
        "year": 14,
        "monthByYear": 6,
        "month": 174,
        "name": "14: 6",
        "-3sd": 14.5,
        "-2sd": 15.7,
        "-1sd": 17.3,
        "Median": 19.4,
        "1sd": 22.2,
        "2sd": 26.5,
        "3sd": 33.6
    },
    {
        "year": 14,
        "monthByYear": 7,
        "month": 175,
        "name": "14: 7",
        "-3sd": 14.5,
        "-2sd": 15.8,
        "-1sd": 17.4,
        "Median": 19.5,
        "1sd": 22.3,
        "2sd": 26.5,
        "3sd": 33.7
    },
    {
        "year": 14,
        "monthByYear": 8,
        "month": 176,
        "name": "14: 8",
        "-3sd": 14.6,
        "-2sd": 15.8,
        "-1sd": 17.4,
        "Median": 19.5,
        "1sd": 22.4,
        "2sd": 26.6,
        "3sd": 33.8
    },
    {
        "year": 14,
        "monthByYear": 9,
        "month": 177,
        "name": "14: 9",
        "-3sd": 14.6,
        "-2sd": 15.9,
        "-1sd": 17.5,
        "Median": 19.6,
        "1sd": 22.5,
        "2sd": 26.7,
        "3sd": 33.9
    },
    {
        "year": 14,
        "monthByYear": 10,
        "month": 178,
        "name": "14:10",
        "-3sd": 14.6,
        "-2sd": 15.9,
        "-1sd": 17.5,
        "Median": 19.6,
        "1sd": 22.5,
        "2sd": 26.8,
        "3sd": 33.9
    },
    {
        "year": 14,
        "monthByYear": 11,
        "month": 179,
        "name": "14:11",
        "-3sd": 14.7,
        "-2sd": 16,
        "-1sd": 17.6,
        "Median": 19.7,
        "1sd": 22.6,
        "2sd": 26.9,
        "3sd": 34
    },
    {
        "year": 15,
        "monthByYear": 0,
        "month": 180,
        "name": "15: 0",
        "-3sd": 14.7,
        "-2sd": 16,
        "-1sd": 17.6,
        "Median": 19.8,
        "1sd": 22.7,
        "2sd": 27,
        "3sd": 34.1
    },
    {
        "year": 15,
        "monthByYear": 1,
        "month": 181,
        "name": "15: 1",
        "-3sd": 14.7,
        "-2sd": 16.1,
        "-1sd": 17.7,
        "Median": 19.8,
        "1sd": 22.8,
        "2sd": 27.1,
        "3sd": 34.1
    },
    {
        "year": 15,
        "monthByYear": 2,
        "month": 182,
        "name": "15: 2",
        "-3sd": 14.8,
        "-2sd": 16.1,
        "-1sd": 17.8,
        "Median": 19.9,
        "1sd": 22.8,
        "2sd": 27.1,
        "3sd": 34.2
    },
    {
        "year": 15,
        "monthByYear": 3,
        "month": 183,
        "name": "15: 3",
        "-3sd": 14.8,
        "-2sd": 16.1,
        "-1sd": 17.8,
        "Median": 20,
        "1sd": 22.9,
        "2sd": 27.2,
        "3sd": 34.3
    },
    {
        "year": 15,
        "monthByYear": 4,
        "month": 184,
        "name": "15: 4",
        "-3sd": 14.8,
        "-2sd": 16.2,
        "-1sd": 17.9,
        "Median": 20,
        "1sd": 23,
        "2sd": 27.3,
        "3sd": 34.3
    },
    {
        "year": 15,
        "monthByYear": 5,
        "month": 185,
        "name": "15: 5",
        "-3sd": 14.9,
        "-2sd": 16.2,
        "-1sd": 17.9,
        "Median": 20.1,
        "1sd": 23,
        "2sd": 27.4,
        "3sd": 34.4
    },
    {
        "year": 15,
        "monthByYear": 6,
        "month": 186,
        "name": "15: 6",
        "-3sd": 14.9,
        "-2sd": 16.3,
        "-1sd": 18,
        "Median": 20.1,
        "1sd": 23.1,
        "2sd": 27.4,
        "3sd": 34.5
    },
    {
        "year": 15,
        "monthByYear": 7,
        "month": 187,
        "name": "15: 7",
        "-3sd": 15,
        "-2sd": 16.3,
        "-1sd": 18,
        "Median": 20.2,
        "1sd": 23.2,
        "2sd": 27.5,
        "3sd": 34.5
    },
    {
        "year": 15,
        "monthByYear": 8,
        "month": 188,
        "name": "15: 8",
        "-3sd": 15,
        "-2sd": 16.3,
        "-1sd": 18.1,
        "Median": 20.3,
        "1sd": 23.3,
        "2sd": 27.6,
        "3sd": 34.6
    },
    {
        "year": 15,
        "monthByYear": 9,
        "month": 189,
        "name": "15: 9",
        "-3sd": 15,
        "-2sd": 16.4,
        "-1sd": 18.1,
        "Median": 20.3,
        "1sd": 23.3,
        "2sd": 27.7,
        "3sd": 34.6
    },
    {
        "year": 15,
        "monthByYear": 10,
        "month": 190,
        "name": "15:10",
        "-3sd": 15,
        "-2sd": 16.4,
        "-1sd": 18.2,
        "Median": 20.4,
        "1sd": 23.4,
        "2sd": 27.7,
        "3sd": 34.7
    },
    {
        "year": 15,
        "monthByYear": 11,
        "month": 191,
        "name": "15:11",
        "-3sd": 15.1,
        "-2sd": 16.5,
        "-1sd": 18.2,
        "Median": 20.4,
        "1sd": 23.5,
        "2sd": 27.8,
        "3sd": 34.7
    },
    {
        "year": 16,
        "monthByYear": 0,
        "month": 192,
        "name": "16: 0",
        "-3sd": 15.1,
        "-2sd": 16.5,
        "-1sd": 18.2,
        "Median": 20.5,
        "1sd": 23.5,
        "2sd": 27.9,
        "3sd": 34.8
    },
    {
        "year": 16,
        "monthByYear": 1,
        "month": 193,
        "name": "16: 1",
        "-3sd": 15.1,
        "-2sd": 16.5,
        "-1sd": 18.3,
        "Median": 20.6,
        "1sd": 23.6,
        "2sd": 27.9,
        "3sd": 34.8
    },
    {
        "year": 16,
        "monthByYear": 2,
        "month": 194,
        "name": "16: 2",
        "-3sd": 15.2,
        "-2sd": 16.6,
        "-1sd": 18.3,
        "Median": 20.6,
        "1sd": 23.7,
        "2sd": 28,
        "3sd": 34.8
    },
    {
        "year": 16,
        "monthByYear": 3,
        "month": 195,
        "name": "16: 3",
        "-3sd": 15.2,
        "-2sd": 16.6,
        "-1sd": 18.4,
        "Median": 20.7,
        "1sd": 23.7,
        "2sd": 28.1,
        "3sd": 34.9
    },
    {
        "year": 16,
        "monthByYear": 4,
        "month": 196,
        "name": "16: 4",
        "-3sd": 15.2,
        "-2sd": 16.7,
        "-1sd": 18.4,
        "Median": 20.7,
        "1sd": 23.8,
        "2sd": 28.1,
        "3sd": 34.9
    },
    {
        "year": 16,
        "monthByYear": 5,
        "month": 197,
        "name": "16: 5",
        "-3sd": 15.3,
        "-2sd": 16.7,
        "-1sd": 18.5,
        "Median": 20.8,
        "1sd": 23.8,
        "2sd": 28.2,
        "3sd": 35
    },
    {
        "year": 16,
        "monthByYear": 6,
        "month": 198,
        "name": "16: 6",
        "-3sd": 15.3,
        "-2sd": 16.7,
        "-1sd": 18.5,
        "Median": 20.8,
        "1sd": 23.9,
        "2sd": 28.3,
        "3sd": 35
    },
    {
        "year": 16,
        "monthByYear": 7,
        "month": 199,
        "name": "16: 7",
        "-3sd": 15.3,
        "-2sd": 16.8,
        "-1sd": 18.6,
        "Median": 20.9,
        "1sd": 24,
        "2sd": 28.3,
        "3sd": 35
    },
    {
        "year": 16,
        "monthByYear": 8,
        "month": 200,
        "name": "16: 8",
        "-3sd": 15.3,
        "-2sd": 16.8,
        "-1sd": 18.6,
        "Median": 20.9,
        "1sd": 24,
        "2sd": 28.4,
        "3sd": 35.1
    },
    {
        "year": 16,
        "monthByYear": 9,
        "month": 201,
        "name": "16: 9",
        "-3sd": 15.4,
        "-2sd": 16.8,
        "-1sd": 18.7,
        "Median": 21,
        "1sd": 24.1,
        "2sd": 28.5,
        "3sd": 35.1
    },
    {
        "year": 16,
        "monthByYear": 10,
        "month": 202,
        "name": "16:10",
        "-3sd": 15.4,
        "-2sd": 16.9,
        "-1sd": 18.7,
        "Median": 21,
        "1sd": 24.2,
        "2sd": 28.5,
        "3sd": 35.1
    },
    {
        "year": 16,
        "monthByYear": 11,
        "month": 203,
        "name": "16:11",
        "-3sd": 15.4,
        "-2sd": 16.9,
        "-1sd": 18.7,
        "Median": 21.1,
        "1sd": 24.2,
        "2sd": 28.6,
        "3sd": 35.2
    },
    {
        "year": 17,
        "monthByYear": 0,
        "month": 204,
        "name": "17: 0",
        "-3sd": 15.4,
        "-2sd": 16.9,
        "-1sd": 18.8,
        "Median": 21.1,
        "1sd": 24.3,
        "2sd": 28.6,
        "3sd": 35.2
    },
    {
        "year": 17,
        "monthByYear": 1,
        "month": 205,
        "name": "17: 1",
        "-3sd": 15.5,
        "-2sd": 17,
        "-1sd": 18.8,
        "Median": 21.2,
        "1sd": 24.3,
        "2sd": 28.7,
        "3sd": 35.2
    },
    {
        "year": 17,
        "monthByYear": 2,
        "month": 206,
        "name": "17: 2",
        "-3sd": 15.5,
        "-2sd": 17,
        "-1sd": 18.9,
        "Median": 21.2,
        "1sd": 24.4,
        "2sd": 28.7,
        "3sd": 35.2
    },
    {
        "year": 17,
        "monthByYear": 3,
        "month": 207,
        "name": "17: 3",
        "-3sd": 15.5,
        "-2sd": 17,
        "-1sd": 18.9,
        "Median": 21.3,
        "1sd": 24.4,
        "2sd": 28.8,
        "3sd": 35.3
    },
    {
        "year": 17,
        "monthByYear": 4,
        "month": 208,
        "name": "17: 4",
        "-3sd": 15.5,
        "-2sd": 17.1,
        "-1sd": 18.9,
        "Median": 21.3,
        "1sd": 24.5,
        "2sd": 28.9,
        "3sd": 35.3
    },
    {
        "year": 17,
        "monthByYear": 5,
        "month": 209,
        "name": "17: 5",
        "-3sd": 15.6,
        "-2sd": 17.1,
        "-1sd": 19,
        "Median": 21.4,
        "1sd": 24.5,
        "2sd": 28.9,
        "3sd": 35.3
    },
    {
        "year": 17,
        "monthByYear": 6,
        "month": 210,
        "name": "17: 6",
        "-3sd": 15.6,
        "-2sd": 17.1,
        "-1sd": 19,
        "Median": 21.4,
        "1sd": 24.6,
        "2sd": 29,
        "3sd": 35.3
    },
    {
        "year": 17,
        "monthByYear": 7,
        "month": 211,
        "name": "17: 7",
        "-3sd": 15.6,
        "-2sd": 17.1,
        "-1sd": 19.1,
        "Median": 21.5,
        "1sd": 24.7,
        "2sd": 29,
        "3sd": 35.4
    },
    {
        "year": 17,
        "monthByYear": 8,
        "month": 212,
        "name": "17: 8",
        "-3sd": 15.6,
        "-2sd": 17.2,
        "-1sd": 19.1,
        "Median": 21.5,
        "1sd": 24.7,
        "2sd": 29.1,
        "3sd": 35.4
    },
    {
        "year": 17,
        "monthByYear": 9,
        "month": 213,
        "name": "17: 9",
        "-3sd": 15.6,
        "-2sd": 17.2,
        "-1sd": 19.1,
        "Median": 21.6,
        "1sd": 24.8,
        "2sd": 29.1,
        "3sd": 35.4
    },
    {
        "year": 17,
        "monthByYear": 10,
        "month": 214,
        "name": "17:10",
        "-3sd": 15.7,
        "-2sd": 17.2,
        "-1sd": 19.2,
        "Median": 21.6,
        "1sd": 24.8,
        "2sd": 29.2,
        "3sd": 35.4
    },
    {
        "year": 17,
        "monthByYear": 11,
        "month": 215,
        "name": "17:11",
        "-3sd": 15.7,
        "-2sd": 17.3,
        "-1sd": 19.2,
        "Median": 21.7,
        "1sd": 24.9,
        "2sd": 29.2,
        "3sd": 35.4
    },
    {
        "year": 18,
        "monthByYear": 0,
        "month": 216,
        "name": "18: 0",
        "-3sd": 15.7,
        "-2sd": 17.3,
        "-1sd": 19.2,
        "Median": 21.7,
        "1sd": 24.9,
        "2sd": 29.2,
        "3sd": 35.4
    },
    {
        "year": 18,
        "monthByYear": 1,
        "month": 217,
        "name": "18: 1",
        "-3sd": 15.7,
        "-2sd": 17.3,
        "-1sd": 19.3,
        "Median": 21.8,
        "1sd": 25,
        "2sd": 29.3,
        "3sd": 35.4
    },
    {
        "year": 18,
        "monthByYear": 2,
        "month": 218,
        "name": "18: 2",
        "-3sd": 15.7,
        "-2sd": 17.3,
        "-1sd": 19.3,
        "Median": 21.8,
        "1sd": 25,
        "2sd": 29.3,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 3,
        "month": 219,
        "name": "18: 3",
        "-3sd": 15.7,
        "-2sd": 17.4,
        "-1sd": 19.3,
        "Median": 21.8,
        "1sd": 25.1,
        "2sd": 29.4,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 4,
        "month": 220,
        "name": "18: 4",
        "-3sd": 15.8,
        "-2sd": 17.4,
        "-1sd": 19.4,
        "Median": 21.9,
        "1sd": 25.1,
        "2sd": 29.4,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 5,
        "month": 221,
        "name": "18: 5",
        "-3sd": 15.8,
        "-2sd": 17.4,
        "-1sd": 19.4,
        "Median": 21.9,
        "1sd": 25.1,
        "2sd": 29.5,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 6,
        "month": 222,
        "name": "18: 6",
        "-3sd": 15.8,
        "-2sd": 17.4,
        "-1sd": 19.4,
        "Median": 22,
        "1sd": 25.2,
        "2sd": 29.5,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 7,
        "month": 223,
        "name": "18: 7",
        "-3sd": 15.8,
        "-2sd": 17.5,
        "-1sd": 19.5,
        "Median": 22,
        "1sd": 25.2,
        "2sd": 29.5,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 8,
        "month": 224,
        "name": "18: 8",
        "-3sd": 15.8,
        "-2sd": 17.5,
        "-1sd": 19.5,
        "Median": 22,
        "1sd": 25.3,
        "2sd": 29.6,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 9,
        "month": 225,
        "name": "18: 9",
        "-3sd": 15.8,
        "-2sd": 17.5,
        "-1sd": 19.5,
        "Median": 22.1,
        "1sd": 25.3,
        "2sd": 29.6,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 10,
        "month": 226,
        "name": "18:10",
        "-3sd": 15.8,
        "-2sd": 17.5,
        "-1sd": 19.6,
        "Median": 22.1,
        "1sd": 25.4,
        "2sd": 29.6,
        "3sd": 35.5
    },
    {
        "year": 18,
        "monthByYear": 11,
        "month": 227,
        "name": "18:11",
        "-3sd": 15.8,
        "-2sd": 17.5,
        "-1sd": 19.6,
        "Median": 22.2,
        "1sd": 25.4,
        "2sd": 29.7,
        "3sd": 35.5
    },
    {
        "year": 19,
        "monthByYear": 0,
        "month": 228,
        "name": "19: 0",
        "-3sd": 15.9,
        "-2sd": 17.6,
        "-1sd": 19.6,
        "Median": 22.2,
        "1sd": 25.4,
        "2sd": 29.7,
        "3sd": 35.5
    }
]

export const WEIGHT_MALE_5_10 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "-3sd": 12.7,
        "-2sd": 14.4,
        "-1sd": 16.3,
        "Median": 18.5,
        "1sd": 21.1,
        "2sd": 24.2,
        "3sd": 27.8
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "-3sd": 12.8,
        "-2sd": 14.5,
        "-1sd": 16.4,
        "Median": 18.7,
        "1sd": 21.3,
        "2sd": 24.4,
        "3sd": 28.1
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "-3sd": 13,
        "-2sd": 14.6,
        "-1sd": 16.6,
        "Median": 18.9,
        "1sd": 21.5,
        "2sd": 24.7,
        "3sd": 28.4
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "-3sd": 13.1,
        "-2sd": 14.8,
        "-1sd": 16.7,
        "Median": 19,
        "1sd": 21.7,
        "2sd": 24.9,
        "3sd": 28.8
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "-3sd": 13.2,
        "-2sd": 14.9,
        "-1sd": 16.9,
        "Median": 19.2,
        "1sd": 22,
        "2sd": 25.2,
        "3sd": 29.1
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "-3sd": 13.3,
        "-2sd": 15,
        "-1sd": 17,
        "Median": 19.4,
        "1sd": 22.2,
        "2sd": 25.5,
        "3sd": 29.4
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "-3sd": 13.4,
        "-2sd": 15.2,
        "-1sd": 17.2,
        "Median": 19.6,
        "1sd": 22.4,
        "2sd": 25.7,
        "3sd": 29.8
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "-3sd": 13.6,
        "-2sd": 15.3,
        "-1sd": 17.4,
        "Median": 19.8,
        "1sd": 22.6,
        "2sd": 26,
        "3sd": 30.1
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "-3sd": 13.7,
        "-2sd": 15.4,
        "-1sd": 17.5,
        "Median": 19.9,
        "1sd": 22.8,
        "2sd": 26.3,
        "3sd": 30.4
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "-3sd": 13.8,
        "-2sd": 15.6,
        "-1sd": 17.7,
        "Median": 20.1,
        "1sd": 23.1,
        "2sd": 26.6,
        "3sd": 30.8
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "-3sd": 13.9,
        "-2sd": 15.7,
        "-1sd": 17.8,
        "Median": 20.3,
        "1sd": 23.3,
        "2sd": 26.8,
        "3sd": 31.2
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "-3sd": 14.1,
        "-2sd": 15.9,
        "-1sd": 18,
        "Median": 20.5,
        "1sd": 23.5,
        "2sd": 27.1,
        "3sd": 31.5
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "-3sd": 14.2,
        "-2sd": 16,
        "-1sd": 18.2,
        "Median": 20.7,
        "1sd": 23.7,
        "2sd": 27.4,
        "3sd": 31.9
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "-3sd": 14.3,
        "-2sd": 16.2,
        "-1sd": 18.3,
        "Median": 20.9,
        "1sd": 24,
        "2sd": 27.7,
        "3sd": 32.2
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "-3sd": 14.5,
        "-2sd": 16.3,
        "-1sd": 18.5,
        "Median": 21.1,
        "1sd": 24.2,
        "2sd": 28,
        "3sd": 32.6
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "-3sd": 14.6,
        "-2sd": 16.5,
        "-1sd": 18.7,
        "Median": 21.3,
        "1sd": 24.4,
        "2sd": 28.3,
        "3sd": 33
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "-3sd": 14.7,
        "-2sd": 16.6,
        "-1sd": 18.8,
        "Median": 21.5,
        "1sd": 24.7,
        "2sd": 28.6,
        "3sd": 33.3
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "-3sd": 14.9,
        "-2sd": 16.8,
        "-1sd": 19,
        "Median": 21.7,
        "1sd": 24.9,
        "2sd": 28.9,
        "3sd": 33.7
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "-3sd": 15,
        "-2sd": 16.9,
        "-1sd": 19.2,
        "Median": 21.9,
        "1sd": 25.2,
        "2sd": 29.2,
        "3sd": 34.1
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "-3sd": 15.1,
        "-2sd": 17.1,
        "-1sd": 19.3,
        "Median": 22.1,
        "1sd": 25.4,
        "2sd": 29.5,
        "3sd": 34.5
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "-3sd": 15.3,
        "-2sd": 17.2,
        "-1sd": 19.5,
        "Median": 22.3,
        "1sd": 25.6,
        "2sd": 29.8,
        "3sd": 34.9
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "-3sd": 15.4,
        "-2sd": 17.4,
        "-1sd": 19.7,
        "Median": 22.5,
        "1sd": 25.9,
        "2sd": 30.1,
        "3sd": 35.3
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "-3sd": 15.5,
        "-2sd": 17.5,
        "-1sd": 19.9,
        "Median": 22.7,
        "1sd": 26.1,
        "2sd": 30.4,
        "3sd": 35.7
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "-3sd": 15.7,
        "-2sd": 17.7,
        "-1sd": 20,
        "Median": 22.9,
        "1sd": 26.4,
        "2sd": 30.7,
        "3sd": 36.1
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "-3sd": 15.8,
        "-2sd": 17.8,
        "-1sd": 20.2,
        "Median": 23.1,
        "1sd": 26.6,
        "2sd": 31,
        "3sd": 36.5
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "-3sd": 15.9,
        "-2sd": 18,
        "-1sd": 20.4,
        "Median": 23.3,
        "1sd": 26.9,
        "2sd": 31.3,
        "3sd": 36.9
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "-3sd": 16.1,
        "-2sd": 18.1,
        "-1sd": 20.6,
        "Median": 23.5,
        "1sd": 27.1,
        "2sd": 31.7,
        "3sd": 37.4
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "-3sd": 16.2,
        "-2sd": 18.3,
        "-1sd": 20.7,
        "Median": 23.7,
        "1sd": 27.4,
        "2sd": 32,
        "3sd": 37.8
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "-3sd": 16.3,
        "-2sd": 18.4,
        "-1sd": 20.9,
        "Median": 23.9,
        "1sd": 27.7,
        "2sd": 32.3,
        "3sd": 38.2
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "-3sd": 16.5,
        "-2sd": 18.6,
        "-1sd": 21.1,
        "Median": 24.1,
        "1sd": 27.9,
        "2sd": 32.6,
        "3sd": 38.7
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "-3sd": 16.6,
        "-2sd": 18.7,
        "-1sd": 21.3,
        "Median": 24.3,
        "1sd": 28.2,
        "2sd": 33,
        "3sd": 39.1
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "-3sd": 16.7,
        "-2sd": 18.9,
        "-1sd": 21.4,
        "Median": 24.6,
        "1sd": 28.4,
        "2sd": 33.3,
        "3sd": 39.6
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "-3sd": 16.9,
        "-2sd": 19,
        "-1sd": 21.6,
        "Median": 24.8,
        "1sd": 28.7,
        "2sd": 33.7,
        "3sd": 40.1
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "-3sd": 17,
        "-2sd": 19.2,
        "-1sd": 21.8,
        "Median": 25,
        "1sd": 29,
        "2sd": 34,
        "3sd": 40.5
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "-3sd": 17.1,
        "-2sd": 19.3,
        "-1sd": 22,
        "Median": 25.2,
        "1sd": 29.2,
        "2sd": 34.4,
        "3sd": 41
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "-3sd": 17.3,
        "-2sd": 19.5,
        "-1sd": 22.1,
        "Median": 25.4,
        "1sd": 29.5,
        "2sd": 34.7,
        "3sd": 41.5
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "-3sd": 17.4,
        "-2sd": 19.6,
        "-1sd": 22.3,
        "Median": 25.6,
        "1sd": 29.8,
        "2sd": 35.1,
        "3sd": 42
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "-3sd": 17.5,
        "-2sd": 19.8,
        "-1sd": 22.5,
        "Median": 25.9,
        "1sd": 30.1,
        "2sd": 35.5,
        "3sd": 42.5
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "-3sd": 17.7,
        "-2sd": 19.9,
        "-1sd": 22.7,
        "Median": 26.1,
        "1sd": 30.3,
        "2sd": 35.8,
        "3sd": 43.1
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "-3sd": 17.8,
        "-2sd": 20.1,
        "-1sd": 22.9,
        "Median": 26.3,
        "1sd": 30.6,
        "2sd": 36.2,
        "3sd": 43.6
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "-3sd": 17.9,
        "-2sd": 20.2,
        "-1sd": 23,
        "Median": 26.5,
        "1sd": 30.9,
        "2sd": 36.6,
        "3sd": 44.1
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "-3sd": 18.1,
        "-2sd": 20.4,
        "-1sd": 23.2,
        "Median": 26.7,
        "1sd": 31.2,
        "2sd": 37,
        "3sd": 44.7
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "-3sd": 18.2,
        "-2sd": 20.5,
        "-1sd": 23.4,
        "Median": 27,
        "1sd": 31.5,
        "2sd": 37.4,
        "3sd": 45.2
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "-3sd": 18.3,
        "-2sd": 20.7,
        "-1sd": 23.6,
        "Median": 27.2,
        "1sd": 31.8,
        "2sd": 37.8,
        "3sd": 45.8
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "-3sd": 18.4,
        "-2sd": 20.8,
        "-1sd": 23.8,
        "Median": 27.4,
        "1sd": 32.1,
        "2sd": 38.2,
        "3sd": 46.4
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "-3sd": 18.6,
        "-2sd": 21,
        "-1sd": 23.9,
        "Median": 27.6,
        "1sd": 32.4,
        "2sd": 38.6,
        "3sd": 47
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "-3sd": 18.7,
        "-2sd": 21.1,
        "-1sd": 24.1,
        "Median": 27.9,
        "1sd": 32.7,
        "2sd": 39,
        "3sd": 47.6
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "-3sd": 18.8,
        "-2sd": 21.3,
        "-1sd": 24.3,
        "Median": 28.1,
        "1sd": 33,
        "2sd": 39.4,
        "3sd": 48.2
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "-3sd": 18.9,
        "-2sd": 21.4,
        "-1sd": 24.5,
        "Median": 28.3,
        "1sd": 33.3,
        "2sd": 39.9,
        "3sd": 48.8
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "-3sd": 19.1,
        "-2sd": 21.6,
        "-1sd": 24.7,
        "Median": 28.6,
        "1sd": 33.6,
        "2sd": 40.3,
        "3sd": 49.5
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "-3sd": 19.2,
        "-2sd": 21.7,
        "-1sd": 24.9,
        "Median": 28.8,
        "1sd": 33.9,
        "2sd": 40.7,
        "3sd": 50.1
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "-3sd": 19.3,
        "-2sd": 21.9,
        "-1sd": 25.1,
        "Median": 29.1,
        "1sd": 34.3,
        "2sd": 41.2,
        "3sd": 50.8
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "-3sd": 19.5,
        "-2sd": 22.1,
        "-1sd": 25.3,
        "Median": 29.3,
        "1sd": 34.6,
        "2sd": 41.7,
        "3sd": 51.5
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "-3sd": 19.6,
        "-2sd": 22.2,
        "-1sd": 25.5,
        "Median": 29.6,
        "1sd": 34.9,
        "2sd": 42.1,
        "3sd": 52.1
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "-3sd": 19.7,
        "-2sd": 22.4,
        "-1sd": 25.7,
        "Median": 29.8,
        "1sd": 35.3,
        "2sd": 42.6,
        "3sd": 52.8
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "-3sd": 19.9,
        "-2sd": 22.5,
        "-1sd": 25.9,
        "Median": 30.1,
        "1sd": 35.6,
        "2sd": 43.1,
        "3sd": 53.5
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "-3sd": 20,
        "-2sd": 22.7,
        "-1sd": 26.1,
        "Median": 30.4,
        "1sd": 36,
        "2sd": 43.5,
        "3sd": 54.2
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "-3sd": 20.1,
        "-2sd": 22.9,
        "-1sd": 26.3,
        "Median": 30.6,
        "1sd": 36.3,
        "2sd": 44,
        "3sd": 55
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "-3sd": 20.3,
        "-2sd": 23,
        "-1sd": 26.5,
        "Median": 30.9,
        "1sd": 36.7,
        "2sd": 44.5,
        "3sd": 55.7
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "-3sd": 20.4,
        "-2sd": 23.2,
        "-1sd": 26.7,
        "Median": 31.2,
        "1sd": 37,
        "2sd": 45,
        "3sd": 56.4
    }
]

export const HEIGHT_MALE_5_19 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "sd": 4.5914,
        "-3sd": 96.5,
        "-2sd": 101.1,
        "-1sd": 105.7,
        "Median": 110.3,
        "1sd": 114.9,
        "2sd": 119.4,
        "3sd": 124
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "sd": 4.6226,
        "-3sd": 96.9,
        "-2sd": 101.6,
        "-1sd": 106.2,
        "Median": 110.8,
        "1sd": 115.4,
        "2sd": 120,
        "3sd": 124.7
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "sd": 4.6538,
        "-3sd": 97.4,
        "-2sd": 102,
        "-1sd": 106.7,
        "Median": 111.3,
        "1sd": 116,
        "2sd": 120.6,
        "3sd": 125.3
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "sd": 4.6837,
        "-3sd": 97.8,
        "-2sd": 102.5,
        "-1sd": 107.2,
        "Median": 111.9,
        "1sd": 116.5,
        "2sd": 121.2,
        "3sd": 125.9
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "sd": 4.7147,
        "-3sd": 98.2,
        "-2sd": 103,
        "-1sd": 107.7,
        "Median": 112.4,
        "1sd": 117.1,
        "2sd": 121.8,
        "3sd": 126.5
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "sd": 4.7456,
        "-3sd": 98.7,
        "-2sd": 103.4,
        "-1sd": 108.2,
        "Median": 112.9,
        "1sd": 117.7,
        "2sd": 122.4,
        "3sd": 127.1
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "sd": 4.7765,
        "-3sd": 99.1,
        "-2sd": 103.9,
        "-1sd": 108.7,
        "Median": 113.4,
        "1sd": 118.2,
        "2sd": 123,
        "3sd": 127.8
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "sd": 4.806,
        "-3sd": 99.5,
        "-2sd": 104.3,
        "-1sd": 109.1,
        "Median": 113.9,
        "1sd": 118.7,
        "2sd": 123.6,
        "3sd": 128.4
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "sd": 4.8367,
        "-3sd": 99.9,
        "-2sd": 104.8,
        "-1sd": 109.6,
        "Median": 114.5,
        "1sd": 119.3,
        "2sd": 124.1,
        "3sd": 129
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "sd": 4.8672,
        "-3sd": 100.4,
        "-2sd": 105.2,
        "-1sd": 110.1,
        "Median": 115,
        "1sd": 119.8,
        "2sd": 124.7,
        "3sd": 129.6
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "sd": 4.8964,
        "-3sd": 100.8,
        "-2sd": 105.7,
        "-1sd": 110.6,
        "Median": 115.5,
        "1sd": 120.4,
        "2sd": 125.2,
        "3sd": 130.1
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "sd": 4.9268,
        "-3sd": 101.2,
        "-2sd": 106.1,
        "-1sd": 111,
        "Median": 116,
        "1sd": 120.9,
        "2sd": 125.8,
        "3sd": 130.7
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "sd": 4.957,
        "-3sd": 101.6,
        "-2sd": 106.5,
        "-1sd": 111.5,
        "Median": 116.4,
        "1sd": 121.4,
        "2sd": 126.4,
        "3sd": 131.3
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "sd": 4.986,
        "-3sd": 102,
        "-2sd": 107,
        "-1sd": 111.9,
        "Median": 116.9,
        "1sd": 121.9,
        "2sd": 126.9,
        "3sd": 131.9
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "sd": 5.0162,
        "-3sd": 102.4,
        "-2sd": 107.4,
        "-1sd": 112.4,
        "Median": 117.4,
        "1sd": 122.4,
        "2sd": 127.5,
        "3sd": 132.5
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "sd": 5.0463,
        "-3sd": 102.8,
        "-2sd": 107.8,
        "-1sd": 112.9,
        "Median": 117.9,
        "1sd": 123,
        "2sd": 128,
        "3sd": 133
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "sd": 5.0753,
        "-3sd": 103.2,
        "-2sd": 108.2,
        "-1sd": 113.3,
        "Median": 118.4,
        "1sd": 123.5,
        "2sd": 128.5,
        "3sd": 133.6
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "sd": 5.1055,
        "-3sd": 103.6,
        "-2sd": 108.7,
        "-1sd": 113.8,
        "Median": 118.9,
        "1sd": 124,
        "2sd": 129.1,
        "3sd": 134.2
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "sd": 5.1357,
        "-3sd": 103.9,
        "-2sd": 109.1,
        "-1sd": 114.2,
        "Median": 119.4,
        "1sd": 124.5,
        "2sd": 129.6,
        "3sd": 134.8
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "sd": 5.1659,
        "-3sd": 104.3,
        "-2sd": 109.5,
        "-1sd": 114.7,
        "Median": 119.8,
        "1sd": 125,
        "2sd": 130.2,
        "3sd": 135.3
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "sd": 5.1949,
        "-3sd": 104.7,
        "-2sd": 109.9,
        "-1sd": 115.1,
        "Median": 120.3,
        "1sd": 125.5,
        "2sd": 130.7,
        "3sd": 135.9
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "sd": 5.2252,
        "-3sd": 105.1,
        "-2sd": 110.3,
        "-1sd": 115.6,
        "Median": 120.8,
        "1sd": 126,
        "2sd": 131.2,
        "3sd": 136.5
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "sd": 5.2554,
        "-3sd": 105.5,
        "-2sd": 110.8,
        "-1sd": 116,
        "Median": 121.3,
        "1sd": 126.5,
        "2sd": 131.8,
        "3sd": 137
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "sd": 5.2857,
        "-3sd": 105.9,
        "-2sd": 111.2,
        "-1sd": 116.4,
        "Median": 121.7,
        "1sd": 127,
        "2sd": 132.3,
        "3sd": 137.6
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "sd": 5.3159,
        "-3sd": 106.3,
        "-2sd": 111.6,
        "-1sd": 116.9,
        "Median": 122.2,
        "1sd": 127.5,
        "2sd": 132.8,
        "3sd": 138.2
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "sd": 5.3462,
        "-3sd": 106.6,
        "-2sd": 112,
        "-1sd": 117.3,
        "Median": 122.7,
        "1sd": 128,
        "2sd": 133.4,
        "3sd": 138.7
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "sd": 5.3764,
        "-3sd": 107,
        "-2sd": 112.4,
        "-1sd": 117.8,
        "Median": 123.1,
        "1sd": 128.5,
        "2sd": 133.9,
        "3sd": 139.3
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "sd": 5.4067,
        "-3sd": 107.4,
        "-2sd": 112.8,
        "-1sd": 118.2,
        "Median": 123.6,
        "1sd": 129,
        "2sd": 134.4,
        "3sd": 139.8
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "sd": 5.4369,
        "-3sd": 107.8,
        "-2sd": 113.2,
        "-1sd": 118.6,
        "Median": 124.1,
        "1sd": 129.5,
        "2sd": 134.9,
        "3sd": 140.4
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "sd": 5.4671,
        "-3sd": 108.1,
        "-2sd": 113.6,
        "-1sd": 119.1,
        "Median": 124.5,
        "1sd": 130,
        "2sd": 135.5,
        "3sd": 140.9
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "sd": 5.4973,
        "-3sd": 108.5,
        "-2sd": 114,
        "-1sd": 119.5,
        "Median": 125,
        "1sd": 130.5,
        "2sd": 136,
        "3sd": 141.5
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "sd": 5.5275,
        "-3sd": 108.9,
        "-2sd": 114.4,
        "-1sd": 119.9,
        "Median": 125.5,
        "1sd": 131,
        "2sd": 136.5,
        "3sd": 142
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "sd": 5.5577,
        "-3sd": 109.2,
        "-2sd": 114.8,
        "-1sd": 120.4,
        "Median": 125.9,
        "1sd": 131.5,
        "2sd": 137,
        "3sd": 142.6
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "sd": 5.5878,
        "-3sd": 109.6,
        "-2sd": 115.2,
        "-1sd": 120.8,
        "Median": 126.4,
        "1sd": 132,
        "2sd": 137.5,
        "3sd": 143.1
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "sd": 5.6179,
        "-3sd": 110,
        "-2sd": 115.6,
        "-1sd": 121.2,
        "Median": 126.8,
        "1sd": 132.4,
        "2sd": 138.1,
        "3sd": 143.7
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "sd": 5.648,
        "-3sd": 110.3,
        "-2sd": 116,
        "-1sd": 121.6,
        "Median": 127.3,
        "1sd": 132.9,
        "2sd": 138.6,
        "3sd": 144.2
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "sd": 5.6781,
        "-3sd": 110.7,
        "-2sd": 116.4,
        "-1sd": 122,
        "Median": 127.7,
        "1sd": 133.4,
        "2sd": 139.1,
        "3sd": 144.7
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "sd": 5.7082,
        "-3sd": 111,
        "-2sd": 116.7,
        "-1sd": 122.5,
        "Median": 128.2,
        "1sd": 133.9,
        "2sd": 139.6,
        "3sd": 145.3
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "sd": 5.7383,
        "-3sd": 111.4,
        "-2sd": 117.1,
        "-1sd": 122.9,
        "Median": 128.6,
        "1sd": 134.3,
        "2sd": 140.1,
        "3sd": 145.8
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "sd": 5.7684,
        "-3sd": 111.7,
        "-2sd": 117.5,
        "-1sd": 123.3,
        "Median": 129,
        "1sd": 134.8,
        "2sd": 140.6,
        "3sd": 146.4
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "sd": 5.7985,
        "-3sd": 112.1,
        "-2sd": 117.9,
        "-1sd": 123.7,
        "Median": 129.5,
        "1sd": 135.3,
        "2sd": 141.1,
        "3sd": 146.9
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "sd": 5.83,
        "-3sd": 112.4,
        "-2sd": 118.3,
        "-1sd": 124.1,
        "Median": 129.9,
        "1sd": 135.8,
        "2sd": 141.6,
        "3sd": 147.4
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "sd": 5.8602,
        "-3sd": 112.8,
        "-2sd": 118.7,
        "-1sd": 124.5,
        "Median": 130.4,
        "1sd": 136.2,
        "2sd": 142.1,
        "3sd": 148
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "sd": 5.8904,
        "-3sd": 113.1,
        "-2sd": 119,
        "-1sd": 124.9,
        "Median": 130.8,
        "1sd": 136.7,
        "2sd": 142.6,
        "3sd": 148.5
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "sd": 5.9207,
        "-3sd": 113.5,
        "-2sd": 119.4,
        "-1sd": 125.3,
        "Median": 131.3,
        "1sd": 137.2,
        "2sd": 143.1,
        "3sd": 149
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "sd": 5.951,
        "-3sd": 113.8,
        "-2sd": 119.8,
        "-1sd": 125.7,
        "Median": 131.7,
        "1sd": 137.6,
        "2sd": 143.6,
        "3sd": 149.5
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "sd": 5.9814,
        "-3sd": 114.2,
        "-2sd": 120.2,
        "-1sd": 126.1,
        "Median": 132.1,
        "1sd": 138.1,
        "2sd": 144.1,
        "3sd": 150.1
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "sd": 6.0118,
        "-3sd": 114.5,
        "-2sd": 120.5,
        "-1sd": 126.6,
        "Median": 132.6,
        "1sd": 138.6,
        "2sd": 144.6,
        "3sd": 150.6
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "sd": 6.0423,
        "-3sd": 114.9,
        "-2sd": 120.9,
        "-1sd": 127,
        "Median": 133,
        "1sd": 139,
        "2sd": 145.1,
        "3sd": 151.1
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "sd": 6.0729,
        "-3sd": 115.2,
        "-2sd": 121.3,
        "-1sd": 127.4,
        "Median": 133.4,
        "1sd": 139.5,
        "2sd": 145.6,
        "3sd": 151.7
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "sd": 6.1035,
        "-3sd": 115.6,
        "-2sd": 121.7,
        "-1sd": 127.8,
        "Median": 133.9,
        "1sd": 140,
        "2sd": 146.1,
        "3sd": 152.2
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "sd": 6.1327,
        "-3sd": 115.9,
        "-2sd": 122,
        "-1sd": 128.2,
        "Median": 134.3,
        "1sd": 140.4,
        "2sd": 146.6,
        "3sd": 152.7
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "sd": 6.1634,
        "-3sd": 116.3,
        "-2sd": 122.4,
        "-1sd": 128.6,
        "Median": 134.7,
        "1sd": 140.9,
        "2sd": 147.1,
        "3sd": 153.2
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "sd": 6.1941,
        "-3sd": 116.6,
        "-2sd": 122.8,
        "-1sd": 129,
        "Median": 135.2,
        "1sd": 141.4,
        "2sd": 147.6,
        "3sd": 153.8
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "sd": 6.2235,
        "-3sd": 116.9,
        "-2sd": 123.2,
        "-1sd": 129.4,
        "Median": 135.6,
        "1sd": 141.8,
        "2sd": 148.1,
        "3sd": 154.3
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "sd": 6.2542,
        "-3sd": 117.3,
        "-2sd": 123.5,
        "-1sd": 129.8,
        "Median": 136.1,
        "1sd": 142.3,
        "2sd": 148.6,
        "3sd": 154.8
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "sd": 6.2837,
        "-3sd": 117.6,
        "-2sd": 123.9,
        "-1sd": 130.2,
        "Median": 136.5,
        "1sd": 142.8,
        "2sd": 149.1,
        "3sd": 155.3
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "sd": 6.3145,
        "-3sd": 118,
        "-2sd": 124.3,
        "-1sd": 130.6,
        "Median": 136.9,
        "1sd": 143.2,
        "2sd": 149.5,
        "3sd": 155.9
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "sd": 6.3441,
        "-3sd": 118.3,
        "-2sd": 124.7,
        "-1sd": 131,
        "Median": 137.3,
        "1sd": 143.7,
        "2sd": 150,
        "3sd": 156.4
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "sd": 6.3737,
        "-3sd": 118.7,
        "-2sd": 125,
        "-1sd": 131.4,
        "Median": 137.8,
        "1sd": 144.2,
        "2sd": 150.5,
        "3sd": 156.9
    },
    {
        "year": 10,
        "monthByYear": 1,
        "month": 121,
        "name": "10: 1",
        "sd": 6.4034,
        "-3sd": 119,
        "-2sd": 125.4,
        "-1sd": 131.8,
        "Median": 138.2,
        "1sd": 144.6,
        "2sd": 151,
        "3sd": 157.4
    },
    {
        "year": 10,
        "monthByYear": 2,
        "month": 122,
        "name": "10: 2",
        "sd": 6.4331,
        "-3sd": 119.3,
        "-2sd": 125.8,
        "-1sd": 132.2,
        "Median": 138.6,
        "1sd": 145.1,
        "2sd": 151.5,
        "3sd": 157.9
    },
    {
        "year": 10,
        "monthByYear": 3,
        "month": 123,
        "name": "10: 3",
        "sd": 6.463,
        "-3sd": 119.7,
        "-2sd": 126.2,
        "-1sd": 132.6,
        "Median": 139.1,
        "1sd": 145.5,
        "2sd": 152,
        "3sd": 158.5
    },
    {
        "year": 10,
        "monthByYear": 4,
        "month": 124,
        "name": "10: 4",
        "sd": 6.4931,
        "-3sd": 120,
        "-2sd": 126.5,
        "-1sd": 133,
        "Median": 139.5,
        "1sd": 146,
        "2sd": 152.5,
        "3sd": 159
    },
    {
        "year": 10,
        "monthByYear": 5,
        "month": 125,
        "name": "10: 5",
        "sd": 6.5233,
        "-3sd": 120.4,
        "-2sd": 126.9,
        "-1sd": 133.4,
        "Median": 140,
        "1sd": 146.5,
        "2sd": 153,
        "3sd": 159.5
    },
    {
        "year": 10,
        "monthByYear": 6,
        "month": 126,
        "name": "10: 6",
        "sd": 6.5522,
        "-3sd": 120.7,
        "-2sd": 127.3,
        "-1sd": 133.8,
        "Median": 140.4,
        "1sd": 146.9,
        "2sd": 153.5,
        "3sd": 160.1
    },
    {
        "year": 10,
        "monthByYear": 7,
        "month": 127,
        "name": "10: 7",
        "sd": 6.5828,
        "-3sd": 121.1,
        "-2sd": 127.7,
        "-1sd": 134.3,
        "Median": 140.8,
        "1sd": 147.4,
        "2sd": 154,
        "3sd": 160.6
    },
    {
        "year": 10,
        "monthByYear": 8,
        "month": 128,
        "name": "10: 8",
        "sd": 6.6122,
        "-3sd": 121.4,
        "-2sd": 128.1,
        "-1sd": 134.7,
        "Median": 141.3,
        "1sd": 147.9,
        "2sd": 154.5,
        "3sd": 161.1
    },
    {
        "year": 10,
        "monthByYear": 9,
        "month": 129,
        "name": "10: 9",
        "sd": 6.6418,
        "-3sd": 121.8,
        "-2sd": 128.5,
        "-1sd": 135.1,
        "Median": 141.7,
        "1sd": 148.4,
        "2sd": 155,
        "3sd": 161.7
    },
    {
        "year": 10,
        "monthByYear": 10,
        "month": 130,
        "name": "10:10",
        "sd": 6.6716,
        "-3sd": 122.2,
        "-2sd": 128.8,
        "-1sd": 135.5,
        "Median": 142.2,
        "1sd": 148.9,
        "2sd": 155.5,
        "3sd": 162.2
    },
    {
        "year": 10,
        "monthByYear": 11,
        "month": 131,
        "name": "10:11",
        "sd": 6.7017,
        "-3sd": 122.5,
        "-2sd": 129.2,
        "-1sd": 135.9,
        "Median": 142.7,
        "1sd": 149.4,
        "2sd": 156.1,
        "3sd": 162.8
    },
    {
        "year": 11,
        "monthByYear": 0,
        "month": 132,
        "name": "11: 0",
        "sd": 6.7306,
        "-3sd": 122.9,
        "-2sd": 129.7,
        "-1sd": 136.4,
        "Median": 143.1,
        "1sd": 149.8,
        "2sd": 156.6,
        "3sd": 163.3
    },
    {
        "year": 11,
        "monthByYear": 1,
        "month": 133,
        "name": "11: 1",
        "sd": 6.7612,
        "-3sd": 123.3,
        "-2sd": 130.1,
        "-1sd": 136.8,
        "Median": 143.6,
        "1sd": 150.3,
        "2sd": 157.1,
        "3sd": 163.9
    },
    {
        "year": 11,
        "monthByYear": 2,
        "month": 134,
        "name": "11: 2",
        "sd": 6.7906,
        "-3sd": 123.7,
        "-2sd": 130.5,
        "-1sd": 137.3,
        "Median": 144.1,
        "1sd": 150.8,
        "2sd": 157.6,
        "3sd": 164.4
    },
    {
        "year": 11,
        "monthByYear": 3,
        "month": 135,
        "name": "11: 3",
        "sd": 6.8203,
        "-3sd": 124.1,
        "-2sd": 130.9,
        "-1sd": 137.7,
        "Median": 144.5,
        "1sd": 151.3,
        "2sd": 158.2,
        "3sd": 165
    },
    {
        "year": 11,
        "monthByYear": 4,
        "month": 136,
        "name": "11: 4",
        "sd": 6.8488,
        "-3sd": 124.5,
        "-2sd": 131.3,
        "-1sd": 138.2,
        "Median": 145,
        "1sd": 151.9,
        "2sd": 158.7,
        "3sd": 165.6
    },
    {
        "year": 11,
        "monthByYear": 5,
        "month": 137,
        "name": "11: 5",
        "sd": 6.8791,
        "-3sd": 124.9,
        "-2sd": 131.7,
        "-1sd": 138.6,
        "Median": 145.5,
        "1sd": 152.4,
        "2sd": 159.3,
        "3sd": 166.1
    },
    {
        "year": 11,
        "monthByYear": 6,
        "month": 138,
        "name": "11: 6",
        "sd": 6.9082,
        "-3sd": 125.3,
        "-2sd": 132.2,
        "-1sd": 139.1,
        "Median": 146,
        "1sd": 152.9,
        "2sd": 159.8,
        "3sd": 166.7
    },
    {
        "year": 11,
        "monthByYear": 7,
        "month": 139,
        "name": "11: 7",
        "sd": 6.9377,
        "-3sd": 125.7,
        "-2sd": 132.6,
        "-1sd": 139.6,
        "Median": 146.5,
        "1sd": 153.4,
        "2sd": 160.4,
        "3sd": 167.3
    },
    {
        "year": 11,
        "monthByYear": 8,
        "month": 140,
        "name": "11: 8",
        "sd": 6.9675,
        "-3sd": 126.1,
        "-2sd": 133.1,
        "-1sd": 140,
        "Median": 147,
        "1sd": 154,
        "2sd": 160.9,
        "3sd": 167.9
    },
    {
        "year": 11,
        "monthByYear": 9,
        "month": 141,
        "name": "11: 9",
        "sd": 6.9976,
        "-3sd": 126.5,
        "-2sd": 133.5,
        "-1sd": 140.5,
        "Median": 147.5,
        "1sd": 154.5,
        "2sd": 161.5,
        "3sd": 168.5
    },
    {
        "year": 11,
        "monthByYear": 10,
        "month": 142,
        "name": "11:10",
        "sd": 7.0266,
        "-3sd": 126.9,
        "-2sd": 134,
        "-1sd": 141,
        "Median": 148,
        "1sd": 155,
        "2sd": 162.1,
        "3sd": 169.1
    },
    {
        "year": 11,
        "monthByYear": 11,
        "month": 143,
        "name": "11:11",
        "sd": 7.056,
        "-3sd": 127.4,
        "-2sd": 134.4,
        "-1sd": 141.5,
        "Median": 148.5,
        "1sd": 155.6,
        "2sd": 162.7,
        "3sd": 169.7
    },
    {
        "year": 12,
        "monthByYear": 0,
        "month": 144,
        "name": "12: 0",
        "sd": 7.0858,
        "-3sd": 127.8,
        "-2sd": 134.9,
        "-1sd": 142,
        "Median": 149.1,
        "1sd": 156.2,
        "2sd": 163.3,
        "3sd": 170.3
    },
    {
        "year": 12,
        "monthByYear": 1,
        "month": 145,
        "name": "12: 1",
        "sd": 7.1145,
        "-3sd": 128.3,
        "-2sd": 135.4,
        "-1sd": 142.5,
        "Median": 149.6,
        "1sd": 156.7,
        "2sd": 163.9,
        "3sd": 171
    },
    {
        "year": 12,
        "monthByYear": 2,
        "month": 146,
        "name": "12: 2",
        "sd": 7.1451,
        "-3sd": 128.7,
        "-2sd": 135.9,
        "-1sd": 143,
        "Median": 150.2,
        "1sd": 157.3,
        "2sd": 164.5,
        "3sd": 171.6
    },
    {
        "year": 12,
        "monthByYear": 3,
        "month": 147,
        "name": "12: 3",
        "sd": 7.173,
        "-3sd": 129.2,
        "-2sd": 136.4,
        "-1sd": 143.6,
        "Median": 150.7,
        "1sd": 157.9,
        "2sd": 165.1,
        "3sd": 172.2
    },
    {
        "year": 12,
        "monthByYear": 4,
        "month": 148,
        "name": "12: 4",
        "sd": 7.2029,
        "-3sd": 129.7,
        "-2sd": 136.9,
        "-1sd": 144.1,
        "Median": 151.3,
        "1sd": 158.5,
        "2sd": 165.7,
        "3sd": 172.9
    },
    {
        "year": 12,
        "monthByYear": 5,
        "month": 149,
        "name": "12: 5",
        "sd": 7.2317,
        "-3sd": 130.2,
        "-2sd": 137.4,
        "-1sd": 144.6,
        "Median": 151.9,
        "1sd": 159.1,
        "2sd": 166.3,
        "3sd": 173.6
    },
    {
        "year": 12,
        "monthByYear": 6,
        "month": 150,
        "name": "12: 6",
        "sd": 7.2608,
        "-3sd": 130.7,
        "-2sd": 137.9,
        "-1sd": 145.2,
        "Median": 152.4,
        "1sd": 159.7,
        "2sd": 167,
        "3sd": 174.2
    },
    {
        "year": 12,
        "monthByYear": 7,
        "month": 151,
        "name": "12: 7",
        "sd": 7.2888,
        "-3sd": 131.2,
        "-2sd": 138.5,
        "-1sd": 145.7,
        "Median": 153,
        "1sd": 160.3,
        "2sd": 167.6,
        "3sd": 174.9
    },
    {
        "year": 12,
        "monthByYear": 8,
        "month": 152,
        "name": "12: 8",
        "sd": 7.3186,
        "-3sd": 131.7,
        "-2sd": 139,
        "-1sd": 146.3,
        "Median": 153.6,
        "1sd": 160.9,
        "2sd": 168.3,
        "3sd": 175.6
    },
    {
        "year": 12,
        "monthByYear": 9,
        "month": 153,
        "name": "12: 9",
        "sd": 7.3456,
        "-3sd": 132.2,
        "-2sd": 139.5,
        "-1sd": 146.9,
        "Median": 154.2,
        "1sd": 161.6,
        "2sd": 168.9,
        "3sd": 176.3
    },
    {
        "year": 12,
        "monthByYear": 10,
        "month": 154,
        "name": "12:10",
        "sd": 7.3744,
        "-3sd": 132.7,
        "-2sd": 140.1,
        "-1sd": 147.5,
        "Median": 154.8,
        "1sd": 162.2,
        "2sd": 169.6,
        "3sd": 176.9
    },
    {
        "year": 12,
        "monthByYear": 11,
        "month": 155,
        "name": "12:11",
        "sd": 7.4017,
        "-3sd": 133.2,
        "-2sd": 140.6,
        "-1sd": 148,
        "Median": 155.4,
        "1sd": 162.8,
        "2sd": 170.2,
        "3sd": 177.6
    },
    {
        "year": 13,
        "monthByYear": 0,
        "month": 156,
        "name": "13: 0",
        "sd": 7.4276,
        "-3sd": 133.8,
        "-2sd": 141.2,
        "-1sd": 148.6,
        "Median": 156,
        "1sd": 163.5,
        "2sd": 170.9,
        "3sd": 178.3
    },
    {
        "year": 13,
        "monthByYear": 1,
        "month": 157,
        "name": "13: 1",
        "sd": 7.4536,
        "-3sd": 134.3,
        "-2sd": 141.7,
        "-1sd": 149.2,
        "Median": 156.7,
        "1sd": 164.1,
        "2sd": 171.6,
        "3sd": 179
    },
    {
        "year": 13,
        "monthByYear": 2,
        "month": 158,
        "name": "13: 2",
        "sd": 7.4796,
        "-3sd": 134.8,
        "-2sd": 142.3,
        "-1sd": 149.8,
        "Median": 157.3,
        "1sd": 164.7,
        "2sd": 172.2,
        "3sd": 179.7
    },
    {
        "year": 13,
        "monthByYear": 3,
        "month": 159,
        "name": "13: 3",
        "sd": 7.5055,
        "-3sd": 135.4,
        "-2sd": 142.9,
        "-1sd": 150.4,
        "Median": 157.9,
        "1sd": 165.4,
        "2sd": 172.9,
        "3sd": 180.4
    },
    {
        "year": 13,
        "monthByYear": 4,
        "month": 160,
        "name": "13: 4",
        "sd": 7.5297,
        "-3sd": 135.9,
        "-2sd": 143.4,
        "-1sd": 151,
        "Median": 158.5,
        "1sd": 166,
        "2sd": 173.5,
        "3sd": 181.1
    },
    {
        "year": 13,
        "monthByYear": 5,
        "month": 161,
        "name": "13: 5",
        "sd": 7.5522,
        "-3sd": 136.4,
        "-2sd": 144,
        "-1sd": 151.5,
        "Median": 159.1,
        "1sd": 166.6,
        "2sd": 174.2,
        "3sd": 181.8
    },
    {
        "year": 13,
        "monthByYear": 6,
        "month": 162,
        "name": "13: 6",
        "sd": 7.576,
        "-3sd": 137,
        "-2sd": 144.5,
        "-1sd": 152.1,
        "Median": 159.7,
        "1sd": 167.3,
        "2sd": 174.8,
        "3sd": 182.4
    },
    {
        "year": 13,
        "monthByYear": 7,
        "month": 163,
        "name": "13: 7",
        "sd": 7.5979,
        "-3sd": 137.5,
        "-2sd": 145.1,
        "-1sd": 152.7,
        "Median": 160.3,
        "1sd": 167.9,
        "2sd": 175.5,
        "3sd": 183.1
    },
    {
        "year": 13,
        "monthByYear": 8,
        "month": 164,
        "name": "13: 8",
        "sd": 7.618,
        "-3sd": 138,
        "-2sd": 145.7,
        "-1sd": 153.3,
        "Median": 160.9,
        "1sd": 168.5,
        "2sd": 176.1,
        "3sd": 183.7
    },
    {
        "year": 13,
        "monthByYear": 9,
        "month": 165,
        "name": "13: 9",
        "sd": 7.6376,
        "-3sd": 138.6,
        "-2sd": 146.2,
        "-1sd": 153.8,
        "Median": 161.5,
        "1sd": 169.1,
        "2sd": 176.7,
        "3sd": 184.4
    },
    {
        "year": 13,
        "monthByYear": 10,
        "month": 166,
        "name": "13:10",
        "sd": 7.6569,
        "-3sd": 139.1,
        "-2sd": 146.7,
        "-1sd": 154.4,
        "Median": 162.1,
        "1sd": 169.7,
        "2sd": 177.4,
        "3sd": 185
    },
    {
        "year": 13,
        "monthByYear": 11,
        "month": 167,
        "name": "13:11",
        "sd": 7.6757,
        "-3sd": 139.6,
        "-2sd": 147.3,
        "-1sd": 154.9,
        "Median": 162.6,
        "1sd": 170.3,
        "2sd": 178,
        "3sd": 185.6
    },
    {
        "year": 14,
        "monthByYear": 0,
        "month": 168,
        "name": "14: 0",
        "sd": 7.6924,
        "-3sd": 140.1,
        "-2sd": 147.8,
        "-1sd": 155.5,
        "Median": 163.2,
        "1sd": 170.9,
        "2sd": 178.6,
        "3sd": 186.3
    },
    {
        "year": 14,
        "monthByYear": 1,
        "month": 169,
        "name": "14: 1",
        "sd": 7.7069,
        "-3sd": 140.6,
        "-2sd": 148.3,
        "-1sd": 156,
        "Median": 163.7,
        "1sd": 171.4,
        "2sd": 179.1,
        "3sd": 186.9
    },
    {
        "year": 14,
        "monthByYear": 2,
        "month": 170,
        "name": "14: 2",
        "sd": 7.7224,
        "-3sd": 141.1,
        "-2sd": 148.8,
        "-1sd": 156.5,
        "Median": 164.3,
        "1sd": 172,
        "2sd": 179.7,
        "3sd": 187.4
    },
    {
        "year": 14,
        "monthByYear": 3,
        "month": 171,
        "name": "14: 3",
        "sd": 7.7357,
        "-3sd": 141.6,
        "-2sd": 149.3,
        "-1sd": 157.1,
        "Median": 164.8,
        "1sd": 172.5,
        "2sd": 180.3,
        "3sd": 188
    },
    {
        "year": 14,
        "monthByYear": 4,
        "month": 172,
        "name": "14: 4",
        "sd": 7.7483,
        "-3sd": 142.1,
        "-2sd": 149.8,
        "-1sd": 157.6,
        "Median": 165.3,
        "1sd": 173.1,
        "2sd": 180.8,
        "3sd": 188.6
    },
    {
        "year": 14,
        "monthByYear": 5,
        "month": 173,
        "name": "14: 5",
        "sd": 7.7586,
        "-3sd": 142.5,
        "-2sd": 150.3,
        "-1sd": 158.1,
        "Median": 165.8,
        "1sd": 173.6,
        "2sd": 181.3,
        "3sd": 189.1
    },
    {
        "year": 14,
        "monthByYear": 6,
        "month": 174,
        "name": "14: 6",
        "sd": 7.7681,
        "-3sd": 143,
        "-2sd": 150.8,
        "-1sd": 158.5,
        "Median": 166.3,
        "1sd": 174.1,
        "2sd": 181.8,
        "3sd": 189.6
    },
    {
        "year": 14,
        "monthByYear": 7,
        "month": 175,
        "name": "14: 7",
        "sd": 7.7769,
        "-3sd": 143.4,
        "-2sd": 151.2,
        "-1sd": 159,
        "Median": 166.8,
        "1sd": 174.6,
        "2sd": 182.3,
        "3sd": 190.1
    },
    {
        "year": 14,
        "monthByYear": 8,
        "month": 176,
        "name": "14: 8",
        "sd": 7.7851,
        "-3sd": 143.9,
        "-2sd": 151.7,
        "-1sd": 159.5,
        "Median": 167.2,
        "1sd": 175,
        "2sd": 182.8,
        "3sd": 190.6
    },
    {
        "year": 14,
        "monthByYear": 9,
        "month": 177,
        "name": "14: 9",
        "sd": 7.7909,
        "-3sd": 144.3,
        "-2sd": 152.1,
        "-1sd": 159.9,
        "Median": 167.7,
        "1sd": 175.5,
        "2sd": 183.3,
        "3sd": 191.1
    },
    {
        "year": 14,
        "monthByYear": 10,
        "month": 178,
        "name": "14:10",
        "sd": 7.796,
        "-3sd": 144.7,
        "-2sd": 152.5,
        "-1sd": 160.3,
        "Median": 168.1,
        "1sd": 175.9,
        "2sd": 183.7,
        "3sd": 191.5
    },
    {
        "year": 14,
        "monthByYear": 11,
        "month": 179,
        "name": "14:11",
        "sd": 7.8004,
        "-3sd": 145.1,
        "-2sd": 152.9,
        "-1sd": 160.7,
        "Median": 168.5,
        "1sd": 176.3,
        "2sd": 184.1,
        "3sd": 191.9
    },
    {
        "year": 15,
        "monthByYear": 0,
        "month": 180,
        "name": "15: 0",
        "sd": 7.8042,
        "-3sd": 145.5,
        "-2sd": 153.4,
        "-1sd": 161.2,
        "Median": 169,
        "1sd": 176.8,
        "2sd": 184.6,
        "3sd": 192.4
    },
    {
        "year": 15,
        "monthByYear": 1,
        "month": 181,
        "name": "15: 1",
        "sd": 7.8056,
        "-3sd": 145.9,
        "-2sd": 153.7,
        "-1sd": 161.5,
        "Median": 169.4,
        "1sd": 177.2,
        "2sd": 185,
        "3sd": 192.8
    },
    {
        "year": 15,
        "monthByYear": 2,
        "month": 182,
        "name": "15: 2",
        "sd": 7.8063,
        "-3sd": 146.3,
        "-2sd": 154.1,
        "-1sd": 161.9,
        "Median": 169.7,
        "1sd": 177.5,
        "2sd": 185.4,
        "3sd": 193.2
    },
    {
        "year": 15,
        "monthByYear": 3,
        "month": 183,
        "name": "15: 3",
        "sd": 7.8063,
        "-3sd": 146.7,
        "-2sd": 154.5,
        "-1sd": 162.3,
        "Median": 170.1,
        "1sd": 177.9,
        "2sd": 185.7,
        "3sd": 193.5
    },
    {
        "year": 15,
        "monthByYear": 4,
        "month": 184,
        "name": "15: 4",
        "sd": 7.8057,
        "-3sd": 147.1,
        "-2sd": 154.9,
        "-1sd": 162.7,
        "Median": 170.5,
        "1sd": 178.3,
        "2sd": 186.1,
        "3sd": 193.9
    },
    {
        "year": 15,
        "monthByYear": 5,
        "month": 185,
        "name": "15: 5",
        "sd": 7.8045,
        "-3sd": 147.4,
        "-2sd": 155.2,
        "-1sd": 163,
        "Median": 170.8,
        "1sd": 178.6,
        "2sd": 186.4,
        "3sd": 194.2
    },
    {
        "year": 15,
        "monthByYear": 6,
        "month": 186,
        "name": "15: 6",
        "sd": 7.8026,
        "-3sd": 147.7,
        "-2sd": 155.5,
        "-1sd": 163.3,
        "Median": 171.1,
        "1sd": 178.9,
        "2sd": 186.8,
        "3sd": 194.6
    },
    {
        "year": 15,
        "monthByYear": 7,
        "month": 187,
        "name": "15: 7",
        "sd": 7.7984,
        "-3sd": 148.1,
        "-2sd": 155.9,
        "-1sd": 163.7,
        "Median": 171.5,
        "1sd": 179.3,
        "2sd": 187.1,
        "3sd": 194.9
    },
    {
        "year": 15,
        "monthByYear": 8,
        "month": 188,
        "name": "15: 8",
        "sd": 7.7953,
        "-3sd": 148.4,
        "-2sd": 156.2,
        "-1sd": 164,
        "Median": 171.8,
        "1sd": 179.6,
        "2sd": 187.4,
        "3sd": 195.2
    },
    {
        "year": 15,
        "monthByYear": 9,
        "month": 189,
        "name": "15: 9",
        "sd": 7.7898,
        "-3sd": 148.7,
        "-2sd": 156.5,
        "-1sd": 164.3,
        "Median": 172.1,
        "1sd": 179.9,
        "2sd": 187.7,
        "3sd": 195.4
    },
    {
        "year": 15,
        "monthByYear": 10,
        "month": 190,
        "name": "15:10",
        "sd": 7.7838,
        "-3sd": 149,
        "-2sd": 156.8,
        "-1sd": 164.6,
        "Median": 172.4,
        "1sd": 180.1,
        "2sd": 187.9,
        "3sd": 195.7
    },
    {
        "year": 15,
        "monthByYear": 11,
        "month": 191,
        "name": "15:11",
        "sd": 7.7789,
        "-3sd": 149.3,
        "-2sd": 157.1,
        "-1sd": 164.9,
        "Median": 172.6,
        "1sd": 180.4,
        "2sd": 188.2,
        "3sd": 196
    },
    {
        "year": 16,
        "monthByYear": 0,
        "month": 192,
        "name": "16: 0",
        "sd": 7.7717,
        "-3sd": 149.6,
        "-2sd": 157.4,
        "-1sd": 165.1,
        "Median": 172.9,
        "1sd": 180.7,
        "2sd": 188.4,
        "3sd": 196.2
    },
    {
        "year": 16,
        "monthByYear": 1,
        "month": 193,
        "name": "16: 1",
        "sd": 7.7639,
        "-3sd": 149.9,
        "-2sd": 157.6,
        "-1sd": 165.4,
        "Median": 173.1,
        "1sd": 180.9,
        "2sd": 188.7,
        "3sd": 196.4
    },
    {
        "year": 16,
        "monthByYear": 2,
        "month": 194,
        "name": "16: 2",
        "sd": 7.7555,
        "-3sd": 150.1,
        "-2sd": 157.9,
        "-1sd": 165.6,
        "Median": 173.4,
        "1sd": 181.1,
        "2sd": 188.9,
        "3sd": 196.7
    },
    {
        "year": 16,
        "monthByYear": 3,
        "month": 195,
        "name": "16: 3",
        "sd": 7.7466,
        "-3sd": 150.4,
        "-2sd": 158.1,
        "-1sd": 165.9,
        "Median": 173.6,
        "1sd": 181.4,
        "2sd": 189.1,
        "3sd": 196.9
    },
    {
        "year": 16,
        "monthByYear": 4,
        "month": 196,
        "name": "16: 4",
        "sd": 7.7371,
        "-3sd": 150.6,
        "-2sd": 158.4,
        "-1sd": 166.1,
        "Median": 173.8,
        "1sd": 181.6,
        "2sd": 189.3,
        "3sd": 197
    },
    {
        "year": 16,
        "monthByYear": 5,
        "month": 197,
        "name": "16: 5",
        "sd": 7.727,
        "-3sd": 150.9,
        "-2sd": 158.6,
        "-1sd": 166.3,
        "Median": 174,
        "1sd": 181.8,
        "2sd": 189.5,
        "3sd": 197.2
    },
    {
        "year": 16,
        "monthByYear": 6,
        "month": 198,
        "name": "16: 6",
        "sd": 7.7164,
        "-3sd": 151.1,
        "-2sd": 158.8,
        "-1sd": 166.5,
        "Median": 174.2,
        "1sd": 181.9,
        "2sd": 189.7,
        "3sd": 197.4
    },
    {
        "year": 16,
        "monthByYear": 7,
        "month": 199,
        "name": "16: 7",
        "sd": 7.7053,
        "-3sd": 151.3,
        "-2sd": 159,
        "-1sd": 166.7,
        "Median": 174.4,
        "1sd": 182.1,
        "2sd": 189.8,
        "3sd": 197.5
    },
    {
        "year": 16,
        "monthByYear": 8,
        "month": 200,
        "name": "16: 8",
        "sd": 7.6937,
        "-3sd": 151.5,
        "-2sd": 159.2,
        "-1sd": 166.9,
        "Median": 174.6,
        "1sd": 182.3,
        "2sd": 190,
        "3sd": 197.7
    },
    {
        "year": 16,
        "monthByYear": 9,
        "month": 201,
        "name": "16: 9",
        "sd": 7.6815,
        "-3sd": 151.7,
        "-2sd": 159.4,
        "-1sd": 167.1,
        "Median": 174.7,
        "1sd": 182.4,
        "2sd": 190.1,
        "3sd": 197.8
    },
    {
        "year": 16,
        "monthByYear": 10,
        "month": 202,
        "name": "16:10",
        "sd": 7.6689,
        "-3sd": 151.9,
        "-2sd": 159.6,
        "-1sd": 167.2,
        "Median": 174.9,
        "1sd": 182.6,
        "2sd": 190.2,
        "3sd": 197.9
    },
    {
        "year": 16,
        "monthByYear": 11,
        "month": 203,
        "name": "16:11",
        "sd": 7.6576,
        "-3sd": 152.1,
        "-2sd": 159.7,
        "-1sd": 167.4,
        "Median": 175,
        "1sd": 182.7,
        "2sd": 190.3,
        "3sd": 198
    },
    {
        "year": 17,
        "monthByYear": 0,
        "month": 204,
        "name": "17: 0",
        "sd": 7.644,
        "-3sd": 152.2,
        "-2sd": 159.9,
        "-1sd": 167.5,
        "Median": 175.2,
        "1sd": 182.8,
        "2sd": 190.4,
        "3sd": 198.1
    },
    {
        "year": 17,
        "monthByYear": 1,
        "month": 205,
        "name": "17: 1",
        "sd": 7.63,
        "-3sd": 152.4,
        "-2sd": 160,
        "-1sd": 167.7,
        "Median": 175.3,
        "1sd": 182.9,
        "2sd": 190.5,
        "3sd": 198.2
    },
    {
        "year": 17,
        "monthByYear": 2,
        "month": 206,
        "name": "17: 2",
        "sd": 7.6174,
        "-3sd": 152.5,
        "-2sd": 160.2,
        "-1sd": 167.8,
        "Median": 175.4,
        "1sd": 183,
        "2sd": 190.6,
        "3sd": 198.2
    },
    {
        "year": 17,
        "monthByYear": 3,
        "month": 207,
        "name": "17: 3",
        "sd": 7.6026,
        "-3sd": 152.7,
        "-2sd": 160.3,
        "-1sd": 167.9,
        "Median": 175.5,
        "1sd": 183.1,
        "2sd": 190.7,
        "3sd": 198.3
    },
    {
        "year": 17,
        "monthByYear": 4,
        "month": 208,
        "name": "17: 4",
        "sd": 7.5893,
        "-3sd": 152.8,
        "-2sd": 160.4,
        "-1sd": 168,
        "Median": 175.6,
        "1sd": 183.2,
        "2sd": 190.8,
        "3sd": 198.4
    },
    {
        "year": 17,
        "monthByYear": 5,
        "month": 209,
        "name": "17: 5",
        "sd": 7.5738,
        "-3sd": 153,
        "-2sd": 160.5,
        "-1sd": 168.1,
        "Median": 175.7,
        "1sd": 183.3,
        "2sd": 190.8,
        "3sd": 198.4
    },
    {
        "year": 17,
        "monthByYear": 6,
        "month": 210,
        "name": "17: 6",
        "sd": 7.5597,
        "-3sd": 153.1,
        "-2sd": 160.6,
        "-1sd": 168.2,
        "Median": 175.8,
        "1sd": 183.3,
        "2sd": 190.9,
        "3sd": 198.4
    },
    {
        "year": 17,
        "monthByYear": 7,
        "month": 211,
        "name": "17: 7",
        "sd": 7.5454,
        "-3sd": 153.2,
        "-2sd": 160.8,
        "-1sd": 168.3,
        "Median": 175.8,
        "1sd": 183.4,
        "2sd": 190.9,
        "3sd": 198.5
    },
    {
        "year": 17,
        "monthByYear": 8,
        "month": 212,
        "name": "17: 8",
        "sd": 7.5308,
        "-3sd": 153.3,
        "-2sd": 160.9,
        "-1sd": 168.4,
        "Median": 175.9,
        "1sd": 183.4,
        "2sd": 191,
        "3sd": 198.5
    },
    {
        "year": 17,
        "monthByYear": 9,
        "month": 213,
        "name": "17: 9",
        "sd": 7.516,
        "-3sd": 153.4,
        "-2sd": 160.9,
        "-1sd": 168.5,
        "Median": 176,
        "1sd": 183.5,
        "2sd": 191,
        "3sd": 198.5
    },
    {
        "year": 17,
        "monthByYear": 10,
        "month": 214,
        "name": "17:10",
        "sd": 7.501,
        "-3sd": 153.5,
        "-2sd": 161,
        "-1sd": 168.5,
        "Median": 176,
        "1sd": 183.5,
        "2sd": 191,
        "3sd": 198.5
    },
    {
        "year": 17,
        "monthByYear": 11,
        "month": 215,
        "name": "17:11",
        "sd": 7.4857,
        "-3sd": 153.6,
        "-2sd": 161.1,
        "-1sd": 168.6,
        "Median": 176.1,
        "1sd": 183.6,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 0,
        "month": 216,
        "name": "18: 0",
        "sd": 7.4703,
        "-3sd": 153.7,
        "-2sd": 161.2,
        "-1sd": 168.7,
        "Median": 176.1,
        "1sd": 183.6,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 1,
        "month": 217,
        "name": "18: 1",
        "sd": 7.4565,
        "-3sd": 153.8,
        "-2sd": 161.3,
        "-1sd": 168.7,
        "Median": 176.2,
        "1sd": 183.6,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 2,
        "month": 218,
        "name": "18: 2",
        "sd": 7.4407,
        "-3sd": 153.9,
        "-2sd": 161.4,
        "-1sd": 168.8,
        "Median": 176.2,
        "1sd": 183.7,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 3,
        "month": 219,
        "name": "18: 3",
        "sd": 7.4266,
        "-3sd": 154,
        "-2sd": 161.4,
        "-1sd": 168.9,
        "Median": 176.3,
        "1sd": 183.7,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 4,
        "month": 220,
        "name": "18: 4",
        "sd": 7.4123,
        "-3sd": 154.1,
        "-2sd": 161.5,
        "-1sd": 168.9,
        "Median": 176.3,
        "1sd": 183.7,
        "2sd": 191.1,
        "3sd": 198.6
    },
    {
        "year": 18,
        "monthByYear": 5,
        "month": 221,
        "name": "18: 5",
        "sd": 7.398,
        "-3sd": 154.2,
        "-2sd": 161.6,
        "-1sd": 169,
        "Median": 176.4,
        "1sd": 183.8,
        "2sd": 191.1,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 6,
        "month": 222,
        "name": "18: 6",
        "sd": 7.3817,
        "-3sd": 154.2,
        "-2sd": 161.6,
        "-1sd": 169,
        "Median": 176.4,
        "1sd": 183.8,
        "2sd": 191.1,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 7,
        "month": 223,
        "name": "18: 7",
        "sd": 7.3689,
        "-3sd": 154.3,
        "-2sd": 161.7,
        "-1sd": 169,
        "Median": 176.4,
        "1sd": 183.8,
        "2sd": 191.2,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 8,
        "month": 224,
        "name": "18: 8",
        "sd": 7.3542,
        "-3sd": 154.4,
        "-2sd": 161.7,
        "-1sd": 169.1,
        "Median": 176.4,
        "1sd": 183.8,
        "2sd": 191.2,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 9,
        "month": 225,
        "name": "18: 9",
        "sd": 7.3395,
        "-3sd": 154.5,
        "-2sd": 161.8,
        "-1sd": 169.1,
        "Median": 176.5,
        "1sd": 183.8,
        "2sd": 191.2,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 10,
        "month": 226,
        "name": "18:10",
        "sd": 7.3247,
        "-3sd": 154.5,
        "-2sd": 161.8,
        "-1sd": 169.2,
        "Median": 176.5,
        "1sd": 183.8,
        "2sd": 191.1,
        "3sd": 198.5
    },
    {
        "year": 18,
        "monthByYear": 11,
        "month": 227,
        "name": "18:11",
        "sd": 7.3115,
        "-3sd": 154.6,
        "-2sd": 161.9,
        "-1sd": 169.2,
        "Median": 176.5,
        "1sd": 183.8,
        "2sd": 191.1,
        "3sd": 198.5
    },
    {
        "year": 19,
        "monthByYear": 0,
        "month": 228,
        "name": "19: 0",
        "sd": 7.2983,
        "-3sd": 154.6,
        "-2sd": 161.9,
        "-1sd": 169.2,
        "Median": 176.5,
        "1sd": 183.8,
        "2sd": 191.1,
        "3sd": 198.4
    }
]

export const WEIGHT_FEMALE_5_10 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "-3sd": 12.4,
        "-2sd": 14,
        "-1sd": 15.9,
        "Median": 18.3,
        "1sd": 21.2,
        "2sd": 24.8,
        "3sd": 29.5
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "-3sd": 12.5,
        "-2sd": 14.1,
        "-1sd": 16,
        "Median": 18.4,
        "1sd": 21.4,
        "2sd": 25.1,
        "3sd": 29.8
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "-3sd": 12.6,
        "-2sd": 14.2,
        "-1sd": 16.2,
        "Median": 18.6,
        "1sd": 21.6,
        "2sd": 25.4,
        "3sd": 30.2
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "-3sd": 12.7,
        "-2sd": 14.3,
        "-1sd": 16.3,
        "Median": 18.8,
        "1sd": 21.8,
        "2sd": 25.6,
        "3sd": 30.5
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "-3sd": 12.8,
        "-2sd": 14.4,
        "-1sd": 16.5,
        "Median": 19,
        "1sd": 22,
        "2sd": 25.9,
        "3sd": 30.9
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "-3sd": 12.9,
        "-2sd": 14.6,
        "-1sd": 16.6,
        "Median": 19.1,
        "1sd": 22.2,
        "2sd": 26.2,
        "3sd": 31.3
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "-3sd": 13,
        "-2sd": 14.7,
        "-1sd": 16.8,
        "Median": 19.3,
        "1sd": 22.5,
        "2sd": 26.5,
        "3sd": 31.6
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "-3sd": 13.1,
        "-2sd": 14.8,
        "-1sd": 16.9,
        "Median": 19.5,
        "1sd": 22.7,
        "2sd": 26.7,
        "3sd": 32
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "-3sd": 13.2,
        "-2sd": 14.9,
        "-1sd": 17,
        "Median": 19.6,
        "1sd": 22.9,
        "2sd": 27,
        "3sd": 32.3
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "-3sd": 13.3,
        "-2sd": 15,
        "-1sd": 17.2,
        "Median": 19.8,
        "1sd": 23.1,
        "2sd": 27.3,
        "3sd": 32.7
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "-3sd": 13.4,
        "-2sd": 15.2,
        "-1sd": 17.3,
        "Median": 20,
        "1sd": 23.3,
        "2sd": 27.6,
        "3sd": 33.1
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "-3sd": 13.5,
        "-2sd": 15.3,
        "-1sd": 17.5,
        "Median": 20.2,
        "1sd": 23.5,
        "2sd": 27.8,
        "3sd": 33.4
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "-3sd": 13.6,
        "-2sd": 15.4,
        "-1sd": 17.6,
        "Median": 20.3,
        "1sd": 23.8,
        "2sd": 28.1,
        "3sd": 33.8
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "-3sd": 13.7,
        "-2sd": 15.5,
        "-1sd": 17.8,
        "Median": 20.5,
        "1sd": 24,
        "2sd": 28.4,
        "3sd": 34.2
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "-3sd": 13.8,
        "-2sd": 15.6,
        "-1sd": 17.9,
        "Median": 20.7,
        "1sd": 24.2,
        "2sd": 28.7,
        "3sd": 34.6
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "-3sd": 13.9,
        "-2sd": 15.8,
        "-1sd": 18,
        "Median": 20.9,
        "1sd": 24.4,
        "2sd": 29,
        "3sd": 35
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "-3sd": 14,
        "-2sd": 15.9,
        "-1sd": 18.2,
        "Median": 21,
        "1sd": 24.6,
        "2sd": 29.3,
        "3sd": 35.4
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "-3sd": 14.1,
        "-2sd": 16,
        "-1sd": 18.3,
        "Median": 21.2,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 35.8
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "-3sd": 14.2,
        "-2sd": 16.1,
        "-1sd": 18.5,
        "Median": 21.4,
        "1sd": 25.1,
        "2sd": 29.9,
        "3sd": 36.2
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "-3sd": 14.3,
        "-2sd": 16.3,
        "-1sd": 18.6,
        "Median": 21.6,
        "1sd": 25.3,
        "2sd": 30.2,
        "3sd": 36.6
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "-3sd": 14.4,
        "-2sd": 16.4,
        "-1sd": 18.8,
        "Median": 21.8,
        "1sd": 25.6,
        "2sd": 30.5,
        "3sd": 37
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "-3sd": 14.5,
        "-2sd": 16.5,
        "-1sd": 18.9,
        "Median": 22,
        "1sd": 25.8,
        "2sd": 30.8,
        "3sd": 37.4
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "-3sd": 14.6,
        "-2sd": 16.6,
        "-1sd": 19.1,
        "Median": 22.2,
        "1sd": 26.1,
        "2sd": 31.1,
        "3sd": 37.8
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "-3sd": 14.8,
        "-2sd": 16.8,
        "-1sd": 19.3,
        "Median": 22.4,
        "1sd": 26.3,
        "2sd": 31.4,
        "3sd": 38.3
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "-3sd": 14.9,
        "-2sd": 16.9,
        "-1sd": 19.4,
        "Median": 22.6,
        "1sd": 26.6,
        "2sd": 31.8,
        "3sd": 38.7
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "-3sd": 15,
        "-2sd": 17.1,
        "-1sd": 19.6,
        "Median": 22.8,
        "1sd": 26.8,
        "2sd": 32.1,
        "3sd": 39.2
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "-3sd": 15.1,
        "-2sd": 17.2,
        "-1sd": 19.8,
        "Median": 23,
        "1sd": 27.1,
        "2sd": 32.5,
        "3sd": 39.6
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "-3sd": 15.2,
        "-2sd": 17.3,
        "-1sd": 19.9,
        "Median": 23.2,
        "1sd": 27.4,
        "2sd": 32.8,
        "3sd": 40.1
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "-3sd": 15.4,
        "-2sd": 17.5,
        "-1sd": 20.1,
        "Median": 23.4,
        "1sd": 27.6,
        "2sd": 33.1,
        "3sd": 40.6
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "-3sd": 15.5,
        "-2sd": 17.6,
        "-1sd": 20.3,
        "Median": 23.6,
        "1sd": 27.9,
        "2sd": 33.5,
        "3sd": 41.1
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "-3sd": 15.6,
        "-2sd": 17.8,
        "-1sd": 20.5,
        "Median": 23.9,
        "1sd": 28.2,
        "2sd": 33.9,
        "3sd": 41.5
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "-3sd": 15.7,
        "-2sd": 17.9,
        "-1sd": 20.7,
        "Median": 24.1,
        "1sd": 28.5,
        "2sd": 34.2,
        "3sd": 42
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "-3sd": 15.9,
        "-2sd": 18.1,
        "-1sd": 20.9,
        "Median": 24.3,
        "1sd": 28.8,
        "2sd": 34.6,
        "3sd": 42.6
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "-3sd": 16,
        "-2sd": 18.3,
        "-1sd": 21,
        "Median": 24.5,
        "1sd": 29.1,
        "2sd": 35,
        "3sd": 43.1
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "-3sd": 16.2,
        "-2sd": 18.4,
        "-1sd": 21.2,
        "Median": 24.8,
        "1sd": 29.4,
        "2sd": 35.4,
        "3sd": 43.6
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "-3sd": 16.3,
        "-2sd": 18.6,
        "-1sd": 21.4,
        "Median": 25,
        "1sd": 29.7,
        "2sd": 35.8,
        "3sd": 44.1
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "-3sd": 16.4,
        "-2sd": 18.8,
        "-1sd": 21.6,
        "Median": 25.3,
        "1sd": 30,
        "2sd": 36.2,
        "3sd": 44.7
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "-3sd": 16.6,
        "-2sd": 18.9,
        "-1sd": 21.8,
        "Median": 25.5,
        "1sd": 30.3,
        "2sd": 36.6,
        "3sd": 45.2
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "-3sd": 16.7,
        "-2sd": 19.1,
        "-1sd": 22,
        "Median": 25.8,
        "1sd": 30.6,
        "2sd": 37,
        "3sd": 45.8
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "-3sd": 16.9,
        "-2sd": 19.3,
        "-1sd": 22.3,
        "Median": 26,
        "1sd": 30.9,
        "2sd": 37.4,
        "3sd": 46.3
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "-3sd": 17,
        "-2sd": 19.5,
        "-1sd": 22.5,
        "Median": 26.3,
        "1sd": 31.2,
        "2sd": 37.8,
        "3sd": 46.9
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "-3sd": 17.2,
        "-2sd": 19.6,
        "-1sd": 22.7,
        "Median": 26.6,
        "1sd": 31.6,
        "2sd": 38.3,
        "3sd": 47.5
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "-3sd": 17.3,
        "-2sd": 19.8,
        "-1sd": 22.9,
        "Median": 26.8,
        "1sd": 31.9,
        "2sd": 38.7,
        "3sd": 48.1
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "-3sd": 17.5,
        "-2sd": 20,
        "-1sd": 23.1,
        "Median": 27.1,
        "1sd": 32.2,
        "2sd": 39.1,
        "3sd": 48.7
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "-3sd": 17.7,
        "-2sd": 20.2,
        "-1sd": 23.3,
        "Median": 27.4,
        "1sd": 32.6,
        "2sd": 39.6,
        "3sd": 49.3
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "-3sd": 17.8,
        "-2sd": 20.4,
        "-1sd": 23.6,
        "Median": 27.6,
        "1sd": 32.9,
        "2sd": 40,
        "3sd": 49.9
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "-3sd": 18,
        "-2sd": 20.6,
        "-1sd": 23.8,
        "Median": 27.9,
        "1sd": 33.3,
        "2sd": 40.5,
        "3sd": 50.5
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "-3sd": 18.1,
        "-2sd": 20.8,
        "-1sd": 24,
        "Median": 28.2,
        "1sd": 33.6,
        "2sd": 41,
        "3sd": 51.1
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "-3sd": 18.3,
        "-2sd": 21,
        "-1sd": 24.3,
        "Median": 28.5,
        "1sd": 34,
        "2sd": 41.4,
        "3sd": 51.8
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "-3sd": 18.5,
        "-2sd": 21.2,
        "-1sd": 24.5,
        "Median": 28.8,
        "1sd": 34.4,
        "2sd": 41.9,
        "3sd": 52.4
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "-3sd": 18.7,
        "-2sd": 21.4,
        "-1sd": 24.7,
        "Median": 29.1,
        "1sd": 34.7,
        "2sd": 42.4,
        "3sd": 53.1
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "-3sd": 18.8,
        "-2sd": 21.6,
        "-1sd": 25,
        "Median": 29.4,
        "1sd": 35.1,
        "2sd": 42.9,
        "3sd": 53.7
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "-3sd": 19,
        "-2sd": 21.8,
        "-1sd": 25.2,
        "Median": 29.7,
        "1sd": 35.5,
        "2sd": 43.3,
        "3sd": 54.4
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "-3sd": 19.2,
        "-2sd": 22,
        "-1sd": 25.5,
        "Median": 30,
        "1sd": 35.9,
        "2sd": 43.8,
        "3sd": 55
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "-3sd": 19.4,
        "-2sd": 22.2,
        "-1sd": 25.7,
        "Median": 30.3,
        "1sd": 36.2,
        "2sd": 44.3,
        "3sd": 55.7
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "-3sd": 19.5,
        "-2sd": 22.4,
        "-1sd": 26,
        "Median": 30.6,
        "1sd": 36.6,
        "2sd": 44.8,
        "3sd": 56.4
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "-3sd": 19.7,
        "-2sd": 22.6,
        "-1sd": 26.2,
        "Median": 30.9,
        "1sd": 37,
        "2sd": 45.3,
        "3sd": 57.1
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "-3sd": 19.9,
        "-2sd": 22.8,
        "-1sd": 26.5,
        "Median": 31.2,
        "1sd": 37.4,
        "2sd": 45.8,
        "3sd": 57.8
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "-3sd": 20.1,
        "-2sd": 23,
        "-1sd": 26.8,
        "Median": 31.5,
        "1sd": 37.8,
        "2sd": 46.4,
        "3sd": 58.5
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "-3sd": 20.3,
        "-2sd": 23.3,
        "-1sd": 27,
        "Median": 31.9,
        "1sd": 38.2,
        "2sd": 46.9,
        "3sd": 59.2
    }
]

export const HEIGHT_FEMALE_5_19 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "sd": 4.7731,
        "-3sd": 95.3,
        "-2sd": 100.1,
        "-1sd": 104.8,
        "Median": 109.6,
        "1sd": 114.4,
        "2sd": 119.1,
        "3sd": 123.9
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "sd": 4.8059,
        "-3sd": 95.7,
        "-2sd": 100.5,
        "-1sd": 105.3,
        "Median": 110.1,
        "1sd": 114.9,
        "2sd": 119.7,
        "3sd": 124.5
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "sd": 4.8385,
        "-3sd": 96.1,
        "-2sd": 101,
        "-1sd": 105.8,
        "Median": 110.6,
        "1sd": 115.5,
        "2sd": 120.3,
        "3sd": 125.2
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "sd": 4.871,
        "-3sd": 96.5,
        "-2sd": 101.4,
        "-1sd": 106.3,
        "Median": 111.2,
        "1sd": 116,
        "2sd": 120.9,
        "3sd": 125.8
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "sd": 4.9023,
        "-3sd": 97,
        "-2sd": 101.9,
        "-1sd": 106.8,
        "Median": 111.7,
        "1sd": 116.6,
        "2sd": 121.5,
        "3sd": 126.4
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "sd": 4.9346,
        "-3sd": 97.4,
        "-2sd": 102.3,
        "-1sd": 107.2,
        "Median": 112.2,
        "1sd": 117.1,
        "2sd": 122,
        "3sd": 127
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "sd": 4.9657,
        "-3sd": 97.8,
        "-2sd": 102.7,
        "-1sd": 107.7,
        "Median": 112.7,
        "1sd": 117.6,
        "2sd": 122.6,
        "3sd": 127.6
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "sd": 4.9966,
        "-3sd": 98.2,
        "-2sd": 103.2,
        "-1sd": 108.2,
        "Median": 113.2,
        "1sd": 118.2,
        "2sd": 123.2,
        "3sd": 128.2
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "sd": 5.0275,
        "-3sd": 98.6,
        "-2sd": 103.6,
        "-1sd": 108.6,
        "Median": 113.7,
        "1sd": 118.7,
        "2sd": 123.7,
        "3sd": 128.8
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "sd": 5.0583,
        "-3sd": 99,
        "-2sd": 104,
        "-1sd": 109.1,
        "Median": 114.2,
        "1sd": 119.2,
        "2sd": 124.3,
        "3sd": 129.3
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "sd": 5.089,
        "-3sd": 99.4,
        "-2sd": 104.5,
        "-1sd": 109.6,
        "Median": 114.6,
        "1sd": 119.7,
        "2sd": 124.8,
        "3sd": 129.9
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "sd": 5.1196,
        "-3sd": 99.8,
        "-2sd": 104.9,
        "-1sd": 110,
        "Median": 115.1,
        "1sd": 120.2,
        "2sd": 125.4,
        "3sd": 130.5
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "sd": 5.149,
        "-3sd": 100.2,
        "-2sd": 105.3,
        "-1sd": 110.5,
        "Median": 115.6,
        "1sd": 120.8,
        "2sd": 125.9,
        "3sd": 131.1
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "sd": 5.1784,
        "-3sd": 100.5,
        "-2sd": 105.7,
        "-1sd": 110.9,
        "Median": 116.1,
        "1sd": 121.3,
        "2sd": 126.4,
        "3sd": 131.6
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "sd": 5.2089,
        "-3sd": 100.9,
        "-2sd": 106.1,
        "-1sd": 111.3,
        "Median": 116.6,
        "1sd": 121.8,
        "2sd": 127,
        "3sd": 132.2
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "sd": 5.2371,
        "-3sd": 101.3,
        "-2sd": 106.6,
        "-1sd": 111.8,
        "Median": 117,
        "1sd": 122.3,
        "2sd": 127.5,
        "3sd": 132.7
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "sd": 5.2665,
        "-3sd": 101.7,
        "-2sd": 107,
        "-1sd": 112.2,
        "Median": 117.5,
        "1sd": 122.8,
        "2sd": 128,
        "3sd": 133.3
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "sd": 5.296,
        "-3sd": 102.1,
        "-2sd": 107.4,
        "-1sd": 112.7,
        "Median": 118,
        "1sd": 123.3,
        "2sd": 128.6,
        "3sd": 133.9
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "sd": 5.3243,
        "-3sd": 102.5,
        "-2sd": 107.8,
        "-1sd": 113.1,
        "Median": 118.4,
        "1sd": 123.8,
        "2sd": 129.1,
        "3sd": 134.4
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "sd": 5.3538,
        "-3sd": 102.9,
        "-2sd": 108.2,
        "-1sd": 113.6,
        "Median": 118.9,
        "1sd": 124.3,
        "2sd": 129.6,
        "3sd": 135
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "sd": 5.3822,
        "-3sd": 103.2,
        "-2sd": 108.6,
        "-1sd": 114,
        "Median": 119.4,
        "1sd": 124.8,
        "2sd": 130.2,
        "3sd": 135.5
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "sd": 5.4107,
        "-3sd": 103.6,
        "-2sd": 109,
        "-1sd": 114.5,
        "Median": 119.9,
        "1sd": 125.3,
        "2sd": 130.7,
        "3sd": 136.1
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "sd": 5.4393,
        "-3sd": 104,
        "-2sd": 109.5,
        "-1sd": 114.9,
        "Median": 120.3,
        "1sd": 125.8,
        "2sd": 131.2,
        "3sd": 136.7
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "sd": 5.4667,
        "-3sd": 104.4,
        "-2sd": 109.9,
        "-1sd": 115.3,
        "Median": 120.8,
        "1sd": 126.3,
        "2sd": 131.7,
        "3sd": 137.2
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "sd": 5.4954,
        "-3sd": 104.8,
        "-2sd": 110.3,
        "-1sd": 115.8,
        "Median": 121.3,
        "1sd": 126.8,
        "2sd": 132.3,
        "3sd": 137.8
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "sd": 5.523,
        "-3sd": 105.2,
        "-2sd": 110.7,
        "-1sd": 116.2,
        "Median": 121.8,
        "1sd": 127.3,
        "2sd": 132.8,
        "3sd": 138.3
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "sd": 5.5519,
        "-3sd": 105.6,
        "-2sd": 111.1,
        "-1sd": 116.7,
        "Median": 122.2,
        "1sd": 127.8,
        "2sd": 133.3,
        "3sd": 138.9
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "sd": 5.5796,
        "-3sd": 106,
        "-2sd": 111.6,
        "-1sd": 117.1,
        "Median": 122.7,
        "1sd": 128.3,
        "2sd": 133.9,
        "3sd": 139.4
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "sd": 5.6062,
        "-3sd": 106.4,
        "-2sd": 112,
        "-1sd": 117.6,
        "Median": 123.2,
        "1sd": 128.8,
        "2sd": 134.4,
        "3sd": 140
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "sd": 5.6342,
        "-3sd": 106.8,
        "-2sd": 112.4,
        "-1sd": 118,
        "Median": 123.7,
        "1sd": 129.3,
        "2sd": 134.9,
        "3sd": 140.6
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "sd": 5.6622,
        "-3sd": 107.2,
        "-2sd": 112.8,
        "-1sd": 118.5,
        "Median": 124.1,
        "1sd": 129.8,
        "2sd": 135.5,
        "3sd": 141.1
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "sd": 5.6891,
        "-3sd": 107.6,
        "-2sd": 113.2,
        "-1sd": 118.9,
        "Median": 124.6,
        "1sd": 130.3,
        "2sd": 136,
        "3sd": 141.7
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "sd": 5.716,
        "-3sd": 108,
        "-2sd": 113.7,
        "-1sd": 119.4,
        "Median": 125.1,
        "1sd": 130.8,
        "2sd": 136.5,
        "3sd": 142.3
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "sd": 5.7431,
        "-3sd": 108.4,
        "-2sd": 114.1,
        "-1sd": 119.8,
        "Median": 125.6,
        "1sd": 131.3,
        "2sd": 137.1,
        "3sd": 142.8
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "sd": 5.7703,
        "-3sd": 108.8,
        "-2sd": 114.5,
        "-1sd": 120.3,
        "Median": 126.1,
        "1sd": 131.8,
        "2sd": 137.6,
        "3sd": 143.4
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "sd": 5.7975,
        "-3sd": 109.2,
        "-2sd": 115,
        "-1sd": 120.8,
        "Median": 126.6,
        "1sd": 132.4,
        "2sd": 138.2,
        "3sd": 143.9
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "sd": 5.8249,
        "-3sd": 109.6,
        "-2sd": 115.4,
        "-1sd": 121.2,
        "Median": 127,
        "1sd": 132.9,
        "2sd": 138.7,
        "3sd": 144.5
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "sd": 5.8511,
        "-3sd": 110,
        "-2sd": 115.8,
        "-1sd": 121.7,
        "Median": 127.5,
        "1sd": 133.4,
        "2sd": 139.2,
        "3sd": 145.1
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "sd": 5.8774,
        "-3sd": 110.4,
        "-2sd": 116.3,
        "-1sd": 122.1,
        "Median": 128,
        "1sd": 133.9,
        "2sd": 139.8,
        "3sd": 145.7
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "sd": 5.9038,
        "-3sd": 110.8,
        "-2sd": 116.7,
        "-1sd": 122.6,
        "Median": 128.5,
        "1sd": 134.4,
        "2sd": 140.3,
        "3sd": 146.2
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "sd": 5.9303,
        "-3sd": 111.2,
        "-2sd": 117.1,
        "-1sd": 123.1,
        "Median": 129,
        "1sd": 134.9,
        "2sd": 140.9,
        "3sd": 146.8
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "sd": 5.9569,
        "-3sd": 111.6,
        "-2sd": 117.6,
        "-1sd": 123.5,
        "Median": 129.5,
        "1sd": 135.5,
        "2sd": 141.4,
        "3sd": 147.4
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "sd": 5.9823,
        "-3sd": 112,
        "-2sd": 118,
        "-1sd": 124,
        "Median": 130,
        "1sd": 136,
        "2sd": 142,
        "3sd": 147.9
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "sd": 6.0078,
        "-3sd": 112.5,
        "-2sd": 118.5,
        "-1sd": 124.5,
        "Median": 130.5,
        "1sd": 136.5,
        "2sd": 142.5,
        "3sd": 148.5
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "sd": 6.0347,
        "-3sd": 112.9,
        "-2sd": 118.9,
        "-1sd": 125,
        "Median": 131,
        "1sd": 137,
        "2sd": 143.1,
        "3sd": 149.1
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "sd": 6.059,
        "-3sd": 113.3,
        "-2sd": 119.4,
        "-1sd": 125.4,
        "Median": 131.5,
        "1sd": 137.5,
        "2sd": 143.6,
        "3sd": 149.7
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "sd": 6.0848,
        "-3sd": 113.7,
        "-2sd": 119.8,
        "-1sd": 125.9,
        "Median": 132,
        "1sd": 138.1,
        "2sd": 144.2,
        "3sd": 150.2
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "sd": 6.1106,
        "-3sd": 114.2,
        "-2sd": 120.3,
        "-1sd": 126.4,
        "Median": 132.5,
        "1sd": 138.6,
        "2sd": 144.7,
        "3sd": 150.8
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "sd": 6.1352,
        "-3sd": 114.6,
        "-2sd": 120.7,
        "-1sd": 126.9,
        "Median": 133,
        "1sd": 139.1,
        "2sd": 145.3,
        "3sd": 151.4
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "sd": 6.1599,
        "-3sd": 115,
        "-2sd": 121.2,
        "-1sd": 127.3,
        "Median": 133.5,
        "1sd": 139.7,
        "2sd": 145.8,
        "3sd": 152
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "sd": 6.1846,
        "-3sd": 115.5,
        "-2sd": 121.6,
        "-1sd": 127.8,
        "Median": 134,
        "1sd": 140.2,
        "2sd": 146.4,
        "3sd": 152.6
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "sd": 6.2095,
        "-3sd": 115.9,
        "-2sd": 122.1,
        "-1sd": 128.3,
        "Median": 134.5,
        "1sd": 140.7,
        "2sd": 146.9,
        "3sd": 153.1
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "sd": 6.233,
        "-3sd": 116.3,
        "-2sd": 122.6,
        "-1sd": 128.8,
        "Median": 135,
        "1sd": 141.3,
        "2sd": 147.5,
        "3sd": 153.7
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "sd": 6.2579,
        "-3sd": 116.8,
        "-2sd": 123,
        "-1sd": 129.3,
        "Median": 135.5,
        "1sd": 141.8,
        "2sd": 148.1,
        "3sd": 154.3
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "sd": 6.2816,
        "-3sd": 117.2,
        "-2sd": 123.5,
        "-1sd": 129.8,
        "Median": 136.1,
        "1sd": 142.3,
        "2sd": 148.6,
        "3sd": 154.9
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "sd": 6.3039,
        "-3sd": 117.7,
        "-2sd": 124,
        "-1sd": 130.3,
        "Median": 136.6,
        "1sd": 142.9,
        "2sd": 149.2,
        "3sd": 155.5
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "sd": 6.3277,
        "-3sd": 118.1,
        "-2sd": 124.4,
        "-1sd": 130.8,
        "Median": 137.1,
        "1sd": 143.4,
        "2sd": 149.7,
        "3sd": 156.1
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "sd": 6.3516,
        "-3sd": 118.5,
        "-2sd": 124.9,
        "-1sd": 131.2,
        "Median": 137.6,
        "1sd": 144,
        "2sd": 150.3,
        "3sd": 156.7
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "sd": 6.3741,
        "-3sd": 119,
        "-2sd": 125.4,
        "-1sd": 131.7,
        "Median": 138.1,
        "1sd": 144.5,
        "2sd": 150.9,
        "3sd": 157.2
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "sd": 6.3967,
        "-3sd": 119.4,
        "-2sd": 125.8,
        "-1sd": 132.2,
        "Median": 138.6,
        "1sd": 145,
        "2sd": 151.4,
        "3sd": 157.8
    },
    {
        "year": 10,
        "monthByYear": 1,
        "month": 121,
        "name": "10: 1",
        "sd": 6.4179,
        "-3sd": 119.9,
        "-2sd": 126.3,
        "-1sd": 132.7,
        "Median": 139.2,
        "1sd": 145.6,
        "2sd": 152,
        "3sd": 158.4
    },
    {
        "year": 10,
        "monthByYear": 2,
        "month": 122,
        "name": "10: 2",
        "sd": 6.4407,
        "-3sd": 120.4,
        "-2sd": 126.8,
        "-1sd": 133.2,
        "Median": 139.7,
        "1sd": 146.1,
        "2sd": 152.6,
        "3sd": 159
    },
    {
        "year": 10,
        "monthByYear": 3,
        "month": 123,
        "name": "10: 3",
        "sd": 6.462,
        "-3sd": 120.8,
        "-2sd": 127.3,
        "-1sd": 133.7,
        "Median": 140.2,
        "1sd": 146.7,
        "2sd": 153.1,
        "3sd": 159.6
    },
    {
        "year": 10,
        "monthByYear": 4,
        "month": 124,
        "name": "10: 4",
        "sd": 6.4835,
        "-3sd": 121.3,
        "-2sd": 127.8,
        "-1sd": 134.2,
        "Median": 140.7,
        "1sd": 147.2,
        "2sd": 153.7,
        "3sd": 160.2
    },
    {
        "year": 10,
        "monthByYear": 5,
        "month": 125,
        "name": "10: 5",
        "sd": 6.505,
        "-3sd": 121.7,
        "-2sd": 128.2,
        "-1sd": 134.8,
        "Median": 141.3,
        "1sd": 147.8,
        "2sd": 154.3,
        "3sd": 160.8
    },
    {
        "year": 10,
        "monthByYear": 6,
        "month": 126,
        "name": "10: 6",
        "sd": 6.5266,
        "-3sd": 122.2,
        "-2sd": 128.7,
        "-1sd": 135.3,
        "Median": 141.8,
        "1sd": 148.3,
        "2sd": 154.8,
        "3sd": 161.4
    },
    {
        "year": 10,
        "monthByYear": 7,
        "month": 127,
        "name": "10: 7",
        "sd": 6.5467,
        "-3sd": 122.7,
        "-2sd": 129.2,
        "-1sd": 135.8,
        "Median": 142.3,
        "1sd": 148.9,
        "2sd": 155.4,
        "3sd": 162
    },
    {
        "year": 10,
        "monthByYear": 8,
        "month": 128,
        "name": "10: 8",
        "sd": 6.567,
        "-3sd": 123.2,
        "-2sd": 129.7,
        "-1sd": 136.3,
        "Median": 142.9,
        "1sd": 149.4,
        "2sd": 156,
        "3sd": 162.6
    },
    {
        "year": 10,
        "monthByYear": 9,
        "month": 129,
        "name": "10: 9",
        "sd": 6.5872,
        "-3sd": 123.6,
        "-2sd": 130.2,
        "-1sd": 136.8,
        "Median": 143.4,
        "1sd": 150,
        "2sd": 156.6,
        "3sd": 163.1
    },
    {
        "year": 10,
        "monthByYear": 10,
        "month": 130,
        "name": "10:10",
        "sd": 6.6075,
        "-3sd": 124.1,
        "-2sd": 130.7,
        "-1sd": 137.3,
        "Median": 143.9,
        "1sd": 150.5,
        "2sd": 157.1,
        "3sd": 163.7
    },
    {
        "year": 10,
        "monthByYear": 11,
        "month": 131,
        "name": "10:11",
        "sd": 6.6277,
        "-3sd": 124.6,
        "-2sd": 131.2,
        "-1sd": 137.8,
        "Median": 144.5,
        "1sd": 151.1,
        "2sd": 157.7,
        "3sd": 164.3
    },
    {
        "year": 11,
        "monthByYear": 0,
        "month": 132,
        "name": "11: 0",
        "sd": 6.6465,
        "-3sd": 125.1,
        "-2sd": 131.7,
        "-1sd": 138.3,
        "Median": 145,
        "1sd": 151.6,
        "2sd": 158.3,
        "3sd": 164.9
    },
    {
        "year": 11,
        "monthByYear": 1,
        "month": 133,
        "name": "11: 1",
        "sd": 6.6652,
        "-3sd": 125.5,
        "-2sd": 132.2,
        "-1sd": 138.9,
        "Median": 145.5,
        "1sd": 152.2,
        "2sd": 158.9,
        "3sd": 165.5
    },
    {
        "year": 11,
        "monthByYear": 2,
        "month": 134,
        "name": "11: 2",
        "sd": 6.6838,
        "-3sd": 126,
        "-2sd": 132.7,
        "-1sd": 139.4,
        "Median": 146.1,
        "1sd": 152.7,
        "2sd": 159.4,
        "3sd": 166.1
    },
    {
        "year": 11,
        "monthByYear": 3,
        "month": 135,
        "name": "11: 3",
        "sd": 6.7009,
        "-3sd": 126.5,
        "-2sd": 133.2,
        "-1sd": 139.9,
        "Median": 146.6,
        "1sd": 153.3,
        "2sd": 160,
        "3sd": 166.7
    },
    {
        "year": 11,
        "monthByYear": 4,
        "month": 136,
        "name": "11: 4",
        "sd": 6.7193,
        "-3sd": 127,
        "-2sd": 133.7,
        "-1sd": 140.4,
        "Median": 147.1,
        "1sd": 153.8,
        "2sd": 160.6,
        "3sd": 167.3
    },
    {
        "year": 11,
        "monthByYear": 5,
        "month": 137,
        "name": "11: 5",
        "sd": 6.736,
        "-3sd": 127.4,
        "-2sd": 134.2,
        "-1sd": 140.9,
        "Median": 147.7,
        "1sd": 154.4,
        "2sd": 161.1,
        "3sd": 167.9
    },
    {
        "year": 11,
        "monthByYear": 6,
        "month": 138,
        "name": "11: 6",
        "sd": 6.7526,
        "-3sd": 127.9,
        "-2sd": 134.7,
        "-1sd": 141.4,
        "Median": 148.2,
        "1sd": 154.9,
        "2sd": 161.7,
        "3sd": 168.4
    },
    {
        "year": 11,
        "monthByYear": 7,
        "month": 139,
        "name": "11: 7",
        "sd": 6.7689,
        "-3sd": 128.4,
        "-2sd": 135.2,
        "-1sd": 141.9,
        "Median": 148.7,
        "1sd": 155.5,
        "2sd": 162.2,
        "3sd": 169
    },
    {
        "year": 11,
        "monthByYear": 8,
        "month": 140,
        "name": "11: 8",
        "sd": 6.7835,
        "-3sd": 128.9,
        "-2sd": 135.7,
        "-1sd": 142.4,
        "Median": 149.2,
        "1sd": 156,
        "2sd": 162.8,
        "3sd": 169.6
    },
    {
        "year": 11,
        "monthByYear": 9,
        "month": 141,
        "name": "11: 9",
        "sd": 6.7993,
        "-3sd": 129.3,
        "-2sd": 136.1,
        "-1sd": 142.9,
        "Median": 149.7,
        "1sd": 156.5,
        "2sd": 163.3,
        "3sd": 170.1
    },
    {
        "year": 11,
        "monthByYear": 10,
        "month": 142,
        "name": "11:10",
        "sd": 6.8133,
        "-3sd": 129.8,
        "-2sd": 136.6,
        "-1sd": 143.4,
        "Median": 150.2,
        "1sd": 157.1,
        "2sd": 163.9,
        "3sd": 170.7
    },
    {
        "year": 11,
        "monthByYear": 11,
        "month": 143,
        "name": "11:11",
        "sd": 6.827,
        "-3sd": 130.3,
        "-2sd": 137.1,
        "-1sd": 143.9,
        "Median": 150.7,
        "1sd": 157.6,
        "2sd": 164.4,
        "3sd": 171.2
    },
    {
        "year": 12,
        "monthByYear": 0,
        "month": 144,
        "name": "12: 0",
        "sd": 6.8403,
        "-3sd": 130.7,
        "-2sd": 137.6,
        "-1sd": 144.4,
        "Median": 151.2,
        "1sd": 158.1,
        "2sd": 164.9,
        "3sd": 171.8
    },
    {
        "year": 12,
        "monthByYear": 1,
        "month": 145,
        "name": "12: 1",
        "sd": 6.8516,
        "-3sd": 131.2,
        "-2sd": 138,
        "-1sd": 144.9,
        "Median": 151.7,
        "1sd": 158.6,
        "2sd": 165.4,
        "3sd": 172.3
    },
    {
        "year": 12,
        "monthByYear": 2,
        "month": 146,
        "name": "12: 2",
        "sd": 6.864,
        "-3sd": 131.6,
        "-2sd": 138.5,
        "-1sd": 145.3,
        "Median": 152.2,
        "1sd": 159.1,
        "2sd": 165.9,
        "3sd": 172.8
    },
    {
        "year": 12,
        "monthByYear": 3,
        "month": 147,
        "name": "12: 3",
        "sd": 6.8744,
        "-3sd": 132,
        "-2sd": 138.9,
        "-1sd": 145.8,
        "Median": 152.7,
        "1sd": 159.5,
        "2sd": 166.4,
        "3sd": 173.3
    },
    {
        "year": 12,
        "monthByYear": 4,
        "month": 148,
        "name": "12: 4",
        "sd": 6.8858,
        "-3sd": 132.5,
        "-2sd": 139.3,
        "-1sd": 146.2,
        "Median": 153.1,
        "1sd": 160,
        "2sd": 166.9,
        "3sd": 173.8
    },
    {
        "year": 12,
        "monthByYear": 5,
        "month": 149,
        "name": "12: 5",
        "sd": 6.8952,
        "-3sd": 132.9,
        "-2sd": 139.8,
        "-1sd": 146.7,
        "Median": 153.6,
        "1sd": 160.5,
        "2sd": 167.4,
        "3sd": 174.3
    },
    {
        "year": 12,
        "monthByYear": 6,
        "month": 150,
        "name": "12: 6",
        "sd": 6.904,
        "-3sd": 133.3,
        "-2sd": 140.2,
        "-1sd": 147.1,
        "Median": 154,
        "1sd": 160.9,
        "2sd": 167.8,
        "3sd": 174.7
    },
    {
        "year": 12,
        "monthByYear": 7,
        "month": 151,
        "name": "12: 7",
        "sd": 6.9122,
        "-3sd": 133.7,
        "-2sd": 140.6,
        "-1sd": 147.5,
        "Median": 154.4,
        "1sd": 161.3,
        "2sd": 168.3,
        "3sd": 175.2
    },
    {
        "year": 12,
        "monthByYear": 8,
        "month": 152,
        "name": "12: 8",
        "sd": 6.9184,
        "-3sd": 134.1,
        "-2sd": 141,
        "-1sd": 147.9,
        "Median": 154.8,
        "1sd": 161.8,
        "2sd": 168.7,
        "3sd": 175.6
    },
    {
        "year": 12,
        "monthByYear": 9,
        "month": 153,
        "name": "12: 9",
        "sd": 6.9254,
        "-3sd": 134.5,
        "-2sd": 141.4,
        "-1sd": 148.3,
        "Median": 155.2,
        "1sd": 162.2,
        "2sd": 169.1,
        "3sd": 176
    },
    {
        "year": 12,
        "monthByYear": 10,
        "month": 154,
        "name": "12:10",
        "sd": 6.9319,
        "-3sd": 134.8,
        "-2sd": 141.8,
        "-1sd": 148.7,
        "Median": 155.6,
        "1sd": 162.6,
        "2sd": 169.5,
        "3sd": 176.4
    },
    {
        "year": 12,
        "monthByYear": 11,
        "month": 155,
        "name": "12:11",
        "sd": 6.9362,
        "-3sd": 135.2,
        "-2sd": 142.1,
        "-1sd": 149.1,
        "Median": 156,
        "1sd": 162.9,
        "2sd": 169.9,
        "3sd": 176.8
    },
    {
        "year": 13,
        "monthByYear": 0,
        "month": 156,
        "name": "13: 0",
        "sd": 6.9415,
        "-3sd": 135.6,
        "-2sd": 142.5,
        "-1sd": 149.4,
        "Median": 156.4,
        "1sd": 163.3,
        "2sd": 170.3,
        "3sd": 177.2
    },
    {
        "year": 13,
        "monthByYear": 1,
        "month": 157,
        "name": "13: 1",
        "sd": 6.9446,
        "-3sd": 135.9,
        "-2sd": 142.8,
        "-1sd": 149.8,
        "Median": 156.7,
        "1sd": 163.7,
        "2sd": 170.6,
        "3sd": 177.6
    },
    {
        "year": 13,
        "monthByYear": 2,
        "month": 158,
        "name": "13: 2",
        "sd": 6.9471,
        "-3sd": 136.2,
        "-2sd": 143.2,
        "-1sd": 150.1,
        "Median": 157.1,
        "1sd": 164,
        "2sd": 171,
        "3sd": 177.9
    },
    {
        "year": 13,
        "monthByYear": 3,
        "month": 159,
        "name": "13: 3",
        "sd": 6.9489,
        "-3sd": 136.5,
        "-2sd": 143.5,
        "-1sd": 150.4,
        "Median": 157.4,
        "1sd": 164.3,
        "2sd": 171.3,
        "3sd": 178.2
    },
    {
        "year": 13,
        "monthByYear": 4,
        "month": 160,
        "name": "13: 4",
        "sd": 6.9518,
        "-3sd": 136.9,
        "-2sd": 143.8,
        "-1sd": 150.8,
        "Median": 157.7,
        "1sd": 164.7,
        "2sd": 171.6,
        "3sd": 178.6
    },
    {
        "year": 13,
        "monthByYear": 5,
        "month": 161,
        "name": "13: 5",
        "sd": 6.9524,
        "-3sd": 137.2,
        "-2sd": 144.1,
        "-1sd": 151.1,
        "Median": 158,
        "1sd": 165,
        "2sd": 171.9,
        "3sd": 178.9
    },
    {
        "year": 13,
        "monthByYear": 6,
        "month": 162,
        "name": "13: 6",
        "sd": 6.9525,
        "-3sd": 137.4,
        "-2sd": 144.4,
        "-1sd": 151.3,
        "Median": 158.3,
        "1sd": 165.3,
        "2sd": 172.2,
        "3sd": 179.2
    },
    {
        "year": 13,
        "monthByYear": 7,
        "month": 163,
        "name": "13: 7",
        "sd": 6.952,
        "-3sd": 137.7,
        "-2sd": 144.7,
        "-1sd": 151.6,
        "Median": 158.6,
        "1sd": 165.5,
        "2sd": 172.5,
        "3sd": 179.4
    },
    {
        "year": 13,
        "monthByYear": 8,
        "month": 164,
        "name": "13: 8",
        "sd": 6.9509,
        "-3sd": 138,
        "-2sd": 144.9,
        "-1sd": 151.9,
        "Median": 158.8,
        "1sd": 165.8,
        "2sd": 172.7,
        "3sd": 179.7
    },
    {
        "year": 13,
        "monthByYear": 9,
        "month": 165,
        "name": "13: 9",
        "sd": 6.9509,
        "-3sd": 138.2,
        "-2sd": 145.2,
        "-1sd": 152.1,
        "Median": 159.1,
        "1sd": 166,
        "2sd": 173,
        "3sd": 179.9
    },
    {
        "year": 13,
        "monthByYear": 10,
        "month": 166,
        "name": "13:10",
        "sd": 6.9487,
        "-3sd": 138.5,
        "-2sd": 145.4,
        "-1sd": 152.4,
        "Median": 159.3,
        "1sd": 166.3,
        "2sd": 173.2,
        "3sd": 180.2
    },
    {
        "year": 13,
        "monthByYear": 11,
        "month": 167,
        "name": "13:11",
        "sd": 6.946,
        "-3sd": 138.7,
        "-2sd": 145.7,
        "-1sd": 152.6,
        "Median": 159.6,
        "1sd": 166.5,
        "2sd": 173.5,
        "3sd": 180.4
    },
    {
        "year": 14,
        "monthByYear": 0,
        "month": 168,
        "name": "14: 0",
        "sd": 6.9428,
        "-3sd": 139,
        "-2sd": 145.9,
        "-1sd": 152.8,
        "Median": 159.8,
        "1sd": 166.7,
        "2sd": 173.7,
        "3sd": 180.6
    },
    {
        "year": 14,
        "monthByYear": 1,
        "month": 169,
        "name": "14: 1",
        "sd": 6.9391,
        "-3sd": 139.2,
        "-2sd": 146.1,
        "-1sd": 153.1,
        "Median": 160,
        "1sd": 166.9,
        "2sd": 173.9,
        "3sd": 180.8
    },
    {
        "year": 14,
        "monthByYear": 2,
        "month": 170,
        "name": "14: 2",
        "sd": 6.9365,
        "-3sd": 139.4,
        "-2sd": 146.3,
        "-1sd": 153.3,
        "Median": 160.2,
        "1sd": 167.1,
        "2sd": 174.1,
        "3sd": 181
    },
    {
        "year": 14,
        "monthByYear": 3,
        "month": 171,
        "name": "14: 3",
        "sd": 6.9319,
        "-3sd": 139.6,
        "-2sd": 146.5,
        "-1sd": 153.5,
        "Median": 160.4,
        "1sd": 167.3,
        "2sd": 174.2,
        "3sd": 181.2
    },
    {
        "year": 14,
        "monthByYear": 4,
        "month": 172,
        "name": "14: 4",
        "sd": 6.9267,
        "-3sd": 139.8,
        "-2sd": 146.7,
        "-1sd": 153.6,
        "Median": 160.6,
        "1sd": 167.5,
        "2sd": 174.4,
        "3sd": 181.3
    },
    {
        "year": 14,
        "monthByYear": 5,
        "month": 173,
        "name": "14: 5",
        "sd": 6.9228,
        "-3sd": 140,
        "-2sd": 146.9,
        "-1sd": 153.8,
        "Median": 160.7,
        "1sd": 167.7,
        "2sd": 174.6,
        "3sd": 181.5
    },
    {
        "year": 14,
        "monthByYear": 6,
        "month": 174,
        "name": "14: 6",
        "sd": 6.9168,
        "-3sd": 140.1,
        "-2sd": 147.1,
        "-1sd": 154,
        "Median": 160.9,
        "1sd": 167.8,
        "2sd": 174.7,
        "3sd": 181.6
    },
    {
        "year": 14,
        "monthByYear": 7,
        "month": 175,
        "name": "14: 7",
        "sd": 6.912,
        "-3sd": 140.3,
        "-2sd": 147.2,
        "-1sd": 154.1,
        "Median": 161,
        "1sd": 168,
        "2sd": 174.9,
        "3sd": 181.8
    },
    {
        "year": 14,
        "monthByYear": 8,
        "month": 176,
        "name": "14: 8",
        "sd": 6.9051,
        "-3sd": 140.5,
        "-2sd": 147.4,
        "-1sd": 154.3,
        "Median": 161.2,
        "1sd": 168.1,
        "2sd": 175,
        "3sd": 181.9
    },
    {
        "year": 14,
        "monthByYear": 9,
        "month": 177,
        "name": "14: 9",
        "sd": 6.8996,
        "-3sd": 140.6,
        "-2sd": 147.5,
        "-1sd": 154.4,
        "Median": 161.3,
        "1sd": 168.2,
        "2sd": 175.1,
        "3sd": 182
    },
    {
        "year": 14,
        "monthByYear": 10,
        "month": 178,
        "name": "14:10",
        "sd": 6.8936,
        "-3sd": 140.8,
        "-2sd": 147.7,
        "-1sd": 154.5,
        "Median": 161.4,
        "1sd": 168.3,
        "2sd": 175.2,
        "3sd": 182.1
    },
    {
        "year": 14,
        "monthByYear": 11,
        "month": 179,
        "name": "14:11",
        "sd": 6.8873,
        "-3sd": 140.9,
        "-2sd": 147.8,
        "-1sd": 154.7,
        "Median": 161.6,
        "1sd": 168.4,
        "2sd": 175.3,
        "3sd": 182.2
    },
    {
        "year": 15,
        "monthByYear": 0,
        "month": 180,
        "name": "15: 0",
        "sd": 6.879,
        "-3sd": 141,
        "-2sd": 147.9,
        "-1sd": 154.8,
        "Median": 161.7,
        "1sd": 168.5,
        "2sd": 175.4,
        "3sd": 182.3
    },
    {
        "year": 15,
        "monthByYear": 1,
        "month": 181,
        "name": "15: 1",
        "sd": 6.8721,
        "-3sd": 141.2,
        "-2sd": 148,
        "-1sd": 154.9,
        "Median": 161.8,
        "1sd": 168.6,
        "2sd": 175.5,
        "3sd": 182.4
    },
    {
        "year": 15,
        "monthByYear": 2,
        "month": 182,
        "name": "15: 2",
        "sd": 6.8648,
        "-3sd": 141.3,
        "-2sd": 148.1,
        "-1sd": 155,
        "Median": 161.9,
        "1sd": 168.7,
        "2sd": 175.6,
        "3sd": 182.5
    },
    {
        "year": 15,
        "monthByYear": 3,
        "month": 183,
        "name": "15: 3",
        "sd": 6.8589,
        "-3sd": 141.4,
        "-2sd": 148.2,
        "-1sd": 155.1,
        "Median": 162,
        "1sd": 168.8,
        "2sd": 175.7,
        "3sd": 182.5
    },
    {
        "year": 15,
        "monthByYear": 4,
        "month": 184,
        "name": "15: 4",
        "sd": 6.851,
        "-3sd": 141.5,
        "-2sd": 148.3,
        "-1sd": 155.2,
        "Median": 162,
        "1sd": 168.9,
        "2sd": 175.7,
        "3sd": 182.6
    },
    {
        "year": 15,
        "monthByYear": 5,
        "month": 185,
        "name": "15: 5",
        "sd": 6.8429,
        "-3sd": 141.6,
        "-2sd": 148.4,
        "-1sd": 155.3,
        "Median": 162.1,
        "1sd": 169,
        "2sd": 175.8,
        "3sd": 182.6
    },
    {
        "year": 15,
        "monthByYear": 6,
        "month": 186,
        "name": "15: 6",
        "sd": 6.8346,
        "-3sd": 141.7,
        "-2sd": 148.5,
        "-1sd": 155.4,
        "Median": 162.2,
        "1sd": 169,
        "2sd": 175.9,
        "3sd": 182.7
    },
    {
        "year": 15,
        "monthByYear": 7,
        "month": 187,
        "name": "15: 7",
        "sd": 6.8277,
        "-3sd": 141.8,
        "-2sd": 148.6,
        "-1sd": 155.4,
        "Median": 162.3,
        "1sd": 169.1,
        "2sd": 175.9,
        "3sd": 182.7
    },
    {
        "year": 15,
        "monthByYear": 8,
        "month": 188,
        "name": "15: 8",
        "sd": 6.8189,
        "-3sd": 141.9,
        "-2sd": 148.7,
        "-1sd": 155.5,
        "Median": 162.3,
        "1sd": 169.1,
        "2sd": 176,
        "3sd": 182.8
    },
    {
        "year": 15,
        "monthByYear": 9,
        "month": 189,
        "name": "15: 9",
        "sd": 6.8115,
        "-3sd": 141.9,
        "-2sd": 148.7,
        "-1sd": 155.6,
        "Median": 162.4,
        "1sd": 169.2,
        "2sd": 176,
        "3sd": 182.8
    },
    {
        "year": 15,
        "monthByYear": 10,
        "month": 190,
        "name": "15:10",
        "sd": 6.8039,
        "-3sd": 142,
        "-2sd": 148.8,
        "-1sd": 155.6,
        "Median": 162.4,
        "1sd": 169.2,
        "2sd": 176,
        "3sd": 182.8
    },
    {
        "year": 15,
        "monthByYear": 11,
        "month": 191,
        "name": "15:11",
        "sd": 6.7946,
        "-3sd": 142.1,
        "-2sd": 148.9,
        "-1sd": 155.7,
        "Median": 162.5,
        "1sd": 169.3,
        "2sd": 176.1,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 0,
        "month": 192,
        "name": "16: 0",
        "sd": 6.7867,
        "-3sd": 142.2,
        "-2sd": 148.9,
        "-1sd": 155.7,
        "Median": 162.5,
        "1sd": 169.3,
        "2sd": 176.1,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 1,
        "month": 193,
        "name": "16: 1",
        "sd": 6.7786,
        "-3sd": 142.2,
        "-2sd": 149,
        "-1sd": 155.8,
        "Median": 162.6,
        "1sd": 169.3,
        "2sd": 176.1,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 2,
        "month": 194,
        "name": "16: 2",
        "sd": 6.7704,
        "-3sd": 142.3,
        "-2sd": 149.1,
        "-1sd": 155.8,
        "Median": 162.6,
        "1sd": 169.4,
        "2sd": 176.1,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 3,
        "month": 195,
        "name": "16: 3",
        "sd": 6.7621,
        "-3sd": 142.3,
        "-2sd": 149.1,
        "-1sd": 155.9,
        "Median": 162.6,
        "1sd": 169.4,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 4,
        "month": 196,
        "name": "16: 4",
        "sd": 6.7536,
        "-3sd": 142.4,
        "-2sd": 149.2,
        "-1sd": 155.9,
        "Median": 162.7,
        "1sd": 169.4,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 5,
        "month": 197,
        "name": "16: 5",
        "sd": 6.7467,
        "-3sd": 142.4,
        "-2sd": 149.2,
        "-1sd": 155.9,
        "Median": 162.7,
        "1sd": 169.4,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 6,
        "month": 198,
        "name": "16: 6",
        "sd": 6.7381,
        "-3sd": 142.5,
        "-2sd": 149.2,
        "-1sd": 156,
        "Median": 162.7,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 7,
        "month": 199,
        "name": "16: 7",
        "sd": 6.731,
        "-3sd": 142.5,
        "-2sd": 149.3,
        "-1sd": 156,
        "Median": 162.7,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 8,
        "month": 200,
        "name": "16: 8",
        "sd": 6.7223,
        "-3sd": 142.6,
        "-2sd": 149.3,
        "-1sd": 156,
        "Median": 162.8,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 9,
        "month": 201,
        "name": "16: 9",
        "sd": 6.7151,
        "-3sd": 142.6,
        "-2sd": 149.4,
        "-1sd": 156.1,
        "Median": 162.8,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 10,
        "month": 202,
        "name": "16:10",
        "sd": 6.7063,
        "-3sd": 142.7,
        "-2sd": 149.4,
        "-1sd": 156.1,
        "Median": 162.8,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 16,
        "monthByYear": 11,
        "month": 203,
        "name": "16:11",
        "sd": 6.699,
        "-3sd": 142.7,
        "-2sd": 149.4,
        "-1sd": 156.1,
        "Median": 162.8,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 0,
        "month": 204,
        "name": "17: 0",
        "sd": 6.6917,
        "-3sd": 142.8,
        "-2sd": 149.5,
        "-1sd": 156.2,
        "Median": 162.9,
        "1sd": 169.5,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 1,
        "month": 205,
        "name": "17: 1",
        "sd": 6.6844,
        "-3sd": 142.8,
        "-2sd": 149.5,
        "-1sd": 156.2,
        "Median": 162.9,
        "1sd": 169.6,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 2,
        "month": 206,
        "name": "17: 2",
        "sd": 6.677,
        "-3sd": 142.9,
        "-2sd": 149.5,
        "-1sd": 156.2,
        "Median": 162.9,
        "1sd": 169.6,
        "2sd": 176.2,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 3,
        "month": 207,
        "name": "17: 3",
        "sd": 6.6696,
        "-3sd": 142.9,
        "-2sd": 149.6,
        "-1sd": 156.2,
        "Median": 162.9,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 4,
        "month": 208,
        "name": "17: 4",
        "sd": 6.6622,
        "-3sd": 142.9,
        "-2sd": 149.6,
        "-1sd": 156.3,
        "Median": 162.9,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 5,
        "month": 209,
        "name": "17: 5",
        "sd": 6.6548,
        "-3sd": 143,
        "-2sd": 149.6,
        "-1sd": 156.3,
        "Median": 162.9,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 6,
        "month": 210,
        "name": "17: 6",
        "sd": 6.649,
        "-3sd": 143,
        "-2sd": 149.7,
        "-1sd": 156.3,
        "Median": 163,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 7,
        "month": 211,
        "name": "17: 7",
        "sd": 6.6415,
        "-3sd": 143.1,
        "-2sd": 149.7,
        "-1sd": 156.3,
        "Median": 163,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 8,
        "month": 212,
        "name": "17: 8",
        "sd": 6.6357,
        "-3sd": 143.1,
        "-2sd": 149.7,
        "-1sd": 156.4,
        "Median": 163,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 9,
        "month": 213,
        "name": "17: 9",
        "sd": 6.6282,
        "-3sd": 143.1,
        "-2sd": 149.8,
        "-1sd": 156.4,
        "Median": 163,
        "1sd": 169.6,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 10,
        "month": 214,
        "name": "17:10",
        "sd": 6.6223,
        "-3sd": 143.2,
        "-2sd": 149.8,
        "-1sd": 156.4,
        "Median": 163,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 17,
        "monthByYear": 11,
        "month": 215,
        "name": "17:11",
        "sd": 6.6164,
        "-3sd": 143.2,
        "-2sd": 149.8,
        "-1sd": 156.4,
        "Median": 163,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 0,
        "month": 216,
        "name": "18: 0",
        "sd": 6.6088,
        "-3sd": 143.2,
        "-2sd": 149.8,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 1,
        "month": 217,
        "name": "18: 1",
        "sd": 6.6028,
        "-3sd": 143.3,
        "-2sd": 149.9,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 2,
        "month": 218,
        "name": "18: 2",
        "sd": 6.5968,
        "-3sd": 143.3,
        "-2sd": 149.9,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 3,
        "month": 219,
        "name": "18: 3",
        "sd": 6.5908,
        "-3sd": 143.3,
        "-2sd": 149.9,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 4,
        "month": 220,
        "name": "18: 4",
        "sd": 6.5847,
        "-3sd": 143.4,
        "-2sd": 149.9,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 5,
        "month": 221,
        "name": "18: 5",
        "sd": 6.5802,
        "-3sd": 143.4,
        "-2sd": 150,
        "-1sd": 156.5,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 6,
        "month": 222,
        "name": "18: 6",
        "sd": 6.5741,
        "-3sd": 143.4,
        "-2sd": 150,
        "-1sd": 156.6,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.9
    },
    {
        "year": 18,
        "monthByYear": 7,
        "month": 223,
        "name": "18: 7",
        "sd": 6.5678,
        "-3sd": 143.4,
        "-2sd": 150,
        "-1sd": 156.6,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.8
    },
    {
        "year": 18,
        "monthByYear": 8,
        "month": 224,
        "name": "18: 8",
        "sd": 6.5632,
        "-3sd": 143.5,
        "-2sd": 150,
        "-1sd": 156.6,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.8
    },
    {
        "year": 18,
        "monthByYear": 9,
        "month": 225,
        "name": "18: 9",
        "sd": 6.5569,
        "-3sd": 143.5,
        "-2sd": 150,
        "-1sd": 156.6,
        "Median": 163.1,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.8
    },
    {
        "year": 18,
        "monthByYear": 10,
        "month": 226,
        "name": "18:10",
        "sd": 6.5521,
        "-3sd": 143.5,
        "-2sd": 150,
        "-1sd": 156.6,
        "Median": 163.2,
        "1sd": 169.7,
        "2sd": 176.3,
        "3sd": 182.8
    },
    {
        "year": 18,
        "monthByYear": 11,
        "month": 227,
        "name": "18:11",
        "sd": 6.5457,
        "-3sd": 143.5,
        "-2sd": 150.1,
        "-1sd": 156.6,
        "Median": 163.2,
        "1sd": 169.7,
        "2sd": 176.2,
        "3sd": 182.8
    },
    {
        "year": 19,
        "monthByYear": 0,
        "month": 228,
        "name": "19: 0",
        "sd": 6.5409,
        "-3sd": 143.5,
        "-2sd": 150.1,
        "-1sd": 156.6,
        "Median": 163.2,
        "1sd": 169.7,
        "2sd": 176.2,
        "3sd": 182.8
    }
]

export const BMI_FEMALE_5_19 = [
    {
        "year": 5,
        "monthByYear": 1,
        "month": 61,
        "name": "5: 1",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 18.9,
        "3sd": 21.3
    },
    {
        "year": 5,
        "monthByYear": 2,
        "month": 62,
        "name": "5: 2",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 18.9,
        "3sd": 21.4
    },
    {
        "year": 5,
        "monthByYear": 3,
        "month": 63,
        "name": "5: 3",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 18.9,
        "3sd": 21.5
    },
    {
        "year": 5,
        "monthByYear": 4,
        "month": 64,
        "name": "5: 4",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 18.9,
        "3sd": 21.5
    },
    {
        "year": 5,
        "monthByYear": 5,
        "month": 65,
        "name": "5: 5",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 19,
        "3sd": 21.6
    },
    {
        "year": 5,
        "monthByYear": 6,
        "month": 66,
        "name": "5: 6",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 19,
        "3sd": 21.7
    },
    {
        "year": 5,
        "monthByYear": 7,
        "month": 67,
        "name": "5: 7",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.2,
        "1sd": 16.9,
        "2sd": 19,
        "3sd": 21.7
    },
    {
        "year": 5,
        "monthByYear": 8,
        "month": 68,
        "name": "5: 8",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.1,
        "3sd": 21.8
    },
    {
        "year": 5,
        "monthByYear": 9,
        "month": 69,
        "name": "5: 9",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.1,
        "3sd": 21.9
    },
    {
        "year": 5,
        "monthByYear": 10,
        "month": 70,
        "name": "5:10",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.1,
        "3sd": 22
    },
    {
        "year": 5,
        "monthByYear": 11,
        "month": 71,
        "name": "5:11",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.2,
        "3sd": 22.1
    },
    {
        "year": 6,
        "monthByYear": 0,
        "month": 72,
        "name": "6: 0",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.2,
        "3sd": 22.1
    },
    {
        "year": 6,
        "monthByYear": 1,
        "month": 73,
        "name": "6: 1",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.3,
        "3sd": 22.2
    },
    {
        "year": 6,
        "monthByYear": 2,
        "month": 74,
        "name": "6: 2",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17,
        "2sd": 19.3,
        "3sd": 22.3
    },
    {
        "year": 6,
        "monthByYear": 3,
        "month": 75,
        "name": "6: 3",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.1,
        "2sd": 19.3,
        "3sd": 22.4
    },
    {
        "year": 6,
        "monthByYear": 4,
        "month": 76,
        "name": "6: 4",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.1,
        "2sd": 19.4,
        "3sd": 22.5
    },
    {
        "year": 6,
        "monthByYear": 5,
        "month": 77,
        "name": "6: 5",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.1,
        "2sd": 19.4,
        "3sd": 22.6
    },
    {
        "year": 6,
        "monthByYear": 6,
        "month": 78,
        "name": "6: 6",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.1,
        "2sd": 19.5,
        "3sd": 22.7
    },
    {
        "year": 6,
        "monthByYear": 7,
        "month": 79,
        "name": "6: 7",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.2,
        "2sd": 19.5,
        "3sd": 22.8
    },
    {
        "year": 6,
        "monthByYear": 8,
        "month": 80,
        "name": "6: 8",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.3,
        "1sd": 17.2,
        "2sd": 19.6,
        "3sd": 22.9
    },
    {
        "year": 6,
        "monthByYear": 9,
        "month": 81,
        "name": "6: 9",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.4,
        "1sd": 17.2,
        "2sd": 19.6,
        "3sd": 23
    },
    {
        "year": 6,
        "monthByYear": 10,
        "month": 82,
        "name": "6:10",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.4,
        "1sd": 17.2,
        "2sd": 19.7,
        "3sd": 23.1
    },
    {
        "year": 6,
        "monthByYear": 11,
        "month": 83,
        "name": "6:11",
        "-3sd": 11.7,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.4,
        "1sd": 17.3,
        "2sd": 19.7,
        "3sd": 23.2
    },
    {
        "year": 7,
        "monthByYear": 0,
        "month": 84,
        "name": "7: 0",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.4,
        "1sd": 17.3,
        "2sd": 19.8,
        "3sd": 23.3
    },
    {
        "year": 7,
        "monthByYear": 1,
        "month": 85,
        "name": "7: 1",
        "-3sd": 11.8,
        "-2sd": 12.7,
        "-1sd": 13.9,
        "Median": 15.4,
        "1sd": 17.3,
        "2sd": 19.8,
        "3sd": 23.4
    },
    {
        "year": 7,
        "monthByYear": 2,
        "month": 86,
        "name": "7: 2",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.4,
        "1sd": 17.4,
        "2sd": 19.9,
        "3sd": 23.5
    },
    {
        "year": 7,
        "monthByYear": 3,
        "month": 87,
        "name": "7: 3",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.5,
        "1sd": 17.4,
        "2sd": 20,
        "3sd": 23.6
    },
    {
        "year": 7,
        "monthByYear": 4,
        "month": 88,
        "name": "7: 4",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.5,
        "1sd": 17.4,
        "2sd": 20,
        "3sd": 23.7
    },
    {
        "year": 7,
        "monthByYear": 5,
        "month": 89,
        "name": "7: 5",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.5,
        "1sd": 17.5,
        "2sd": 20.1,
        "3sd": 23.9
    },
    {
        "year": 7,
        "monthByYear": 6,
        "month": 90,
        "name": "7: 6",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.5,
        "1sd": 17.5,
        "2sd": 20.1,
        "3sd": 24
    },
    {
        "year": 7,
        "monthByYear": 7,
        "month": 91,
        "name": "7: 7",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.5,
        "1sd": 17.5,
        "2sd": 20.2,
        "3sd": 24.1
    },
    {
        "year": 7,
        "monthByYear": 8,
        "month": 92,
        "name": "7: 8",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14,
        "Median": 15.6,
        "1sd": 17.6,
        "2sd": 20.3,
        "3sd": 24.2
    },
    {
        "year": 7,
        "monthByYear": 9,
        "month": 93,
        "name": "7: 9",
        "-3sd": 11.8,
        "-2sd": 12.8,
        "-1sd": 14.1,
        "Median": 15.6,
        "1sd": 17.6,
        "2sd": 20.3,
        "3sd": 24.4
    },
    {
        "year": 7,
        "monthByYear": 10,
        "month": 94,
        "name": "7:10",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.1,
        "Median": 15.6,
        "1sd": 17.6,
        "2sd": 20.4,
        "3sd": 24.5
    },
    {
        "year": 7,
        "monthByYear": 11,
        "month": 95,
        "name": "7:11",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.1,
        "Median": 15.7,
        "1sd": 17.7,
        "2sd": 20.5,
        "3sd": 24.6
    },
    {
        "year": 8,
        "monthByYear": 0,
        "month": 96,
        "name": "8: 0",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.1,
        "Median": 15.7,
        "1sd": 17.7,
        "2sd": 20.6,
        "3sd": 24.8
    },
    {
        "year": 8,
        "monthByYear": 1,
        "month": 97,
        "name": "8: 1",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.1,
        "Median": 15.7,
        "1sd": 17.8,
        "2sd": 20.6,
        "3sd": 24.9
    },
    {
        "year": 8,
        "monthByYear": 2,
        "month": 98,
        "name": "8: 2",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.2,
        "Median": 15.7,
        "1sd": 17.8,
        "2sd": 20.7,
        "3sd": 25.1
    },
    {
        "year": 8,
        "monthByYear": 3,
        "month": 99,
        "name": "8: 3",
        "-3sd": 11.9,
        "-2sd": 12.9,
        "-1sd": 14.2,
        "Median": 15.8,
        "1sd": 17.9,
        "2sd": 20.8,
        "3sd": 25.2
    },
    {
        "year": 8,
        "monthByYear": 4,
        "month": 100,
        "name": "8: 4",
        "-3sd": 11.9,
        "-2sd": 13,
        "-1sd": 14.2,
        "Median": 15.8,
        "1sd": 17.9,
        "2sd": 20.9,
        "3sd": 25.3
    },
    {
        "year": 8,
        "monthByYear": 5,
        "month": 101,
        "name": "8: 5",
        "-3sd": 12,
        "-2sd": 13,
        "-1sd": 14.2,
        "Median": 15.8,
        "1sd": 18,
        "2sd": 20.9,
        "3sd": 25.5
    },
    {
        "year": 8,
        "monthByYear": 6,
        "month": 102,
        "name": "8: 6",
        "-3sd": 12,
        "-2sd": 13,
        "-1sd": 14.3,
        "Median": 15.9,
        "1sd": 18,
        "2sd": 21,
        "3sd": 25.6
    },
    {
        "year": 8,
        "monthByYear": 7,
        "month": 103,
        "name": "8: 7",
        "-3sd": 12,
        "-2sd": 13,
        "-1sd": 14.3,
        "Median": 15.9,
        "1sd": 18.1,
        "2sd": 21.1,
        "3sd": 25.8
    },
    {
        "year": 8,
        "monthByYear": 8,
        "month": 104,
        "name": "8: 8",
        "-3sd": 12,
        "-2sd": 13,
        "-1sd": 14.3,
        "Median": 15.9,
        "1sd": 18.1,
        "2sd": 21.2,
        "3sd": 25.9
    },
    {
        "year": 8,
        "monthByYear": 9,
        "month": 105,
        "name": "8: 9",
        "-3sd": 12,
        "-2sd": 13.1,
        "-1sd": 14.3,
        "Median": 16,
        "1sd": 18.2,
        "2sd": 21.3,
        "3sd": 26.1
    },
    {
        "year": 8,
        "monthByYear": 10,
        "month": 106,
        "name": "8:10",
        "-3sd": 12.1,
        "-2sd": 13.1,
        "-1sd": 14.4,
        "Median": 16,
        "1sd": 18.2,
        "2sd": 21.3,
        "3sd": 26.2
    },
    {
        "year": 8,
        "monthByYear": 11,
        "month": 107,
        "name": "8:11",
        "-3sd": 12.1,
        "-2sd": 13.1,
        "-1sd": 14.4,
        "Median": 16.1,
        "1sd": 18.3,
        "2sd": 21.4,
        "3sd": 26.4
    },
    {
        "year": 9,
        "monthByYear": 0,
        "month": 108,
        "name": "9: 0",
        "-3sd": 12.1,
        "-2sd": 13.1,
        "-1sd": 14.4,
        "Median": 16.1,
        "1sd": 18.3,
        "2sd": 21.5,
        "3sd": 26.5
    },
    {
        "year": 9,
        "monthByYear": 1,
        "month": 109,
        "name": "9: 1",
        "-3sd": 12.1,
        "-2sd": 13.2,
        "-1sd": 14.5,
        "Median": 16.1,
        "1sd": 18.4,
        "2sd": 21.6,
        "3sd": 26.7
    },
    {
        "year": 9,
        "monthByYear": 2,
        "month": 110,
        "name": "9: 2",
        "-3sd": 12.1,
        "-2sd": 13.2,
        "-1sd": 14.5,
        "Median": 16.2,
        "1sd": 18.4,
        "2sd": 21.7,
        "3sd": 26.8
    },
    {
        "year": 9,
        "monthByYear": 3,
        "month": 111,
        "name": "9: 3",
        "-3sd": 12.2,
        "-2sd": 13.2,
        "-1sd": 14.5,
        "Median": 16.2,
        "1sd": 18.5,
        "2sd": 21.8,
        "3sd": 27
    },
    {
        "year": 9,
        "monthByYear": 4,
        "month": 112,
        "name": "9: 4",
        "-3sd": 12.2,
        "-2sd": 13.2,
        "-1sd": 14.6,
        "Median": 16.3,
        "1sd": 18.6,
        "2sd": 21.9,
        "3sd": 27.2
    },
    {
        "year": 9,
        "monthByYear": 5,
        "month": 113,
        "name": "9: 5",
        "-3sd": 12.2,
        "-2sd": 13.3,
        "-1sd": 14.6,
        "Median": 16.3,
        "1sd": 18.6,
        "2sd": 21.9,
        "3sd": 27.3
    },
    {
        "year": 9,
        "monthByYear": 6,
        "month": 114,
        "name": "9: 6",
        "-3sd": 12.2,
        "-2sd": 13.3,
        "-1sd": 14.6,
        "Median": 16.3,
        "1sd": 18.7,
        "2sd": 22,
        "3sd": 27.5
    },
    {
        "year": 9,
        "monthByYear": 7,
        "month": 115,
        "name": "9: 7",
        "-3sd": 12.3,
        "-2sd": 13.3,
        "-1sd": 14.7,
        "Median": 16.4,
        "1sd": 18.7,
        "2sd": 22.1,
        "3sd": 27.6
    },
    {
        "year": 9,
        "monthByYear": 8,
        "month": 116,
        "name": "9: 8",
        "-3sd": 12.3,
        "-2sd": 13.4,
        "-1sd": 14.7,
        "Median": 16.4,
        "1sd": 18.8,
        "2sd": 22.2,
        "3sd": 27.8
    },
    {
        "year": 9,
        "monthByYear": 9,
        "month": 117,
        "name": "9: 9",
        "-3sd": 12.3,
        "-2sd": 13.4,
        "-1sd": 14.7,
        "Median": 16.5,
        "1sd": 18.8,
        "2sd": 22.3,
        "3sd": 27.9
    },
    {
        "year": 9,
        "monthByYear": 10,
        "month": 118,
        "name": "9:10",
        "-3sd": 12.3,
        "-2sd": 13.4,
        "-1sd": 14.8,
        "Median": 16.5,
        "1sd": 18.9,
        "2sd": 22.4,
        "3sd": 28.1
    },
    {
        "year": 9,
        "monthByYear": 11,
        "month": 119,
        "name": "9:11",
        "-3sd": 12.4,
        "-2sd": 13.4,
        "-1sd": 14.8,
        "Median": 16.6,
        "1sd": 19,
        "2sd": 22.5,
        "3sd": 28.2
    },
    {
        "year": 10,
        "monthByYear": 0,
        "month": 120,
        "name": "10: 0",
        "-3sd": 12.4,
        "-2sd": 13.5,
        "-1sd": 14.8,
        "Median": 16.6,
        "1sd": 19,
        "2sd": 22.6,
        "3sd": 28.4
    },
    {
        "year": 10,
        "monthByYear": 1,
        "month": 121,
        "name": "10: 1",
        "-3sd": 12.4,
        "-2sd": 13.5,
        "-1sd": 14.9,
        "Median": 16.7,
        "1sd": 19.1,
        "2sd": 22.7,
        "3sd": 28.5
    },
    {
        "year": 10,
        "monthByYear": 2,
        "month": 122,
        "name": "10: 2",
        "-3sd": 12.4,
        "-2sd": 13.5,
        "-1sd": 14.9,
        "Median": 16.7,
        "1sd": 19.2,
        "2sd": 22.8,
        "3sd": 28.7
    },
    {
        "year": 10,
        "monthByYear": 3,
        "month": 123,
        "name": "10: 3",
        "-3sd": 12.5,
        "-2sd": 13.6,
        "-1sd": 15,
        "Median": 16.8,
        "1sd": 19.2,
        "2sd": 22.8,
        "3sd": 28.8
    },
    {
        "year": 10,
        "monthByYear": 4,
        "month": 124,
        "name": "10: 4",
        "-3sd": 12.5,
        "-2sd": 13.6,
        "-1sd": 15,
        "Median": 16.8,
        "1sd": 19.3,
        "2sd": 22.9,
        "3sd": 29
    },
    {
        "year": 10,
        "monthByYear": 5,
        "month": 125,
        "name": "10: 5",
        "-3sd": 12.5,
        "-2sd": 13.6,
        "-1sd": 15,
        "Median": 16.9,
        "1sd": 19.4,
        "2sd": 23,
        "3sd": 29.1
    },
    {
        "year": 10,
        "monthByYear": 6,
        "month": 126,
        "name": "10: 6",
        "-3sd": 12.5,
        "-2sd": 13.7,
        "-1sd": 15.1,
        "Median": 16.9,
        "1sd": 19.4,
        "2sd": 23.1,
        "3sd": 29.3
    },
    {
        "year": 10,
        "monthByYear": 7,
        "month": 127,
        "name": "10: 7",
        "-3sd": 12.6,
        "-2sd": 13.7,
        "-1sd": 15.1,
        "Median": 17,
        "1sd": 19.5,
        "2sd": 23.2,
        "3sd": 29.4
    },
    {
        "year": 10,
        "monthByYear": 8,
        "month": 128,
        "name": "10: 8",
        "-3sd": 12.6,
        "-2sd": 13.7,
        "-1sd": 15.2,
        "Median": 17,
        "1sd": 19.6,
        "2sd": 23.3,
        "3sd": 29.6
    },
    {
        "year": 10,
        "monthByYear": 9,
        "month": 129,
        "name": "10: 9",
        "-3sd": 12.6,
        "-2sd": 13.8,
        "-1sd": 15.2,
        "Median": 17.1,
        "1sd": 19.6,
        "2sd": 23.4,
        "3sd": 29.7
    },
    {
        "year": 10,
        "monthByYear": 10,
        "month": 130,
        "name": "10:10",
        "-3sd": 12.7,
        "-2sd": 13.8,
        "-1sd": 15.3,
        "Median": 17.1,
        "1sd": 19.7,
        "2sd": 23.5,
        "3sd": 29.9
    },
    {
        "year": 10,
        "monthByYear": 11,
        "month": 131,
        "name": "10:11",
        "-3sd": 12.7,
        "-2sd": 13.8,
        "-1sd": 15.3,
        "Median": 17.2,
        "1sd": 19.8,
        "2sd": 23.6,
        "3sd": 30
    },
    {
        "year": 11,
        "monthByYear": 0,
        "month": 132,
        "name": "11: 0",
        "-3sd": 12.7,
        "-2sd": 13.9,
        "-1sd": 15.3,
        "Median": 17.2,
        "1sd": 19.9,
        "2sd": 23.7,
        "3sd": 30.2
    },
    {
        "year": 11,
        "monthByYear": 1,
        "month": 133,
        "name": "11: 1",
        "-3sd": 12.8,
        "-2sd": 13.9,
        "-1sd": 15.4,
        "Median": 17.3,
        "1sd": 19.9,
        "2sd": 23.8,
        "3sd": 30.3
    },
    {
        "year": 11,
        "monthByYear": 2,
        "month": 134,
        "name": "11: 2",
        "-3sd": 12.8,
        "-2sd": 14,
        "-1sd": 15.4,
        "Median": 17.4,
        "1sd": 20,
        "2sd": 23.9,
        "3sd": 30.5
    },
    {
        "year": 11,
        "monthByYear": 3,
        "month": 135,
        "name": "11: 3",
        "-3sd": 12.8,
        "-2sd": 14,
        "-1sd": 15.5,
        "Median": 17.4,
        "1sd": 20.1,
        "2sd": 24,
        "3sd": 30.6
    },
    {
        "year": 11,
        "monthByYear": 4,
        "month": 136,
        "name": "11: 4",
        "-3sd": 12.9,
        "-2sd": 14,
        "-1sd": 15.5,
        "Median": 17.5,
        "1sd": 20.2,
        "2sd": 24.1,
        "3sd": 30.8
    },
    {
        "year": 11,
        "monthByYear": 5,
        "month": 137,
        "name": "11: 5",
        "-3sd": 12.9,
        "-2sd": 14.1,
        "-1sd": 15.6,
        "Median": 17.5,
        "1sd": 20.2,
        "2sd": 24.2,
        "3sd": 30.9
    },
    {
        "year": 11,
        "monthByYear": 6,
        "month": 138,
        "name": "11: 6",
        "-3sd": 12.9,
        "-2sd": 14.1,
        "-1sd": 15.6,
        "Median": 17.6,
        "1sd": 20.3,
        "2sd": 24.3,
        "3sd": 31.1
    },
    {
        "year": 11,
        "monthByYear": 7,
        "month": 139,
        "name": "11: 7",
        "-3sd": 13,
        "-2sd": 14.2,
        "-1sd": 15.7,
        "Median": 17.7,
        "1sd": 20.4,
        "2sd": 24.4,
        "3sd": 31.2
    },
    {
        "year": 11,
        "monthByYear": 8,
        "month": 140,
        "name": "11: 8",
        "-3sd": 13,
        "-2sd": 14.2,
        "-1sd": 15.7,
        "Median": 17.7,
        "1sd": 20.5,
        "2sd": 24.5,
        "3sd": 31.4
    },
    {
        "year": 11,
        "monthByYear": 9,
        "month": 141,
        "name": "11: 9",
        "-3sd": 13,
        "-2sd": 14.3,
        "-1sd": 15.8,
        "Median": 17.8,
        "1sd": 20.6,
        "2sd": 24.7,
        "3sd": 31.5
    },
    {
        "year": 11,
        "monthByYear": 10,
        "month": 142,
        "name": "11:10",
        "-3sd": 13.1,
        "-2sd": 14.3,
        "-1sd": 15.8,
        "Median": 17.9,
        "1sd": 20.6,
        "2sd": 24.8,
        "3sd": 31.6
    },
    {
        "year": 11,
        "monthByYear": 11,
        "month": 143,
        "name": "11:11",
        "-3sd": 13.1,
        "-2sd": 14.3,
        "-1sd": 15.9,
        "Median": 17.9,
        "1sd": 20.7,
        "2sd": 24.9,
        "3sd": 31.8
    },
    {
        "year": 12,
        "monthByYear": 0,
        "month": 144,
        "name": "12: 0",
        "-3sd": 13.2,
        "-2sd": 14.4,
        "-1sd": 16,
        "Median": 18,
        "1sd": 20.8,
        "2sd": 25,
        "3sd": 31.9
    },
    {
        "year": 12,
        "monthByYear": 1,
        "month": 145,
        "name": "12: 1",
        "-3sd": 13.2,
        "-2sd": 14.4,
        "-1sd": 16,
        "Median": 18.1,
        "1sd": 20.9,
        "2sd": 25.1,
        "3sd": 32
    },
    {
        "year": 12,
        "monthByYear": 2,
        "month": 146,
        "name": "12: 2",
        "-3sd": 13.2,
        "-2sd": 14.5,
        "-1sd": 16.1,
        "Median": 18.1,
        "1sd": 21,
        "2sd": 25.2,
        "3sd": 32.2
    },
    {
        "year": 12,
        "monthByYear": 3,
        "month": 147,
        "name": "12: 3",
        "-3sd": 13.3,
        "-2sd": 14.5,
        "-1sd": 16.1,
        "Median": 18.2,
        "1sd": 21.1,
        "2sd": 25.3,
        "3sd": 32.3
    },
    {
        "year": 12,
        "monthByYear": 4,
        "month": 148,
        "name": "12: 4",
        "-3sd": 13.3,
        "-2sd": 14.6,
        "-1sd": 16.2,
        "Median": 18.3,
        "1sd": 21.1,
        "2sd": 25.4,
        "3sd": 32.4
    },
    {
        "year": 12,
        "monthByYear": 5,
        "month": 149,
        "name": "12: 5",
        "-3sd": 13.3,
        "-2sd": 14.6,
        "-1sd": 16.2,
        "Median": 18.3,
        "1sd": 21.2,
        "2sd": 25.5,
        "3sd": 32.6
    },
    {
        "year": 12,
        "monthByYear": 6,
        "month": 150,
        "name": "12: 6",
        "-3sd": 13.4,
        "-2sd": 14.7,
        "-1sd": 16.3,
        "Median": 18.4,
        "1sd": 21.3,
        "2sd": 25.6,
        "3sd": 32.7
    },
    {
        "year": 12,
        "monthByYear": 7,
        "month": 151,
        "name": "12: 7",
        "-3sd": 13.4,
        "-2sd": 14.7,
        "-1sd": 16.3,
        "Median": 18.5,
        "1sd": 21.4,
        "2sd": 25.7,
        "3sd": 32.8
    },
    {
        "year": 12,
        "monthByYear": 8,
        "month": 152,
        "name": "12: 8",
        "-3sd": 13.5,
        "-2sd": 14.8,
        "-1sd": 16.4,
        "Median": 18.5,
        "1sd": 21.5,
        "2sd": 25.8,
        "3sd": 33
    },
    {
        "year": 12,
        "monthByYear": 9,
        "month": 153,
        "name": "12: 9",
        "-3sd": 13.5,
        "-2sd": 14.8,
        "-1sd": 16.4,
        "Median": 18.6,
        "1sd": 21.6,
        "2sd": 25.9,
        "3sd": 33.1
    },
    {
        "year": 12,
        "monthByYear": 10,
        "month": 154,
        "name": "12:10",
        "-3sd": 13.5,
        "-2sd": 14.8,
        "-1sd": 16.5,
        "Median": 18.7,
        "1sd": 21.6,
        "2sd": 26,
        "3sd": 33.2
    },
    {
        "year": 12,
        "monthByYear": 11,
        "month": 155,
        "name": "12:11",
        "-3sd": 13.6,
        "-2sd": 14.9,
        "-1sd": 16.6,
        "Median": 18.7,
        "1sd": 21.7,
        "2sd": 26.1,
        "3sd": 33.3
    },
    {
        "year": 13,
        "monthByYear": 0,
        "month": 156,
        "name": "13: 0",
        "-3sd": 13.6,
        "-2sd": 14.9,
        "-1sd": 16.6,
        "Median": 18.8,
        "1sd": 21.8,
        "2sd": 26.2,
        "3sd": 33.4
    },
    {
        "year": 13,
        "monthByYear": 1,
        "month": 157,
        "name": "13: 1",
        "-3sd": 13.6,
        "-2sd": 15,
        "-1sd": 16.7,
        "Median": 18.9,
        "1sd": 21.9,
        "2sd": 26.3,
        "3sd": 33.6
    },
    {
        "year": 13,
        "monthByYear": 2,
        "month": 158,
        "name": "13: 2",
        "-3sd": 13.7,
        "-2sd": 15,
        "-1sd": 16.7,
        "Median": 18.9,
        "1sd": 22,
        "2sd": 26.4,
        "3sd": 33.7
    },
    {
        "year": 13,
        "monthByYear": 3,
        "month": 159,
        "name": "13: 3",
        "-3sd": 13.7,
        "-2sd": 15.1,
        "-1sd": 16.8,
        "Median": 19,
        "1sd": 22,
        "2sd": 26.5,
        "3sd": 33.8
    },
    {
        "year": 13,
        "monthByYear": 4,
        "month": 160,
        "name": "13: 4",
        "-3sd": 13.8,
        "-2sd": 15.1,
        "-1sd": 16.8,
        "Median": 19.1,
        "1sd": 22.1,
        "2sd": 26.6,
        "3sd": 33.9
    },
    {
        "year": 13,
        "monthByYear": 5,
        "month": 161,
        "name": "13: 5",
        "-3sd": 13.8,
        "-2sd": 15.2,
        "-1sd": 16.9,
        "Median": 19.1,
        "1sd": 22.2,
        "2sd": 26.7,
        "3sd": 34
    },
    {
        "year": 13,
        "monthByYear": 6,
        "month": 162,
        "name": "13: 6",
        "-3sd": 13.8,
        "-2sd": 15.2,
        "-1sd": 16.9,
        "Median": 19.2,
        "1sd": 22.3,
        "2sd": 26.8,
        "3sd": 34.1
    },
    {
        "year": 13,
        "monthByYear": 7,
        "month": 163,
        "name": "13: 7",
        "-3sd": 13.9,
        "-2sd": 15.2,
        "-1sd": 17,
        "Median": 19.3,
        "1sd": 22.4,
        "2sd": 26.9,
        "3sd": 34.2
    },
    {
        "year": 13,
        "monthByYear": 8,
        "month": 164,
        "name": "13: 8",
        "-3sd": 13.9,
        "-2sd": 15.3,
        "-1sd": 17,
        "Median": 19.3,
        "1sd": 22.4,
        "2sd": 27,
        "3sd": 34.3
    },
    {
        "year": 13,
        "monthByYear": 9,
        "month": 165,
        "name": "13: 9",
        "-3sd": 13.9,
        "-2sd": 15.3,
        "-1sd": 17.1,
        "Median": 19.4,
        "1sd": 22.5,
        "2sd": 27.1,
        "3sd": 34.4
    },
    {
        "year": 13,
        "monthByYear": 10,
        "month": 166,
        "name": "13:10",
        "-3sd": 14,
        "-2sd": 15.4,
        "-1sd": 17.1,
        "Median": 19.4,
        "1sd": 22.6,
        "2sd": 27.1,
        "3sd": 34.5
    },
    {
        "year": 13,
        "monthByYear": 11,
        "month": 167,
        "name": "13:11",
        "-3sd": 14,
        "-2sd": 15.4,
        "-1sd": 17.2,
        "Median": 19.5,
        "1sd": 22.7,
        "2sd": 27.2,
        "3sd": 34.6
    },
    {
        "year": 14,
        "monthByYear": 0,
        "month": 168,
        "name": "14: 0",
        "-3sd": 14,
        "-2sd": 15.4,
        "-1sd": 17.2,
        "Median": 19.6,
        "1sd": 22.7,
        "2sd": 27.3,
        "3sd": 34.7
    },
    {
        "year": 14,
        "monthByYear": 1,
        "month": 169,
        "name": "14: 1",
        "-3sd": 14.1,
        "-2sd": 15.5,
        "-1sd": 17.3,
        "Median": 19.6,
        "1sd": 22.8,
        "2sd": 27.4,
        "3sd": 34.7
    },
    {
        "year": 14,
        "monthByYear": 2,
        "month": 170,
        "name": "14: 2",
        "-3sd": 14.1,
        "-2sd": 15.5,
        "-1sd": 17.3,
        "Median": 19.7,
        "1sd": 22.9,
        "2sd": 27.5,
        "3sd": 34.8
    },
    {
        "year": 14,
        "monthByYear": 3,
        "month": 171,
        "name": "14: 3",
        "-3sd": 14.1,
        "-2sd": 15.6,
        "-1sd": 17.4,
        "Median": 19.7,
        "1sd": 22.9,
        "2sd": 27.6,
        "3sd": 34.9
    },
    {
        "year": 14,
        "monthByYear": 4,
        "month": 172,
        "name": "14: 4",
        "-3sd": 14.1,
        "-2sd": 15.6,
        "-1sd": 17.4,
        "Median": 19.8,
        "1sd": 23,
        "2sd": 27.7,
        "3sd": 35
    },
    {
        "year": 14,
        "monthByYear": 5,
        "month": 173,
        "name": "14: 5",
        "-3sd": 14.2,
        "-2sd": 15.6,
        "-1sd": 17.5,
        "Median": 19.9,
        "1sd": 23.1,
        "2sd": 27.7,
        "3sd": 35.1
    },
    {
        "year": 14,
        "monthByYear": 6,
        "month": 174,
        "name": "14: 6",
        "-3sd": 14.2,
        "-2sd": 15.7,
        "-1sd": 17.5,
        "Median": 19.9,
        "1sd": 23.1,
        "2sd": 27.8,
        "3sd": 35.1
    },
    {
        "year": 14,
        "monthByYear": 7,
        "month": 175,
        "name": "14: 7",
        "-3sd": 14.2,
        "-2sd": 15.7,
        "-1sd": 17.6,
        "Median": 20,
        "1sd": 23.2,
        "2sd": 27.9,
        "3sd": 35.2
    },
    {
        "year": 14,
        "monthByYear": 8,
        "month": 176,
        "name": "14: 8",
        "-3sd": 14.3,
        "-2sd": 15.7,
        "-1sd": 17.6,
        "Median": 20,
        "1sd": 23.3,
        "2sd": 28,
        "3sd": 35.3
    },
    {
        "year": 14,
        "monthByYear": 9,
        "month": 177,
        "name": "14: 9",
        "-3sd": 14.3,
        "-2sd": 15.8,
        "-1sd": 17.6,
        "Median": 20.1,
        "1sd": 23.3,
        "2sd": 28,
        "3sd": 35.4
    },
    {
        "year": 14,
        "monthByYear": 10,
        "month": 178,
        "name": "14:10",
        "-3sd": 14.3,
        "-2sd": 15.8,
        "-1sd": 17.7,
        "Median": 20.1,
        "1sd": 23.4,
        "2sd": 28.1,
        "3sd": 35.4
    },
    {
        "year": 14,
        "monthByYear": 11,
        "month": 179,
        "name": "14:11",
        "-3sd": 14.3,
        "-2sd": 15.8,
        "-1sd": 17.7,
        "Median": 20.2,
        "1sd": 23.5,
        "2sd": 28.2,
        "3sd": 35.5
    },
    {
        "year": 15,
        "monthByYear": 0,
        "month": 180,
        "name": "15: 0",
        "-3sd": 14.4,
        "-2sd": 15.9,
        "-1sd": 17.8,
        "Median": 20.2,
        "1sd": 23.5,
        "2sd": 28.2,
        "3sd": 35.5
    },
    {
        "year": 15,
        "monthByYear": 1,
        "month": 181,
        "name": "15: 1",
        "-3sd": 14.4,
        "-2sd": 15.9,
        "-1sd": 17.8,
        "Median": 20.3,
        "1sd": 23.6,
        "2sd": 28.3,
        "3sd": 35.6
    },
    {
        "year": 15,
        "monthByYear": 2,
        "month": 182,
        "name": "15: 2",
        "-3sd": 14.4,
        "-2sd": 15.9,
        "-1sd": 17.8,
        "Median": 20.3,
        "1sd": 23.6,
        "2sd": 28.4,
        "3sd": 35.7
    },
    {
        "year": 15,
        "monthByYear": 3,
        "month": 183,
        "name": "15: 3",
        "-3sd": 14.4,
        "-2sd": 16,
        "-1sd": 17.9,
        "Median": 20.4,
        "1sd": 23.7,
        "2sd": 28.4,
        "3sd": 35.7
    },
    {
        "year": 15,
        "monthByYear": 4,
        "month": 184,
        "name": "15: 4",
        "-3sd": 14.5,
        "-2sd": 16,
        "-1sd": 17.9,
        "Median": 20.4,
        "1sd": 23.7,
        "2sd": 28.5,
        "3sd": 35.8
    },
    {
        "year": 15,
        "monthByYear": 5,
        "month": 185,
        "name": "15: 5",
        "-3sd": 14.5,
        "-2sd": 16,
        "-1sd": 17.9,
        "Median": 20.4,
        "1sd": 23.8,
        "2sd": 28.5,
        "3sd": 35.8
    },
    {
        "year": 15,
        "monthByYear": 6,
        "month": 186,
        "name": "15: 6",
        "-3sd": 14.5,
        "-2sd": 16,
        "-1sd": 18,
        "Median": 20.5,
        "1sd": 23.8,
        "2sd": 28.6,
        "3sd": 35.8
    },
    {
        "year": 15,
        "monthByYear": 7,
        "month": 187,
        "name": "15: 7",
        "-3sd": 14.5,
        "-2sd": 16.1,
        "-1sd": 18,
        "Median": 20.5,
        "1sd": 23.9,
        "2sd": 28.6,
        "3sd": 35.9
    },
    {
        "year": 15,
        "monthByYear": 8,
        "month": 188,
        "name": "15: 8",
        "-3sd": 14.5,
        "-2sd": 16.1,
        "-1sd": 18,
        "Median": 20.6,
        "1sd": 23.9,
        "2sd": 28.7,
        "3sd": 35.9
    },
    {
        "year": 15,
        "monthByYear": 9,
        "month": 189,
        "name": "15: 9",
        "-3sd": 14.5,
        "-2sd": 16.1,
        "-1sd": 18.1,
        "Median": 20.6,
        "1sd": 24,
        "2sd": 28.7,
        "3sd": 36
    },
    {
        "year": 15,
        "monthByYear": 10,
        "month": 190,
        "name": "15:10",
        "-3sd": 14.6,
        "-2sd": 16.1,
        "-1sd": 18.1,
        "Median": 20.6,
        "1sd": 24,
        "2sd": 28.8,
        "3sd": 36
    },
    {
        "year": 15,
        "monthByYear": 11,
        "month": 191,
        "name": "15:11",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.1,
        "Median": 20.7,
        "1sd": 24.1,
        "2sd": 28.8,
        "3sd": 36
    },
    {
        "year": 16,
        "monthByYear": 0,
        "month": 192,
        "name": "16: 0",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.2,
        "Median": 20.7,
        "1sd": 24.1,
        "2sd": 28.9,
        "3sd": 36.1
    },
    {
        "year": 16,
        "monthByYear": 1,
        "month": 193,
        "name": "16: 1",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.2,
        "Median": 20.7,
        "1sd": 24.1,
        "2sd": 28.9,
        "3sd": 36.1
    },
    {
        "year": 16,
        "monthByYear": 2,
        "month": 194,
        "name": "16: 2",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.2,
        "Median": 20.8,
        "1sd": 24.2,
        "2sd": 29,
        "3sd": 36.1
    },
    {
        "year": 16,
        "monthByYear": 3,
        "month": 195,
        "name": "16: 3",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.2,
        "Median": 20.8,
        "1sd": 24.2,
        "2sd": 29,
        "3sd": 36.1
    },
    {
        "year": 16,
        "monthByYear": 4,
        "month": 196,
        "name": "16: 4",
        "-3sd": 14.6,
        "-2sd": 16.2,
        "-1sd": 18.3,
        "Median": 20.8,
        "1sd": 24.3,
        "2sd": 29,
        "3sd": 36.2
    },
    {
        "year": 16,
        "monthByYear": 5,
        "month": 197,
        "name": "16: 5",
        "-3sd": 14.6,
        "-2sd": 16.3,
        "-1sd": 18.3,
        "Median": 20.9,
        "1sd": 24.3,
        "2sd": 29.1,
        "3sd": 36.2
    },
    {
        "year": 16,
        "monthByYear": 6,
        "month": 198,
        "name": "16: 6",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.3,
        "Median": 20.9,
        "1sd": 24.3,
        "2sd": 29.1,
        "3sd": 36.2
    },
    {
        "year": 16,
        "monthByYear": 7,
        "month": 199,
        "name": "16: 7",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.3,
        "Median": 20.9,
        "1sd": 24.4,
        "2sd": 29.1,
        "3sd": 36.2
    },
    {
        "year": 16,
        "monthByYear": 8,
        "month": 200,
        "name": "16: 8",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.3,
        "Median": 20.9,
        "1sd": 24.4,
        "2sd": 29.2,
        "3sd": 36.2
    },
    {
        "year": 16,
        "monthByYear": 9,
        "month": 201,
        "name": "16: 9",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.4,
        "Median": 21,
        "1sd": 24.4,
        "2sd": 29.2,
        "3sd": 36.3
    },
    {
        "year": 16,
        "monthByYear": 10,
        "month": 202,
        "name": "16:10",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.4,
        "Median": 21,
        "1sd": 24.4,
        "2sd": 29.2,
        "3sd": 36.3
    },
    {
        "year": 16,
        "monthByYear": 11,
        "month": 203,
        "name": "16:11",
        "-3sd": 14.7,
        "-2sd": 16.3,
        "-1sd": 18.4,
        "Median": 21,
        "1sd": 24.5,
        "2sd": 29.3,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 0,
        "month": 204,
        "name": "17: 0",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.4,
        "Median": 21,
        "1sd": 24.5,
        "2sd": 29.3,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 1,
        "month": 205,
        "name": "17: 1",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.4,
        "Median": 21.1,
        "1sd": 24.5,
        "2sd": 29.3,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 2,
        "month": 206,
        "name": "17: 2",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.4,
        "Median": 21.1,
        "1sd": 24.6,
        "2sd": 29.3,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 3,
        "month": 207,
        "name": "17: 3",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.1,
        "1sd": 24.6,
        "2sd": 29.4,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 4,
        "month": 208,
        "name": "17: 4",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.1,
        "1sd": 24.6,
        "2sd": 29.4,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 5,
        "month": 209,
        "name": "17: 5",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.1,
        "1sd": 24.6,
        "2sd": 29.4,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 6,
        "month": 210,
        "name": "17: 6",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.2,
        "1sd": 24.6,
        "2sd": 29.4,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 7,
        "month": 211,
        "name": "17: 7",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.2,
        "1sd": 24.7,
        "2sd": 29.4,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 8,
        "month": 212,
        "name": "17: 8",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.2,
        "1sd": 24.7,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 9,
        "month": 213,
        "name": "17: 9",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.2,
        "1sd": 24.7,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 10,
        "month": 214,
        "name": "17:10",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.5,
        "Median": 21.2,
        "1sd": 24.7,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 17,
        "monthByYear": 11,
        "month": 215,
        "name": "17:11",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.6,
        "Median": 21.2,
        "1sd": 24.8,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 0,
        "month": 216,
        "name": "18: 0",
        "-3sd": 14.7,
        "-2sd": 16.4,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.8,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 1,
        "month": 217,
        "name": "18: 1",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.8,
        "2sd": 29.5,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 2,
        "month": 218,
        "name": "18: 2",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.8,
        "2sd": 29.6,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 3,
        "month": 219,
        "name": "18: 3",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.8,
        "2sd": 29.6,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 4,
        "month": 220,
        "name": "18: 4",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.8,
        "2sd": 29.6,
        "3sd": 36.3
    },
    {
        "year": 18,
        "monthByYear": 5,
        "month": 221,
        "name": "18: 5",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 6,
        "month": 222,
        "name": "18: 6",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.3,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 7,
        "month": 223,
        "name": "18: 7",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.4,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 8,
        "month": 224,
        "name": "18: 8",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.6,
        "Median": 21.4,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 9,
        "month": 225,
        "name": "18: 9",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.7,
        "Median": 21.4,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 10,
        "month": 226,
        "name": "18:10",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.7,
        "Median": 21.4,
        "1sd": 24.9,
        "2sd": 29.6,
        "3sd": 36.2
    },
    {
        "year": 18,
        "monthByYear": 11,
        "month": 227,
        "name": "18:11",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.7,
        "Median": 21.4,
        "1sd": 25,
        "2sd": 29.7,
        "3sd": 36.2
    },
    {
        "year": 19,
        "monthByYear": 0,
        "month": 228,
        "name": "19: 0",
        "-3sd": 14.7,
        "-2sd": 16.5,
        "-1sd": 18.7,
        "Median": 21.4,
        "1sd": 25,
        "2sd": 29.7,
        "3sd": 36.2
    }
]